// src/components/property-listing/property-listing.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingAdaptExAnalyticsEventFragment on LodgingAdaptExAnalyticsEvent {\n    campaignId\n    clientSideAnalytics {\n      referrerId\n      eventType\n      linkName\n    }\n    events {\n      eventType\n      eventTarget\n      banditDisplayed\n      payloadId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AdaptexCampaignTrackingDetailFragment on AdaptexCampaignTrackingDetail {\n    campaignId\n    eventTarget\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PriceSummaryFragment on PropertyPrice {\n    displayMessages {\n      lineItems {\n        ...PriceMessageFragment\n        ...EnrichedMessageFragment\n      }\n    }\n    options {\n      leadingCaption\n      displayPrice {\n        formatted\n      }\n      disclaimer {\n        value\n      }\n      priceDisclaimer {\n        content\n        primaryButton {\n          text\n        }\n        trigger {\n          icon {\n            description\n          }\n        }\n      }\n      accessibilityLabel\n      strikeOut {\n        formatted\n      }\n      loyaltyPrice {\n        unit\n        amount {\n          formatted\n        }\n        totalStrikeOutPoints {\n          formatted\n        }\n      }\n    }\n    priceMessaging {\n      value\n      theme\n    }\n  }\n\n  fragment PriceMessageFragment on DisplayPrice {\n    __typename\n    role\n    price {\n      formatted\n      accessibilityLabel\n    }\n    disclaimer {\n      content\n      primaryUIButton {\n        accessibility\n        primary\n      }\n    }\n  }\n\n  fragment EnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    value\n    state\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingBadgeFragment on EGDSStandardBadge {\n    text\n    theme\n    graphic {\n      __typename\n      ... on Icon {\n        description\n        id\n      }\n      ... on Mark {\n        description\n        id\n      }\n    }\n    size\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSParagraphFragment on EGDSParagraph {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n    size\n    decorative\n    accessibility\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSTextFragment on EGDSText {\n    ... on EGDSParagraph {\n      ...LodgingEGDSParagraphFragment\n    }\n    ... on EGDSStylizedText {\n      ...EGDSStylizedTextFragment\n    }\n    ... on EGDSPlainText {\n      __typename\n      text\n    }\n    ... on EGDSInlineLink {\n      ...LodgingEGDSInlineLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSHeadingFragment on EGDSHeading {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ... on Icon {\n        id\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...LodgingEGDSGraphicTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSLocalizedTextTemplateFragment on EGDSLocalizedTextTemplate {\n    __typename\n    template\n    token\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingStandardBadgeFragment on LodgingStandardBadge {\n    standardBadge {\n      text\n      theme\n      graphic {\n        __typename\n        ... on Icon {\n          description\n          id\n        }\n        ... on Mark {\n          description\n          id\n        }\n      }\n      size\n    }\n    impressionEventAnalytics {\n      referrerId\n      linkName\n      event\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingPriceSummaryFragment on Offer {\n    price {\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          trigger {\n            icon {\n              description\n            }\n          }\n        }\n        accessibilityLabel\n        strikeOut {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n      }\n      priceMessaging {\n        value\n        theme\n      }\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardCompareSectionFragment on LodgingCardCompareSection {\n    __typename\n    compareAction {\n      ... on EGDSBasicCheckBox {\n        __typename\n        label {\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardDateSectionFragment on LodgingCardDateSection {\n    date {\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSRatingFragment on EGDSRating {\n    accessibility\n    rating\n    ... on EGDSIconRating {\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardFeaturedMessageFragment on LodgingCardFeaturedMessage {\n    icon {\n      id\n      description\n      size\n    }\n    text\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingProductAmenityFragment on EGDSIconText {\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardHeadingSectionFragment on LodgingCardHeadingSection {\n    heading\n    productRating {\n      ...LodgingEGDSRatingFragment\n    }\n    featuredMessages {\n      ...LodgingCardFeaturedMessageFragment\n    }\n    messages {\n      ...LodgingEGDSTextFragment\n    }\n    amenities {\n      ...LodgingProductAmenityFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardMarketingFeeDetailFragment on MarketingFeeDetails {\n    tierMessage {\n      accessibilityLabel\n      value\n      egdsMark {\n        id\n      }\n    }\n    marketingFeeMessageDialog {\n      content\n      dialog {\n        footer {\n          buttons {\n            primary\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardMoreDetailsTriggerFragment on LodgingCardMoreDetailsTrigger {\n    accessibilityLabel\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    label\n  }\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardChangeUnitDialogActionFragment on LodgingCardChangeUnitDialogAction {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardChangeUnitSheetActionFragment on LodgingCardChangeUnitSheetAction {\n    sheet {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      closeText\n    }\n    trigger {\n      ...LodgingCardMoreDetailsTriggerFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardGuestRatingFragment on LodgingCardPhrase {\n    accessibilityLabel\n    phraseParts {\n      ...EGDSIconRatingFragment\n    }\n    parts {\n      text\n      ... on EGDSStylizedText {\n        ...EGDSStylizedTextFragment\n      }\n      ... on EGDSText {\n        ...LodgingEGDSTextFragment\n      }\n    }\n  }\n\n  fragment EGDSIconRatingFragment on EGDSIconRating {\n    rating\n    icon {\n      size\n      theme\n      token\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardMoreDetailsLinkTriggerFragment on LodgingCardMoreDetailsTrigger {\n    accessibilityLabel\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    label\n  }\n\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardPropertyDetailsDialogActionFragment on LodgingCardPropertyDetailsDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsLinkTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardUnitDetailsDialogActionFragment on LodgingCardUnitDetailsDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsLinkTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardPropertyDialogActionFragment on LodgingCardDetailsAction {\n    __typename\n    ... on LodgingCardUnitDetailsDialog {\n      ...LodgingCardUnitDetailsDialogActionFragment\n    }\n    ... on LodgingCardPropertyDetailsDialog {\n      ...LodgingCardPropertyDetailsDialogActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardPropertyDescriptionSectionFragment on LodgingCardPropertyDescriptionSection {\n    heading {\n      text\n    }\n    description {\n      text\n    }\n    # Link is used for tracking purposes on the client, do not remove\n    link {\n      action {\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingProductFooterMessagesFragment on EGDSTextWithMarkListItem {\n    mark {\n      description\n      id\n      url {\n        value\n      }\n    }\n    egdsElementId\n    style\n    text\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingProductSpannableFooterMessagesFragment on EarnMessageContainerListItem {\n    graphic {\n      ... on Mark {\n        description\n        id\n        token\n        url {\n          value\n          relativePath\n        }\n      }\n      ... on Icon {\n        description\n        id\n        size\n        theme\n        title\n      }\n      ... on Illustration {\n        id\n        description\n      }\n    }\n    style\n    text\n    stylizedText {\n      ...EGDSSpannableTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardProductSummarySectionFragment on LodgingCardProductSummarySection {\n    heading {\n      ...LodgingEGDSHeadingFragment\n    }\n    amenities {\n      ...LodgingProductAmenityFragment\n    }\n    messages {\n      ...LodgingEGDSTextFragment\n    }\n    descriptionSection {\n      ...LodgingCardPropertyDescriptionSectionFragment\n    }\n    changeActionDialog {\n      ...LodgingCardChangeUnitDialogActionFragment\n    }\n    changeActionSheet {\n      ...LodgingCardChangeUnitSheetActionFragment\n    }\n    detailsAction {\n      ...LodgingCardPropertyDialogActionFragment\n    }\n    guestRating {\n      ...LodgingCardGuestRatingFragment\n    }\n    footerMessages {\n      listItems {\n        ...LodgingProductFooterMessagesFragment\n        ...LodgingProductSpannableFooterMessagesFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardContentSectionFragment on LodgingCard {\n    __typename\n    headingSection {\n      ...LodgingCardHeadingSectionFragment\n    }\n    summarySections {\n      ...LodgingCardProductSummarySectionFragment\n    }\n    priceSection {\n      priceSummary {\n        ...PriceSummaryFragment\n        marketingFeeDetails {\n          ...LodgingCardMarketingFeeDetailFragment\n        }\n      }\n      badge {\n        ...LodgingBadgeFragment\n      }\n      standardBadge {\n        ...LodgingStandardBadgeFragment\n      }\n      button {\n        accessibility\n        action {\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n        disabled\n        icon {\n          description\n          id\n        }\n        primary\n        attemptEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        successEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        adaptexSuccessActionTracking {\n          ...AdaptexCampaignTrackingDetailFragment\n        }\n      }\n    }\n    compareSection {\n      ...LodgingCardCompareSectionFragment\n    }\n    dateSection {\n      ...LodgingCardDateSectionFragment\n    }\n    callOut {\n      ...LodgingEGDSTextFragment\n    }\n    id\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardLinkFragment on UILinkAction {\n    __typename\n    accessibility\n    resource {\n      __typename\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    useRelativePath\n    target\n  }\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardLinkActionFragment on LodgingCardLinkAction {\n    link {\n      text\n      action {\n        target\n        resource {\n          ... on HttpURI {\n            value\n            relativePath\n          }\n        }\n        useRelativePath\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSImageFragment on Image {\n    description\n    url\n    thumbnailClickAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingMediaItemFragment on LodgingMediaItem {\n    id\n    media {\n      ... on Image {\n        ...LodgingEGDSImageFragment\n      }\n    }\n    trackingId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingGalleryCarouselFragment on LodgingGalleryCarousel {\n    accessibilityHeadingText\n    navClickAnalytics {\n      referrerId\n      linkName\n    }\n    intersectionAnalytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    media {\n      ...LodgingMediaItemFragment\n    }\n    nextButtonText\n    previousButtonText\n  }\n\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveStayAttributesFragment\n      ...TripsSaveActivityAttributesFragment\n      ...TripsSaveFlightSearchAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    adaptexSuccessCampaignIds {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n    label\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardSaveItemFragment on LodgingSaveItem {\n    items {\n      itemId\n    }\n    labels {\n      saveLabel\n      removeLabel\n    }\n    messages {\n      saveMessage\n      removeMessage\n    }\n    initialChecked\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardMediaSectionFragment on LodgingCardMediaSection {\n    gallery {\n      ...LodgingGalleryCarouselFragment\n    }\n    saveItem {\n      ...LodgingCardSaveItemFragment\n    }\n    saveTripItem {\n      ...TripsSaveItemFragment\n    }\n    badges {\n      primaryBadge {\n        ...LodgingBadgeFragment\n      }\n      secondaryBadge {\n        ...LodgingBadgeFragment\n      }\n      tertiaryBadge {\n        ...LodgingBadgeFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingCardFragment on LodgingCard {\n    featuredHeader {\n      header {\n        text\n      }\n    }\n    cardLink {\n      ...LodgingCardLinkFragment\n    }\n    footerActions {\n      ...LodgingCardLinkActionFragment\n    }\n    mediaSection {\n      ...LodgingCardMediaSectionFragment\n    }\n    id\n    ...LodgingCardContentSectionFragment\n    clickstreamEvents {\n      productPresented {\n        ...ProductEventFragment\n      }\n      productSelected {\n        ...ProductEventFragment\n      }\n    }\n    impressionAnalytics {\n      url\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    adaptexSuccessActionTracking {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n  }\n\n  fragment ProductEventFragment on LodgingProductEvent {\n    event {\n      ...ClickstreamEventFragment\n    }\n    product_list {\n      ...ProductListFragment\n    }\n    search_request {\n      ...RequestFragment\n    }\n  }\n\n  fragment ClickstreamEventFragment on EGClickstreamEvent {\n    eventCategory\n    eventName\n    eventType\n    eventVersion\n  }\n\n  fragment ProductListFragment on LodgingProduct {\n    product_id\n  }\n\n  fragment RequestFragment on LodgingSearchRequest {\n    search_id\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingHeadingFragment on LodgingHeading {\n    __typename\n    value\n  }\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingIntentButtonFragment on UIPrimaryButton {\n    primary\n    action {\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingIntentCardFragment on LodgingIntentCard {\n    headingTitle\n    message\n    gallery {\n      media {\n        ...LodgingMediaItemFragment\n      }\n    }\n    primaryButton {\n      ...LodgingIntentButtonFragment\n    }\n    impressionTracking {\n      event\n      referrerId\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MessagingResultTitleMediaFragment on MessagingResultTitle {\n    icon {\n      id\n      description\n      size\n      spotLight\n    }\n    illustration {\n      assetUri {\n        value\n      }\n      description\n    }\n    egdsMark {\n      id\n      description\n      url {\n        ... on HttpURI {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MessageResultFragment on MessageResult {\n    title {\n      text\n      ...MessagingResultTitleMediaFragment\n    }\n    subtitle {\n      text\n      ...MessagingResultTitleMediaFragment\n    }\n    action {\n      primary {\n        ...MessageActionContent\n      }\n      secondary {\n        ...MessageActionContent\n      }\n    }\n    type\n    footerText\n  }\n  fragment MessageActionContent on MessagingAction {\n    text\n    linkUrl\n    referrerId\n    actionDetails {\n      action\n      accessibilityLabel\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SparkleBannerFragment on MessageResult {\n    __typename\n    title {\n      ...MessageTitleFields\n      ...MessagingResultTitleMediaFragment\n    }\n    subtitle {\n      ...MessageTitleFields\n    }\n    action {\n      primary {\n        ...MessagingActionFields\n      }\n      secondary {\n        ...MessagingActionFields\n      }\n    }\n    type\n  }\n  fragment MessageTitleFields on MessagingResultTitle {\n    text\n    icon {\n      description\n      id\n    }\n    illustration {\n      assetUri {\n        value\n      }\n      description\n    }\n  }\n  fragment MessagingActionFields on MessagingAction {\n    actionDetails {\n      action\n      accessibilityLabel\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    linkUrl\n    referrerId\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyListingExpandoCardFragment on PropertyListingsIconTextExpando {\n    graphic {\n      __typename\n      ... on Illustration {\n        url\n        description\n        id\n      }\n    }\n    expandoCard {\n      collapsedLabel\n      expandedLabel\n      expanded\n      subtitle\n      expandAnalytics {\n        linkName\n        referrerId\n      }\n      collapseAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    expandedContent {\n      text\n      graphic {\n        __typename\n        ... on Icon {\n          id\n          description\n          token\n          size\n          theme\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingEGDSRemovablePillFragment on EGDSBasicRemovablePill {\n    primary\n    accessibility\n    name\n    value\n    remove {\n      ... on Icon {\n        id\n        description\n        size\n      }\n    }\n    removeAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchFilterPillsFragment on PropertySearchListingsOverfilteredCard {\n    filterPills {\n      ... on BasicShoppingAppliedFilter {\n        filter {\n          ...LodgingEGDSRemovablePillFragment\n        }\n        linkUrl {\n          ... on UILinkAction {\n            resource {\n              ... on HttpURI {\n                value\n                relativePath\n              }\n            }\n            target\n            useRelativePath\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyListingOverfilteredFragment on PropertySearchListingsOverfilteredCard {\n    cardContent: content {\n      ... on EGDSStandardMessagingCard {\n        heading\n        message\n        graphic {\n          ... on Icon {\n            description\n            id\n            iconSize: size\n            withBackground\n          }\n        }\n      }\n    }\n    ...SearchFilterPillsFragment\n    action {\n      button {\n        ... on UISecondaryButton {\n          accessibility\n          disabled\n          primary\n          analytics {\n            ... on ClientSideAnalytics {\n              referrerId\n              linkName\n            }\n          }\n        }\n      }\n      action {\n        ... on UILinkAction {\n          resource {\n            ... on HttpURI {\n              value\n              relativePath\n            }\n          }\n          target\n          useRelativePath\n        }\n      }\n    }\n    impressionAnalytics {\n      ... on ClientSideImpressionEventAnalytics {\n        event\n        referrerId\n        linkName\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyListingSoldOutFragment on PropertySearchListingsSoldOutCard {\n    cardContent: content {\n      ... on EGDSStandardMessagingCard {\n        heading\n        graphic {\n          ... on Icon {\n            description\n            id\n            iconSize: size\n            theme\n            title\n            withBackground\n          }\n        }\n      }\n    }\n    actionButton {\n      ... on EGDSButton {\n        __typename\n        primary\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    analytics {\n      event\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertyListingStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    graphic {\n      __typename\n      ... on Illustration {\n        description\n        url\n      }\n    }\n    egdsElementId\n    heading\n    cardMessage: message\n    links {\n      action {\n        accessibility\n        analytics {\n          linkName\n          referrerId\n        }\n        resource {\n          __typename\n          ... on HttpURI {\n            relativePath\n          }\n        }\n        useRelativePath\n      }\n      text\n    }\n    impressionAnalyticsTracking: impressionTracking {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SponsoredContentPlacementFragment on SponsoredContentPlacement {\n    productType\n    sponsoredContentContext {\n      sponsoredContentId\n      variant\n      pageName\n      targeting {\n        adults\n        dateEnd {\n          day\n          month\n          year\n        }\n        dateStart {\n          day\n          month\n          year\n        }\n        kids\n        locationResolver\n        destination\n      }\n    }\n  }\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingStaticMultiItemCrossSellFragment on StaticLodgingMultiItemCrossSell {\n    crossSellProductType\n    fallbackListing {\n      ...MessageResultFragment\n    }\n    multiItemSearchContext {\n      properties {\n        primary {\n          dateRange {\n            checkInDate {\n              day\n              month\n              year\n            }\n            checkOutDate {\n              day\n              month\n              year\n            }\n          }\n          destination {\n            coordinates {\n              latitude\n              longitude\n            }\n            mapBounds {\n              latitude\n              longitude\n            }\n            pinnedPropertyId\n            propertyIds\n            regionId\n            regionName\n          }\n          rooms {\n            adults\n            children {\n              age\n            }\n          }\n        }\n        secondary {\n          booleans {\n            id\n            value\n          }\n          counts {\n            id\n            value\n          }\n          dates {\n            id\n            value {\n              day\n              month\n              year\n            }\n          }\n          ranges {\n            id\n            max\n            min\n          }\n          selections {\n            id\n            value\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PropertySearchListingPlaceholderFragment on PropertySearchListingPlaceholder {\n    loadingComponent\n  }\n"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ListingFragment on PropertySearchListing {\n    ...LodgingIntentCardFragment\n    ...LodgingCardFragment\n    ...LodgingHeadingFragment\n    ...LodgingStaticMultiItemCrossSellFragment\n    ...MessageResultFragment\n    ...SponsoredContentPlacementFragment\n    ...PropertyListingSoldOutFragment\n    ...PropertyListingOverfilteredFragment\n    ...PropertyListingStandardMessagingCardFragment\n    ...PropertyListingExpandoCardFragment\n    ...SparkleBannerFragment\n    ...PropertySearchListingPlaceholderFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyListingQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $rooms: [RoomInput!]\n    $dateRange: PropertyDateRangeInput\n    $sort: PropertySort\n    $filters: PropertySearchFiltersInput\n    $marketing: PropertyMarketingInfoInput\n    $propertyShopOptions: PropertyShopOptionsInput\n    $searchPagination: PaginationInput\n    $searchIntent: SearchIntentInput\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      rooms: $rooms\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      marketing: $marketing\n      propertyShopOptions: $propertyShopOptions\n      searchPagination: $searchPagination\n      searchIntent: $searchIntent\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n      returnPropertyType: false\n    ) {\n      propertyListingAdaptexAnalyticsSuccessEvents {\n        ...LodgingAdaptExAnalyticsEventFragment\n      }\n      propertySearchListings {\n        ...ListingFragment\n      }\n      pagination {\n        paginationLabel\n        trigger {\n          ... on LodgingPaginationNavigationButtons {\n            previousButton {\n              accessibility\n              analytics {\n                linkName\n                referrerId\n              }\n              disabled\n              icon {\n                token\n              }\n              primary\n            }\n            nextButton {\n              accessibility\n              analytics {\n                referrerId\n                linkName\n              }\n              disabled\n              icon {\n                token\n              }\n              primary\n            }\n          }\n          ... on UIPrimaryButton {\n            analytics {\n              linkName\n              referrerId\n            }\n            action {\n              analytics {\n                linkName\n                referrerId\n              }\n              accessibility\n            }\n            accessibility\n            disabled\n            egdsElementId\n            icon {\n              description\n              id\n              title\n            }\n            primary\n          }\n          ... on LodgingScrollTrigger {\n            triggerAfterPosition\n            analytics {\n              linkName\n              referrerId\n            }\n          }\n        }\n        subSets {\n          nextSubSet {\n            size\n            startingIndex\n          }\n          previousSubset {\n            size\n            startingIndex\n          }\n        }\n      }\n      criteria {\n        secondary {\n          booleans {\n            id\n            value\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "\n  fragment LodgingMoreInfoTriggerFragment on EGDSStandardLink {\n    __typename\n    text\n    icon {\n      description\n      id\n      size\n      title\n      token\n      withBackground\n    }\n    action {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n      resource {\n        ... on HttpURI {\n          relativePath\n          value\n        }\n      }\n      target\n      useRelativePath\n    }\n    egdsElementId\n    disabled\n  }\n"
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "\n  fragment PlainHeaderMessageFragment on EGDSPlainText {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "\n  query PropertyListingHeaderMessagesQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $rooms: [RoomInput!]\n    $dateRange: PropertyDateRangeInput\n    $sort: PropertySort\n    $filters: PropertySearchFiltersInput\n    $marketing: PropertyMarketingInfoInput\n    $propertyShopOptions: PropertyShopOptionsInput\n    $searchPagination: PaginationInput\n    $searchIntent: SearchIntentInput\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      rooms: $rooms\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      marketing: $marketing\n      propertyShopOptions: $propertyShopOptions\n      searchPagination: $searchPagination\n      searchIntent: $searchIntent\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n    ) {\n      summary {\n        resultMessages {\n          ...PlainHeaderMessageFragment\n          ...LodgingMoreInfoTriggerFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
import React74, { useState } from "react";
import LazyLoad from "react-lazy-load";
import { gql as gql64, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
// ../internal/src/components/common/adaptex/adaptex-analytics-event-fragment.ts
import { gql } from "@apollo/client";
var AdaptExAnalyticsEventFragment = gql(_templateObject());
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
import React from "react";
// ../internal/src/utils/adaptex-events-filter.ts
var filterAdaptExEventsByEventType = function(adaptexActionTracking, adaptExEvents) {
    var resultAdaptExEvents;
    if (adaptexActionTracking) {
        resultAdaptExEvents = adaptExEvents.reduce(function(results, adaptExEvent) {
            var foundTracking = adaptexActionTracking.find(function(tracking) {
                return tracking.campaignId === adaptExEvent.campaignId;
            });
            if (foundTracking) {
                var filteredEvents;
                if (foundTracking.eventTarget) {
                    filteredEvents = adaptExEvent.events.filter(function(event) {
                        return foundTracking.eventTarget === event.eventTarget;
                    });
                } else {
                    filteredEvents = adaptExEvent.events;
                }
                if ((filteredEvents === null || filteredEvents === void 0 ? void 0 : filteredEvents.length) > 0) {
                    results.push(_objectSpreadProps(_objectSpread({}, adaptExEvent), {
                        events: filteredEvents
                    }));
                }
            }
            return results;
        }, []);
    } else {
        resultAdaptExEvents = adaptExEvents;
    }
    return resultAdaptExEvents;
};
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
var initialAdaptExEvents = {
    adaptExSuccessEvents: []
};
var AdaptExEventsContext = React.createContext(initialAdaptExEvents);
var useAdaptExEvents = function() {
    var adaptexSuccessActionTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var allAdaptExEvents = React.useContext(AdaptExEventsContext);
    var resultAdaptExSuccessEvents = filterAdaptExEventsByEventType(adaptexSuccessActionTracking, allAdaptExEvents.adaptExSuccessEvents);
    return {
        adaptExSuccessEvents: resultAdaptExSuccessEvents
    };
};
var AdaptExEventsProvider = function(param) {
    var children = param.children, value = param.value;
    return /* @__PURE__ */ React.createElement(AdaptExEventsContext.Provider, {
        value: value
    }, children);
};
// src/components/property-listing/property-listing.tsx
import { buildStateProvider as buildStateProvider2 } from "@shared-ui/provided-state-context";
import { LodgingCompareSheet, LodgingCompareStateChunk, LodgingCompareStateManager } from "@shared-ui/retail-lodging-compare";
import { TripsToastStateChunk, ValidatedInputsState as ValidatedInputsState2 } from "@shared-ui/trips-save-item";
import { UitkSecondaryButton as UitkSecondaryButton4 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex22 } from "uitk-react-layout-flex";
import { UitkPageLoader } from "uitk-react-loader";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
// src/components/property-listing-pagination/property-listing-pagination.tsx
import React3 from "react";
// src/components/property-listing-pagination/property-listing-pagination-navigation.tsx
import React2 from "react";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var PropertyListingPaginationNavigation = function(param) {
    var isLoading = param.isLoading, onNextPage = param.onNextPage, onPrevPage = param.onPrevPage, paginationLabel = param.paginationLabel, pagingNextButton = param.pagingNextButton, pagingPrevButton = param.pagingPrevButton;
    var clickTracker = useClickTracker();
    var _pagingPrevButton_accessibility, _pagingPrevButton_disabled, _pagingNextButton_accessibility, _pagingNextButton_disabled;
    return /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        "data-stid": "pagination-navigation",
        direction: "column",
        justifyContent: "center",
        alignItems: "center"
    }, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            blockend: "four"
        }
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        space: "six",
        alignItems: "center",
        justifyContent: "center"
    }, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            inlineend: "four"
        }
    }, /* @__PURE__ */ React2.createElement(UitkPrimaryButton, {
        "aria-label": (_pagingPrevButton_accessibility = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : pagingPrevButton.accessibility) !== null && _pagingPrevButton_accessibility !== void 0 ? _pagingPrevButton_accessibility : "",
        "data-stid": "previous-button",
        disabled: !pagingPrevButton || isLoading || ((_pagingPrevButton_disabled = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : pagingPrevButton.disabled) !== null && _pagingPrevButton_disabled !== void 0 ? _pagingPrevButton_disabled : false),
        onClick: function() {
            var _pagingPrevButton_analytics, _pagingPrevButton_analytics1;
            onPrevPage();
            var _pagingPrevButton_analytics_referrerId, _pagingPrevButton_analytics_linkName;
            clickTracker((_pagingPrevButton_analytics_referrerId = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : (_pagingPrevButton_analytics = pagingPrevButton.analytics) === null || _pagingPrevButton_analytics === void 0 ? void 0 : _pagingPrevButton_analytics.referrerId) !== null && _pagingPrevButton_analytics_referrerId !== void 0 ? _pagingPrevButton_analytics_referrerId : "", (_pagingPrevButton_analytics_linkName = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : (_pagingPrevButton_analytics1 = pagingPrevButton.analytics) === null || _pagingPrevButton_analytics1 === void 0 ? void 0 : _pagingPrevButton_analytics1.linkName) !== null && _pagingPrevButton_analytics_linkName !== void 0 ? _pagingPrevButton_analytics_linkName : "");
        },
        size: UitkButtonSize.MEDIUM,
        type: "button"
    }, /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: "chevron_left"
    }))), isLoading ? /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, {
        minWidth: 12,
        shrink: 0
    }, /* @__PURE__ */ React2.createElement(UitkLineSkeleton, {
        type: "secondary"
    })) : paginationLabel && /* @__PURE__ */ React2.createElement(UitkText, {
        size: 300,
        weight: "regular"
    }, paginationLabel), /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React2.createElement(UitkPrimaryButton, {
        "aria-label": (_pagingNextButton_accessibility = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : pagingNextButton.accessibility) !== null && _pagingNextButton_accessibility !== void 0 ? _pagingNextButton_accessibility : "",
        "data-stid": "next-button",
        disabled: !pagingNextButton || isLoading || ((_pagingNextButton_disabled = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : pagingNextButton.disabled) !== null && _pagingNextButton_disabled !== void 0 ? _pagingNextButton_disabled : false),
        onClick: function() {
            var _pagingNextButton_analytics, _pagingNextButton_analytics1;
            onNextPage();
            var _pagingNextButton_analytics_referrerId, _pagingNextButton_analytics_linkName;
            clickTracker((_pagingNextButton_analytics_referrerId = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : (_pagingNextButton_analytics = pagingNextButton.analytics) === null || _pagingNextButton_analytics === void 0 ? void 0 : _pagingNextButton_analytics.referrerId) !== null && _pagingNextButton_analytics_referrerId !== void 0 ? _pagingNextButton_analytics_referrerId : "", (_pagingNextButton_analytics_linkName = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : (_pagingNextButton_analytics1 = pagingNextButton.analytics) === null || _pagingNextButton_analytics1 === void 0 ? void 0 : _pagingNextButton_analytics1.linkName) !== null && _pagingNextButton_analytics_linkName !== void 0 ? _pagingNextButton_analytics_linkName : "");
        },
        size: UitkButtonSize.MEDIUM,
        type: "button"
    }, /* @__PURE__ */ React2.createElement(UitkIcon, {
        name: "chevron_right"
    }))))));
};
PropertyListingPaginationNavigation.displayName = "PaginationNavigation";
// src/components/property-listing-pagination/property-listing-pagination.tsx
var refreshAds = function() {
    if (document && CustomEvent && typeof document.dispatchEvent === "function") {
        document.dispatchEvent(new CustomEvent("mesoTriggeredRefresh", {
            detail: {
                type: "impressionRefresh"
            }
        }));
    }
};
var PropertyListingPagination = function(param) {
    var handlePagination = param.handlePagination, isLoading = param.isLoading, pagination = param.pagination;
    var _pagination_trigger;
    var handleNewPage = function(startingIndex) {
        refreshAds();
        handlePagination(startingIndex);
    };
    if ((pagination === null || pagination === void 0 ? void 0 : (_pagination_trigger = pagination.trigger) === null || _pagination_trigger === void 0 ? void 0 : _pagination_trigger.__typename) !== "LodgingPaginationNavigationButtons") {
        return null;
    }
    var _pagination_paginationLabel;
    return /* @__PURE__ */ React3.createElement(PropertyListingPaginationNavigation, {
        isLoading: isLoading,
        onNextPage: function() {
            var _pagination_subSets, _pagination_subSets_nextSubSet;
            return handleNewPage((_pagination_subSets = pagination.subSets) === null || _pagination_subSets === void 0 ? void 0 : (_pagination_subSets_nextSubSet = _pagination_subSets.nextSubSet) === null || _pagination_subSets_nextSubSet === void 0 ? void 0 : _pagination_subSets_nextSubSet.startingIndex);
        },
        onPrevPage: function() {
            var _pagination_subSets, _pagination_subSets_previousSubset;
            return handleNewPage((_pagination_subSets = pagination.subSets) === null || _pagination_subSets === void 0 ? void 0 : (_pagination_subSets_previousSubset = _pagination_subSets.previousSubset) === null || _pagination_subSets_previousSubset === void 0 ? void 0 : _pagination_subSets_previousSubset.startingIndex);
        },
        paginationLabel: (_pagination_paginationLabel = pagination.paginationLabel) !== null && _pagination_paginationLabel !== void 0 ? _pagination_paginationLabel : "",
        pagingNextButton: pagination.trigger.nextButton,
        pagingPrevButton: pagination.trigger.previousButton
    });
};
PropertyListingPagination.displayName = "PropertyListingPagination";
// src/components/property-listing/__private/listing.tsx
import React72 from "react";
import { gql as gql63 } from "@apollo/client";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3 } from "@shared-ui/experiment-context";
// ../internal/src/components/lodging-card/lodging-card.tsx
import React56, { useEffect as useEffect2 } from "react";
import { gql as gql47 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker5, useClickstreamAnalytics as useClickstreamAnalytics3, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useMesoViewabilityWrapper } from "@shared-ui/sponsored-content-meso-viewability-wrapper";
// ../internal/src/utils/analytics.ts
var parseLodgingCardImpressionSchema = function(uisPrimeMessages) {
    if (uisPrimeMessages && uisPrimeMessages.length > 0) {
        return [
            {
                // we are parsing data here since additionalUisPrimeMicroMessages in intersection tracker takes message content as json object
                // mean while we are returning this data from the API as string.
                messageContent: JSON.parse(uisPrimeMessages[0].messageContent),
                schemaName: uisPrimeMessages[0].schemaName
            }
        ];
    }
};
var lightweightAdaptExMicroMessage = function(param) {
    var campaignId = param.campaignId, payloadId = param.payloadId, eventType = param.eventType, eventTarget = param.eventTarget, _param_banditDisplayed = param.banditDisplayed, banditDisplayed = _param_banditDisplayed === void 0 ? true : _param_banditDisplayed;
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: [
                {
                    payloadId: payloadId,
                    eventType: eventType,
                    eventTarget: eventTarget,
                    banditDisplayed: banditDisplayed
                }
            ]
        }
    };
};
var createAdaptExMicroMessage = function(campaignId, events) {
    var allEvents = events === null || events === void 0 ? void 0 : events.reduce(function(acc, curr) {
        return _toConsumableArray(acc).concat([
            {
                payloadId: curr.payloadId,
                eventType: curr.eventType,
                eventTarget: curr.eventTarget,
                banditDisplayed: curr.banditDisplayed
            }
        ]);
    }, []);
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: allEvents
        }
    };
};
var adaptToAdaptExSuccessEventSchema = function(lodgingAdaptExAnalyticsEvent) {
    var mappedMessages = [];
    var campaignId = lodgingAdaptExAnalyticsEvent.campaignId, events = lodgingAdaptExAnalyticsEvent.events, clientSideAnalytics = lodgingAdaptExAnalyticsEvent.clientSideAnalytics;
    if (clientSideAnalytics) {
        var referrerId = clientSideAnalytics.referrerId, eventType = clientSideAnalytics.eventType, linkName = clientSideAnalytics.linkName;
        mappedMessages.push({
            messageContent: {
                referrerId: referrerId,
                eventType: (eventType === null || eventType === void 0 ? void 0 : eventType.toLowerCase()) || "click",
                linkName: linkName
            },
            schemaName: "referrer"
        });
    }
    if (events) {
        mappedMessages.push(createAdaptExMicroMessage(campaignId, events));
    }
    return mappedMessages;
};
var microMessageToFragment = function(param) {
    var schemaName = param.schemaName, messageContent = param.messageContent;
    return {
        __typename: "EGUisMicroMessage",
        schemaName: schemaName,
        messageContent: JSON.stringify(messageContent)
    };
};
// ../internal/src/components/lodging-card/lodging-card-utils.ts
import { ITrackType } from "@shared-ui/clickstream-analytics-context";
var isCompactView = function(view) {
    return view === "COMPACT" /* COMPACT */ ;
};
var isCompactHorizontalView = function(view) {
    return view === "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ ;
};
function sendProductSchemaTracking(analytics, track) {
    var _analytics_uisPrimeMessages;
    var productSchema = ((_analytics_uisPrimeMessages = analytics.uisPrimeMessages) === null || _analytics_uisPrimeMessages === void 0 ? void 0 : _analytics_uisPrimeMessages.length) > 0 ? analytics.uisPrimeMessages.map(function(param) {
        var schemaName = param.schemaName, messageContent = param.messageContent;
        return {
            schemaName: schemaName,
            messageContent: JSON.parse(messageContent)
        };
    }) : void 0;
    track(analytics.referrerId, analytics.linkName, true, productSchema);
}
function adaptProductEvent(productEvent) {
    return _objectSpreadProps(_objectSpread({}, productEvent), {
        event: {
            event_name: productEvent.event.eventName,
            event_type: productEvent.event.eventType,
            event_version: productEvent.event.eventVersion
        }
    });
}
function consolidateOnclick(track, event, adaptexTrack, adaptexSuccessEvents, onClick) {
    return function() {
        if (onClick) {
            onClick();
        }
        if (event) {
            track(adaptProductEvent(event));
        }
        if (adaptexSuccessEvents.length) {
            adaptexSuccessEvents.forEach(function(adaptExEvent) {
                adaptexTrack(ITrackType.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    };
}
var isAd = function(mediaSection) {
    var _mediaSection_badges, _mediaSection_badges_secondaryBadge;
    return ((_mediaSection_badges = mediaSection.badges) === null || _mediaSection_badges === void 0 ? void 0 : (_mediaSection_badges_secondaryBadge = _mediaSection_badges.secondaryBadge) === null || _mediaSection_badges_secondaryBadge === void 0 ? void 0 : _mediaSection_badges_secondaryBadge.theme) === "promoted";
};
// ../internal/src/components/lodging-card/__private/lodging-card-content-section.tsx
import React43 from "react";
import { gql as gql38 } from "@apollo/client";
import { HeadingLevelProvider } from "@shared-ui/heading-level-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport4 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing11, UitkSpacingHr } from "uitk-react-spacing";
// ../internal/src/components/common/adaptex/adaptex-success-action-tracking-fragment.ts
import { gql as gql2 } from "@apollo/client";
var AdaptexTrackingFragment = gql2(_templateObject1());
// ../internal/src/components/common/pricing-fragments.ts
import { gql as gql3 } from "@apollo/client";
var PriceSummaryFragment = gql3(_templateObject2());
// ../internal/src/components/lodging-badge/lodging-badge.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkBadge, UitkBadgeLoyalty, UitkBadgeStandard, UitkBadgeStandardThemes } from "uitk-react-badge";
import { UitkIcon as UitkIcon2, UitkIconSize } from "uitk-react-icons";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
// ../internal/src/components/uitk-badge-size-mapper.tsx
import { UitkBadgeSize } from "uitk-react-badge";
var _obj;
var UitkBadgeSizeMapper = (_obj = {}, _defineProperty(_obj, UitkBadgeSize.SMALL, "small"), _defineProperty(_obj, UitkBadgeSize.LARGE, "large"), _obj);
// ../internal/src/components/uitk-badge-theme-mapper.tsx
import { UitkBadgeLoyaltyThemes, UitkBadgeTheme } from "uitk-react-badge";
var LOYALTY_EXTRA_HIGH_TIER = "loyalty-extra-high-tier";
var _obj1;
var UitkBadgeThemeMapper = (_obj1 = {}, _defineProperty(_obj1, UitkBadgeTheme.DEAL_BUNDLED, "deal-bundled"), _defineProperty(_obj1, UitkBadgeTheme.DEAL_GENERIC, "deal-generic"), _defineProperty(_obj1, UitkBadgeTheme.DEAL_MEMBER, "deal-member"), _defineProperty(_obj1, UitkBadgeTheme.NOTIFICATION_1, "notification-1"), _defineProperty(_obj1, UitkBadgeTheme.NOTIFICATION_2, "notification-2"), _defineProperty(_obj1, UitkBadgeTheme.VIP, "vip"), _defineProperty(_obj1, UitkBadgeTheme.LOYALTY_HIGH_TIER, "loyalty-high-tier"), _defineProperty(_obj1, UitkBadgeTheme.LOYALTY_MIDDLE_TIER, "loyalty-middle-tier"), _defineProperty(_obj1, UitkBadgeTheme.LOYALTY_LOW_TIER, "loyalty-low-tier"), _defineProperty(_obj1, UitkBadgeTheme.SPONSORED, "sponsored"), _defineProperty(_obj1, UitkBadgeTheme.VIEWED, "viewed"), _defineProperty(_obj1, UitkBadgeTheme.SAVED, "saved"), _defineProperty(_obj1, UitkBadgeTheme.FAMILY_FRIENDLY, "family-friendly"), _defineProperty(_obj1, UitkBadgeTheme.SUPPLIER_PROMO, "supplier-promo"), _defineProperty(_obj1, UitkBadgeTheme.PROMOTED, "promoted"), _obj1);
var _obj2;
var UitkBadgeLoyaltyThemeMapper = (_obj2 = {}, _defineProperty(_obj2, LOYALTY_EXTRA_HIGH_TIER, UitkBadgeLoyaltyThemes.EXTRAHIGH), _defineProperty(_obj2, UitkBadgeTheme.LOYALTY_HIGH_TIER, UitkBadgeLoyaltyThemes.HIGH), _defineProperty(_obj2, UitkBadgeTheme.LOYALTY_MIDDLE_TIER, UitkBadgeLoyaltyThemes.MID), _defineProperty(_obj2, UitkBadgeTheme.LOYALTY_LOW_TIER, UitkBadgeLoyaltyThemes.LOW), _obj2);
// ../internal/src/components/lodging-badge/lodging-badge.tsx
var fragment = gql4(_templateObject3());
var LodgingBadge = function(param) {
    var propertyId = param.propertyId, className = param.className, isSRPListingCard = param.isSRPListingCard, data = param.data;
    if (!data || !data.text && !data.graphic) {
        return null;
    }
    var text = data.text, theme = data.theme, graphic = data.graphic, size = data.size;
    var graphics = function() {
        switch(graphic === null || graphic === void 0 ? void 0 : graphic.__typename){
            case "Icon":
                return graphic.id && /* @__PURE__ */ React4.createElement(UitkIcon2, {
                    name: graphic.id,
                    id: propertyId ? "mod-".concat(propertyId, "-title") : void 0,
                    description: graphic.description,
                    size: UitkIconSize.SMALL
                });
            case "Mark":
                return graphic.id && /* @__PURE__ */ React4.createElement(UitkMark, {
                    name: graphic.id,
                    description: graphic.description,
                    size: UitkMarkSize.SMALL
                });
            default:
                return null;
        }
    };
    var DefaultUitkBadge = function() {
        return /* @__PURE__ */ React4.createElement(UitkBadge, {
            className: className,
            text: text || void 0,
            theme: theme ? UitkBadgeThemeMapper[theme] : void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0
        }, graphics());
    };
    if (theme && UitkBadgeLoyaltyThemeMapper[theme]) {
        return /* @__PURE__ */ React4.createElement(UitkBadgeLoyalty, {
            className: className,
            text: text || void 0,
            theme: theme ? UitkBadgeLoyaltyThemeMapper[theme] : void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0
        }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphics());
    }
    if (theme === UitkBadgeThemeMapper.promoted) {
        return isSRPListingCard ? /* @__PURE__ */ React4.createElement(Experiment, {
            name: "MeSo_TravelAd_Standard_Badge"
        }, /* @__PURE__ */ React4.createElement(ExperimentControl, null, /* @__PURE__ */ React4.createElement(DefaultUitkBadge, null)), /* @__PURE__ */ React4.createElement(ExperimentVariant, {
            bucket: 1
        }, /* @__PURE__ */ React4.createElement(UitkBadgeStandard, {
            className: className,
            text: text || void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0,
            theme: "standard"
        }))) : /* @__PURE__ */ React4.createElement(DefaultUitkBadge, null);
    }
    if (theme && UitkBadgeStandardThemes[theme]) {
        return /* @__PURE__ */ React4.createElement(UitkBadgeStandard, {
            className: className,
            text: text || void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0,
            theme: theme ? UitkBadgeStandardThemes[theme] : void 0
        });
    }
    return /* @__PURE__ */ React4.createElement(DefaultUitkBadge, null);
};
LodgingBadge.fragment = fragment;
LodgingBadge.displayName = "LodgingBadge";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var _obj3;
// ../internal/src/components/__private/link-map.ts
var linkSizeMapper = (_obj3 = {}, _defineProperty(_obj3, "SMALL" /* SMALL */ , "small"), _defineProperty(_obj3, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj3, "LARGE" /* LARGE */ , "large"), _obj3);
var _obj4;
var UILinkTargetMap = (_obj4 = {}, _defineProperty(_obj4, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj4, "INTERNAL" /* INTERNAL */ , "_self"), _obj4);
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
var fragment2 = gql5(_templateObject4());
var LodgingEGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, disabled = _param_data.disabled, linkSize = _param_data.linkSize, text = _param_data.text;
    var clickTracker = useClickTracker2();
    var onClick = React5.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React5.createElement(UitkLink, {
        className: className,
        size: linkSizeMapper[linkSize],
        onClickCapture: onClick,
        disabled: disabled,
        inline: true
    }, /* @__PURE__ */ React5.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap[target]
    }, text, accessibility && /* @__PURE__ */ React5.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
LodgingEGDSInlineLink.fragment = fragment2;
LodgingEGDSInlineLink.displayName = "LodgingEGDSInlineLink";
// ../internal/src/components/lodging-egds-text/lodging-egds-paragraph.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment3 = gql6(_templateObject5());
var LodgingEGDSParagraph = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? 2 : _param_size;
    return /* @__PURE__ */ React6.createElement(UitkParagraph, {
        size: size
    }, data.text);
};
LodgingEGDSParagraph.fragment = fragment3;
LodgingEGDSParagraph.displayName = "LodgingEGDSParagraph";
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var _obj5;
// ../internal/src/components/lodging-egds-text/__private/text-theme.ts
var textThemeMapper = (_obj5 = {}, _defineProperty(_obj5, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _defineProperty(_obj5, "LOYALTY" /* LOYALTY */ , "loyalty"), _defineProperty(_obj5, "NEGATIVE" /* NEGATIVE */ , "negative"), _defineProperty(_obj5, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj5, "PRIMARY" /* PRIMARY */ , "emphasis"), _defineProperty(_obj5, "SECONDARY" /* SECONDARY */ , "default"), _defineProperty(_obj5, "INVERSE" /* INVERSE */ , "inverse"), _obj5);
var _obj6;
// ../internal/src/components/lodging-egds-text/__private/text-weight.ts
var textWeightMapper = (_obj6 = {}, _defineProperty(_obj6, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj6, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj6, "REGULAR" /* REGULAR */ , "regular"), _obj6);
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
var fragment4 = gql7(_templateObject6());
var sizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var decorativeMap = {
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
};
var EGDSStylizedText = function(_param) {
    var data = _param.data, theme = _param.theme, weight = _param.weight, size = _param.size, props = _objectWithoutProperties(_param, [
        "data",
        "theme",
        "weight",
        "size"
    ]);
    var decorative = data.decorative, accessibility = data.accessibility;
    var textProps = _objectSpread({
        theme: data.theme ? textThemeMapper[data.theme] : theme,
        weight: data.weight ? textWeightMapper[data.weight] : weight,
        size: data.size ? sizeMap[data.size] : size
    }, props);
    var Decorative = decorative && decorativeMap[decorative];
    var content = Decorative ? /* @__PURE__ */ React7.createElement(Decorative, null, data.text) : data.text;
    return /* @__PURE__ */ React7.createElement(UitkText2, _objectSpread({}, textProps), content, accessibility && /* @__PURE__ */ React7.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSStylizedText.fragment = fragment4;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
var fragment5 = gql8(_templateObject7(), LodgingEGDSParagraph.fragment, EGDSStylizedText.fragment, LodgingEGDSInlineLink.fragment);
var LodgingEGDSText = function(param) {
    var size = param.size, overflow = param.overflow, spacing = param.spacing, data = param.data, align = param.align, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React8.createElement(UitkText3, {
                inline: inline,
                size: size
            }, data.text);
        case "EGDSParagraph":
            return /* @__PURE__ */ React8.createElement(LodgingEGDSParagraph, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React8.createElement(EGDSStylizedText, {
                size: size,
                overflow: overflow,
                spacing: spacing,
                data: data,
                align: align,
                inline: inline
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React8.createElement(LodgingEGDSInlineLink, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
LodgingEGDSText.fragment = fragment5;
LodgingEGDSText.displayName = "LodgingEGDSText";
// ../internal/src/components/lodging-egds-text/lodging-egds-heading.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var fragment6 = gql9(_templateObject8());
var LodgingEGDSHeading = function(param) {
    var tag = param.tag, size = param.size, data = param.data;
    return /* @__PURE__ */ React9.createElement(UitkHeading, {
        tag: tag,
        size: size
    }, data.text);
};
LodgingEGDSHeading.fragment = fragment6;
LodgingEGDSHeading.displayName = "LodgingEGDSHeading";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkText as UitkText6 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/lodging-egds-graphic-text/lodging-egds-graphic-text.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment7 = gql10(_templateObject9());
var LodgingEGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, customTextSize = param.customTextSize;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React10.createElement("div", null, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphic.id && /* @__PURE__ */ React10.createElement(UitkSpacing2, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React10.createElement(UitkIcon3, {
        name: graphic.id,
        size: graphic.size ? UitkIconSize2[graphic.size] : UitkIconSize2.EXTRA_SMALL
    })), /* @__PURE__ */ React10.createElement(UitkText4, _objectSpreadProps(_objectSpread({
        size: customTextSize || 200
    }, textProps), {
        inline: !!graphic
    }), text));
};
LodgingEGDSGraphicText.fragment = fragment7;
LodgingEGDSGraphicText.displayName = "LodgingEGDSGraphicText";
// ../internal/src/components/lodging-egds-text/lodging-egds-plain-text.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
var fragment8 = gql11(_templateObject10());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React11.createElement(UitkText5, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment8;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
var fragment9 = gql12(_templateObject11(), EGDSStylizedText.fragment, EGDSPlainText.fragment, LodgingEGDSGraphicText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, data = param.data;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React12.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React12.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React12.createElement(LodgingEGDSGraphicText, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
var fragment10 = gql13(_templateObject12(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_contents, _data_inlineContent, _data_inlineContent1;
    var align = props.align, data = props.data, styleProps = _objectWithoutProperties(props, [
        "align",
        "data"
    ]);
    if ((data === null || data === void 0 ? void 0 : (_data_contents = data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !(data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React13.createElement(UitkText6, _objectSpreadProps(_objectSpread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React13.createElement(React13.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(EGDSSpannableTextContent, _objectSpreadProps(_objectSpread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            })));
        }));
    }
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React13.createElement(React13.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React13.createElement(EGDSSpannableTextContent, _objectSpread({
            data: item
        }, styleProps)));
    }));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/lodging-egds-text/lodging-egds-localized-text-template.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
var fragment11 = gql14(_templateObject13());
var LodgingEGDSLocalizedTextTemplate = function(param) {
    var data = param.data, value = param.value;
    return /* @__PURE__ */ React14.createElement(React14.Fragment, null, data.template.replace("{".concat(data.token, "}"), value));
};
LodgingEGDSLocalizedTextTemplate.fragment = fragment11;
LodgingEGDSLocalizedTextTemplate.displayName = "LodgingEGDSLocalizedTextTemplate";
// ../internal/src/components/lodging-standard-badge/lodging-standard-badge.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkBadge as UitkBadge2, UitkBadgeLoyalty as UitkBadgeLoyalty2 } from "uitk-react-badge";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkMark as UitkMark2, UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
var fragment12 = gql15(_templateObject14());
var LodgingStandardBadge = function(param) {
    var propertyId = param.propertyId, className = param.className, data = param.data;
    if (!data || !data.standardBadge || !data.standardBadge.text && !data.standardBadge.graphic) {
        return null;
    }
    var standardBadge = data.standardBadge, impressionEventAnalytics = data.impressionEventAnalytics;
    var text = standardBadge.text, theme = standardBadge.theme, graphic = standardBadge.graphic, size = standardBadge.size;
    var _ref = impressionEventAnalytics !== null && impressionEventAnalytics !== void 0 ? impressionEventAnalytics : {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var graphics = function() {
        switch(graphic === null || graphic === void 0 ? void 0 : graphic.__typename){
            case "Icon":
                return graphic.id && /* @__PURE__ */ React15.createElement(UitkIcon4, {
                    name: graphic.id,
                    id: propertyId ? "mod-".concat(propertyId, "-title") : void 0,
                    description: graphic.description,
                    size: UitkIconSize3.SMALL
                });
            case "Mark":
                return graphic.id && /* @__PURE__ */ React15.createElement(UitkMark2, {
                    name: graphic.id,
                    description: graphic.description,
                    size: UitkMarkSize2.SMALL
                });
            default:
                return null;
        }
    };
    var badgeLoyalty = /* @__PURE__ */ React15.createElement(UitkBadgeLoyalty2, {
        className: className,
        text: text || void 0,
        theme: theme ? UitkBadgeLoyaltyThemeMapper[theme] : void 0,
        size: size ? UitkBadgeSizeMapper[size] : void 0
    }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Icon" && graphics());
    var lodgingBadge = referrerId && linkName ? /* @__PURE__ */ React15.createElement(IntersectionTracker, {
        referrerId: referrerId,
        linkName: linkName,
        trackOnce: true
    }, badgeLoyalty) : badgeLoyalty;
    return theme && UitkBadgeLoyaltyThemeMapper[theme] ? lodgingBadge : /* @__PURE__ */ React15.createElement(UitkBadge2, {
        className: className,
        text: text || void 0,
        theme: theme ? UitkBadgeThemeMapper[theme] : void 0,
        size: size ? UitkBadgeSizeMapper[size] : void 0
    }, graphics());
};
LodgingStandardBadge.fragment = fragment12;
LodgingStandardBadge.displayName = "LodgingStandardBadge";
// ../internal/src/components/lodging-card/lodging-card-price-section-price-summary.tsx
import React19 from "react";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
import { UitkPriceLockupAlign as UitkPriceLockupAlign2 } from "uitk-react-price-lockup";
// ../internal/src/components/lodging-price-summary.tsx
import React18 from "react";
import { gql as gql16 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
// ../internal/src/utils/use-dialog-id.ts
import React16 from "react";
var useDialogId = function() {
    return React16.useMemo(function() {
        return Math.random().toString(36).slice(2, 7);
    }, []);
};
// ../internal/src/components/dialog-context.tsx
import React17 from "react";
var DialogContext = React17.createContext(false);
var dialog_context_default = DialogContext;
// ../internal/src/components/lodging-price-summary.tsx
var fragment13 = gql16(_templateObject15());
var formatStrikeOutText = function(price, points, unit, leadingCaption, isPointsFirst) {
    if (!price && !points) {
        return void 0;
    }
    if (!points) {
        return price === null || price === void 0 ? void 0 : price.formatted;
    }
    if (!price) {
        return "".concat(points.formatted, " ").concat(unit);
    }
    if (isPointsFirst) {
        return "".concat(points.formatted, " ").concat(unit, " ").concat(leadingCaption, " ").concat(price.formatted);
    }
    return "".concat(price.formatted, " ").concat(leadingCaption, " ").concat(points.formatted, " ").concat(unit);
};
var buildUitkPriceLockupProps = function(options) {
    var _loyaltyPoints_amount, _priceDisclaimer_trigger, _priceDisclaimer_trigger_icon;
    var _options = _slicedToArray(options, 3), leadOption = _options[0], otherOption = _options[1], disclaimerForPoints = _options[2];
    var leadingCaption = leadOption.leadingCaption, loyaltyPrice = leadOption.loyaltyPrice, displayPrice = leadOption.displayPrice, accessibilityLabel = leadOption.accessibilityLabel, priceDisclaimer = leadOption.priceDisclaimer, strikeOut = leadOption.strikeOut;
    if (options.length === 1 && loyaltyPrice) {
        var _loyaltyPrice_totalStrikeOutPoints, _loyaltyPrice_amount;
        var strikeThroughPoints = loyaltyPrice.totalStrikeOutPoints ? "".concat((_loyaltyPrice_totalStrikeOutPoints = loyaltyPrice.totalStrikeOutPoints) === null || _loyaltyPrice_totalStrikeOutPoints === void 0 ? void 0 : _loyaltyPrice_totalStrikeOutPoints.formatted, " ").concat(loyaltyPrice.unit) : "";
        return {
            isStrikeThroughFirst: true,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount = loyaltyPrice.amount) === null || _loyaltyPrice_amount === void 0 ? void 0 : _loyaltyPrice_amount.formatted, " ").concat(loyaltyPrice.unit),
            strikeThroughPrice: strikeThroughPoints,
            a11yPrice: accessibilityLabel || ""
        };
    }
    if (loyaltyPrice) {
        var _otherOption_displayPrice, _loyaltyPrice_amount1, _disclaimerForPoints_priceDisclaimer, _disclaimerForPoints_priceDisclaimer_trigger, _disclaimerForPoints_priceDisclaimer_trigger_icon;
        var moneyPrice = "".concat(otherOption.leadingCaption, " ").concat((_otherOption_displayPrice = otherOption.displayPrice) === null || _otherOption_displayPrice === void 0 ? void 0 : _otherOption_displayPrice.formatted);
        return {
            isStrikeThroughFirst: true,
            isPointsFirst: true,
            lockupPrice: moneyPrice,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount1 = loyaltyPrice.amount) === null || _loyaltyPrice_amount1 === void 0 ? void 0 : _loyaltyPrice_amount1.formatted, " ").concat(loyaltyPrice.unit),
            a11yPrice: otherOption.accessibilityLabel || "",
            strikeThroughPrice: formatStrikeOutText(disclaimerForPoints === null || disclaimerForPoints === void 0 ? void 0 : disclaimerForPoints.strikeOut, loyaltyPrice.totalStrikeOutPoints, loyaltyPrice.unit, otherOption.leadingCaption, true),
            a11yStrikeThroughDialogTrigger: disclaimerForPoints === null || disclaimerForPoints === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer = disclaimerForPoints.priceDisclaimer) === null || _disclaimerForPoints_priceDisclaimer === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger = _disclaimerForPoints_priceDisclaimer.trigger) === null || _disclaimerForPoints_priceDisclaimer_trigger === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger_icon = _disclaimerForPoints_priceDisclaimer_trigger.icon) === null || _disclaimerForPoints_priceDisclaimer_trigger_icon === void 0 ? void 0 : _disclaimerForPoints_priceDisclaimer_trigger_icon.description
        };
    }
    var leadPrice = leadingCaption ? "".concat(leadingCaption, " ").concat(displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.formatted) : displayPrice === null || displayPrice === void 0 ? void 0 : displayPrice.formatted;
    if (options.length === 1) {
        var _priceDisclaimer_trigger1, _priceDisclaimer_trigger_icon1;
        return {
            lockupPrice: leadPrice,
            a11yPrice: accessibilityLabel || "",
            strikeThroughPrice: strikeOut === null || strikeOut === void 0 ? void 0 : strikeOut.formatted,
            a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger1 = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : (_priceDisclaimer_trigger_icon1 = _priceDisclaimer_trigger1.icon) === null || _priceDisclaimer_trigger_icon1 === void 0 ? void 0 : _priceDisclaimer_trigger_icon1.description
        };
    }
    var loyaltyPoints = otherOption.loyaltyPrice;
    return {
        isStrikeThroughFirst: true,
        isPointsFirst: false,
        strikeThroughPrice: formatStrikeOutText(strikeOut, loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.totalStrikeOutPoints, loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.unit, otherOption.leadingCaption, false),
        lockupPrice: leadPrice,
        lockupFormattedPoints: "".concat(otherOption.leadingCaption, " ").concat(loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : (_loyaltyPoints_amount = loyaltyPoints.amount) === null || _loyaltyPoints_amount === void 0 ? void 0 : _loyaltyPoints_amount.formatted, " ").concat(loyaltyPoints === null || loyaltyPoints === void 0 ? void 0 : loyaltyPoints.unit),
        a11yStrikeThroughDialogTrigger: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.description,
        a11yPrice: accessibilityLabel || ""
    };
};
var getPriceDisclaimer = function(options) {
    var _options_;
    return options[0].priceDisclaimer || ((_options_ = options[2]) === null || _options_ === void 0 ? void 0 : _options_.priceDisclaimer);
};
var LodgingPriceSummary = function(param) {
    var _param_showPriceDetails = param.showPriceDetails, showPriceDetails = _param_showPriceDetails === void 0 ? true : _param_showPriceDetails, _param_align = param.align, align = _param_align === void 0 ? UitkPriceLockupAlign.LEFT : _param_align, data = param.data;
    var _priceDisclaimer_primaryButton;
    var price = data.price;
    var trackClick = useClickTracker3();
    var dialogPostfix = useDialogId();
    var _useDialog = _slicedToArray(useDialog("property-price-messaging-dialog-".concat(dialogPostfix), "pwaDialogNested"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var isWithinDetailsDialog = React18.useContext(dialog_context_default);
    if (!(price === null || price === void 0 ? void 0 : price.options) || price.options.length === 0) {
        return null;
    }
    var priceMessaging = price.priceMessaging, options = price.options;
    var priceSubtextBoldIndex = (priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.findIndex(function(msg) {
        return msg.theme === "STRONG" /* STRONG */ ;
    })) || -1;
    var priceSubtextStandardRawData = priceSubtextBoldIndex === -1 ? priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.slice(1) : priceMessaging === null || priceMessaging === void 0 ? void 0 : priceMessaging.slice(1).splice(priceSubtextBoldIndex, 1);
    var priceSubtextStandard = priceSubtextStandardRawData === null || priceSubtextStandardRawData === void 0 ? void 0 : priceSubtextStandardRawData.map(function(msg) {
        return msg.value;
    });
    var openStrikeThroughPriceDialog = function() {
        dialogActions.openDialog();
        trackClick("HOT.HIS.Price.DisclaimerDialog", "Price Disclaimer Dialog");
    };
    var priceProps = buildUitkPriceLockupProps(options);
    var priceDisclaimer = getPriceDisclaimer(options);
    return /* @__PURE__ */ React18.createElement("div", null, /* @__PURE__ */ React18.createElement(UitkPriceLockup, _objectSpreadProps(_objectSpread({}, priceProps), {
        align: align,
        priceSubtextFirst: showPriceDetails && priceMessaging ? priceMessaging[0].value : "",
        priceSubtextStandard: showPriceDetails ? priceSubtextStandard : void 0,
        priceSubtextBold: showPriceDetails && priceMessaging && priceSubtextBoldIndex !== -1 ? priceMessaging[priceSubtextBoldIndex].value : "",
        strikeThroughTrigger: !!priceDisclaimer && /* @__PURE__ */ React18.createElement("button", {
            onClick: openStrikeThroughPriceDialog,
            type: "button",
            className: "uitk-more-info-trigger"
        }),
        stids: {
            lockupId: "price-lockup-text",
            subtextBoldId: "price-lockup-bold-subtext",
            wrapperId: "price-lockup-wrapper"
        }
    })), !!priceDisclaimer && !isWithinDetailsDialog && /* @__PURE__ */ React18.createElement(DialogComponent, null, /* @__PURE__ */ React18.createElement(UitkDialog, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React18.createElement(UitkDialogContent, null, priceDisclaimer.content[0], /* @__PURE__ */ React18.createElement(UitkDialogFooter, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: ((_priceDisclaimer_primaryButton = priceDisclaimer.primaryButton) === null || _priceDisclaimer_primaryButton === void 0 ? void 0 : _priceDisclaimer_primaryButton.text) || "",
            type: "tertiary"
        }
    })))));
};
LodgingPriceSummary.fragment = fragment13;
LodgingPriceSummary.displayName = "LodgingPriceSummary";
// ../internal/src/components/lodging-card/lodging-card-price-section-price-summary.tsx
var mapPriceSummary = function(priceSummary) {
    var price = {
        __typename: "Offer",
        price: priceSummary
    };
    return price;
};
var PriceSectionPriceSummary = function(param) {
    var priceSection = param.priceSection, flexAlignment = param.flexAlignment, _param_align = param.align, align = _param_align === void 0 ? UitkPriceLockupAlign2.RIGHT : _param_align, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _priceSection_priceSummary, _priceSection_priceSummary_displayMessages;
    return ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : (_priceSection_priceSummary_displayMessages = _priceSection_priceSummary.displayMessages) === null || _priceSection_priceSummary_displayMessages === void 0 ? void 0 : _priceSection_priceSummary_displayMessages.length) ? /* @__PURE__ */ React19.createElement(PriceSummary, {
        data: priceSection.priceSummary,
        flexAlignment: flexAlignment,
        enableInlineLink: enableInlineLink
    }) : /* @__PURE__ */ React19.createElement(LodgingPriceSummary, {
        align: align,
        data: mapPriceSummary(priceSection.priceSummary)
    });
};
// ../internal/src/components/lodging-card/__private/lodging-card-compare-section.tsx
import React20, { useCallback, useContext } from "react";
import { gql as gql17 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState } from "@shared-ui/provided-state-context";
import { CompareAdaptExContext } from "@shared-ui/retail-compare-providers";
import { UitkCheckbox } from "uitk-react-checkbox";
import { UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
// ../internal/src/components/lodging-compare/lodging-compare-state.tsx
var STATE_FIELD_NAME = "lodgingCompare";
var MAX_SELECTABLE = 5;
var defaultState = {
    searchResultsProperties: [],
    comparePropertyIds: [],
    isDialogOpen: false
};
var SET_PROPERTIES = "".concat(STATE_FIELD_NAME, ".setProperties");
var ADD_COMPARE_PROPERTY = "".concat(STATE_FIELD_NAME, ".addCompareProperty");
var REMOVE_COMPARE_PROPERTY = "".concat(STATE_FIELD_NAME, ".removeCompareProperty");
var OPEN_DIALOG = "".concat(STATE_FIELD_NAME, ".openDialog");
var CLOSE_DIALOG = "".concat(STATE_FIELD_NAME, ".closeDialog");
// ../internal/src/components/lodging-card/__private/lodging-card-compare-section.tsx
var fragment14 = gql17(_templateObject16());
var LodgingCardCompareSection = function(param) {
    var propertyId = param.propertyId, isAd2 = param.isAd, data = param.data;
    var track = useClickTracker4();
    var compareAction = data.compareAction;
    var _useProvidedState = _slicedToArray(useProvidedState(), 2), state = _useProvidedState[0], dispatch = _useProvidedState[1];
    var _state_STATE_FIELD_NAME;
    var comparePropertyIds = ((_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    var cardId = isAd2 ? propertyId.concat("-ad") : propertyId;
    var checked = comparePropertyIds.includes(cardId);
    var uniquePropertyIds = _toConsumableArray(new Set(comparePropertyIds.map(function(id2) {
        return id2.split("-")[0];
    })));
    var disabled = uniquePropertyIds.length >= MAX_SELECTABLE && !checked;
    var setCheck = useCallback(function() {
        var rfrrSuffix = checked ? "deselect" : "select";
        var rfrr = "HOT.SR.PROPERTY.COMPARISON.compare.".concat(rfrrSuffix);
        var linkName = checked ? "Deselect" : "Select";
        track(isAd2 ? rfrr.concat(".ad") : rfrr, "Property Comparison Compare ".concat(linkName));
        dispatch({
            type: checked ? "lodgingCompare.removeCompareProperty" : "lodgingCompare.addCompareProperty",
            payload: {
                propertyId: cardId
            }
        });
    }, [
        checked
    ]);
    var id = "lodging-card-compare-checkbox-".concat(propertyId);
    var _useContext = _slicedToArray(useContext(CompareAdaptExContext), 1), enabled = _useContext[0].enabled;
    if (!enabled) {
        return null;
    }
    return /* @__PURE__ */ React20.createElement(UitkLayoutPosition, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React20.createElement(UitkLayoutFlexItem2, {
        alignSelf: "end"
    }, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(UitkCheckbox, {
        id: isAd2 ? id.concat("-ad") : id,
        checked: checked,
        onChange: setCheck,
        disabled: disabled
    }, /* @__PURE__ */ React20.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            top: "zero",
            left: "zero",
            bottom: "zero",
            right: "minus-two"
        }
    }, /* @__PURE__ */ React20.createElement("div", null)), compareAction.label.text))));
};
LodgingCardCompareSection.fragment = fragment14;
LodgingCardCompareSection.displayName = "LodgingCardCompareSection";
// ../internal/src/components/lodging-card/__private/lodging-card-date-section.tsx
import React21 from "react";
import { gql as gql18 } from "@apollo/client";
var fragment15 = gql18(_templateObject17(), EGDSStylizedText.fragment);
var LodgingCardDateSection = function(param) {
    var data = param.data;
    var date = data.date;
    return date ? /* @__PURE__ */ React21.createElement(LodgingEGDSText, {
        data: date,
        align: "right"
    }) : null;
};
LodgingCardDateSection.fragment = fragment15;
LodgingCardDateSection.displayName = "LodgingCardDateSection";
// ../internal/src/components/lodging-card/__private/lodging-card-heading-section.tsx
import React26 from "react";
import { gql as gql23 } from "@apollo/client";
import { useHeadingLevelContext } from "@shared-ui/heading-level-context";
import { UitkIcon as UitkIcon7, UitkIconSize as UitkIconSize6 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText9 } from "uitk-react-text";
import { UitkToolbar, UitkToolbarButton } from "uitk-react-toolbar";
// ../internal/src/components/lodging-egds-rating/lodging-egds-rating.tsx
import React22 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkRating } from "uitk-react-rating";
var fragment16 = gql19(_templateObject18());
var LodgingEGDSRating = function(param) {
    var data = param.data;
    var icon = data.icon;
    var _data_accessibility;
    return /* @__PURE__ */ React22.createElement(UitkRating, {
        icon: icon === null || icon === void 0 ? void 0 : icon.id,
        rating: String(data.rating),
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    });
};
LodgingEGDSRating.fragment = fragment16;
LodgingEGDSRating.displayName = "LodgingEGDSRating";
// ../internal/src/components/lodging-card/__private/lodging-card-featured-message.tsx
import React23 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkText as UitkText7 } from "uitk-react-text";
var fragment17 = gql20(_templateObject19());
var LodgingCardFeaturedMessage = function(param) {
    var data = param.data, index = param.index;
    var icon = data.icon, text = data.text;
    return /* @__PURE__ */ React23.createElement(React23.Fragment, null, index > 0 && /* @__PURE__ */ React23.createElement(UitkText7, {
        "aria-hidden": "true",
        weight: "bold",
        size: 300
    }, "\xb7"), icon && /* @__PURE__ */ React23.createElement(UitkIcon5, {
        name: icon.id || "visibility",
        description: icon.description || "",
        size: icon.size ? UitkIconSize4[icon.size] : UitkIconSize4.SMALL,
        "data-stid": "uitk-icon"
    }), /* @__PURE__ */ React23.createElement(UitkText7, null, text));
};
LodgingCardFeaturedMessage.fragment = fragment17;
LodgingCardFeaturedMessage.displayName = "LodgingCardFeaturedMessage";
// ../internal/src/components/lodging-card/__private/lodging-product-amenity.tsx
import React25 from "react";
import { gql as gql22 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText8 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-icon/lodging-egds-icon.tsx
import React24 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
var fragment18 = gql21(_templateObject20());
var LodgingEGDSIcon = function(param) {
    var ariaHidden = param.ariaHidden, data = param.data;
    var description = data.description, id = data.id, size = data.size, theme = data.theme;
    var _ref;
    return /* @__PURE__ */ React24.createElement(UitkIcon6, {
        description: ariaHidden ? void 0 : description,
        title: ariaHidden ? void 0 : description,
        id: id,
        name: id,
        size: (_ref = size && UitkIconSize5[size]) !== null && _ref !== void 0 ? _ref : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
LodgingEGDSIcon.fragment = fragment18;
LodgingEGDSIcon.displayName = "LodgingEGDSIcon";
// ../internal/src/components/lodging-card/__private/lodging-product-amenity.tsx
var fragment19 = gql22(_templateObject21(), LodgingEGDSIcon.fragment);
var LodgingProductAmenity = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React25.createElement(UitkSpacing3, {
        margin: {
            inlineend: "three"
        },
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React25.createElement(UitkLayoutFlex2, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React25.createElement(LodgingEGDSIcon, {
        ariaHidden: true,
        data: data.icon
    }), /* @__PURE__ */ React25.createElement(UitkText8, {
        size: 200,
        overflow: "truncate"
    }, data.text)));
};
LodgingProductAmenity.fragment = fragment19;
LodgingProductAmenity.displayName = "LodgingProductAmenity";
// ../internal/src/components/lodging-card/__private/lodging-card-heading-section.tsx
var fragment20 = gql23(_templateObject22(), LodgingEGDSRating.fragment, LodgingCardFeaturedMessage.fragment, LodgingEGDSText.fragment, LodgingProductAmenity.fragment);
var LodgingCardHeadingSection = function(param) {
    var data = param.data, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 5 : _param_headingSize, wrapHeadingText = param.wrapHeadingText, showDismissButton = param.showDismissButton, // TODO: To remove this property when the test is a winner; and depend on the server response for the Icon
    onCardDismiss = param.onCardDismiss, isReview = param.isReview;
    var heading = data.heading, productRating = data.productRating, featuredMessages = data.featuredMessages, messages = data.messages, amenities = data.amenities;
    var headingLevel = useHeadingLevelContext(1).headingLevel;
    var dismissButtonProps = {
        id: "close",
        name: "close",
        size: UitkIconSize6.MEDIUM,
        title: "close"
    };
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(UitkLayoutFlex3, {
        justifyContent: "space-between",
        space: "two"
    }, /* @__PURE__ */ React26.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React26.createElement(UitkLayoutGrid, {
        rows: [
            "min-content"
        ]
    }, /* @__PURE__ */ React26.createElement(UitkLayoutGridItem, {
        rowSpan: 1
    }, featuredMessages.length > 0 && /* @__PURE__ */ React26.createElement(UitkLayoutFlex3, {
        space: "one",
        alignItems: "center"
    }, featuredMessages.map(function(featuredMessage, index) {
        return /* @__PURE__ */ React26.createElement(LodgingCardFeaturedMessage, {
            data: featuredMessage,
            key: "featuredMessage-".concat(index),
            index: index
        });
    }))), /* @__PURE__ */ React26.createElement(UitkLayoutGridItem, {
        rowSpan: 1
    }, showDismissButton && /* @__PURE__ */ React26.createElement(UitkHeading2, {
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h2",
        size: headingSize,
        overflow: "truncate-2-lines"
    }, heading) || /* @__PURE__ */ React26.createElement(UitkHeading2, {
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h2",
        size: headingSize,
        overflow: wrapHeadingText ? "wrap" : "truncate"
    }, heading)))), /* @__PURE__ */ React26.createElement(UitkLayoutFlexItem3, null, showDismissButton && onCardDismiss && /* @__PURE__ */ React26.createElement(UitkText9, null, /* @__PURE__ */ React26.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            right: "minus-three",
            top: "minus-two"
        }
    }, /* @__PURE__ */ React26.createElement(UitkToolbar, {
        elevation: "flat",
        toolbarActionContent: /* @__PURE__ */ React26.createElement(UitkToolbarButton, {
            buttonId: "close-map-card",
            onClick: onCardDismiss
        }, /* @__PURE__ */ React26.createElement(UitkIcon7, _objectSpread({}, dismissButtonProps)))
    }))))), productRating && /* @__PURE__ */ React26.createElement(LodgingEGDSRating, {
        data: productRating
    }), !isReview && (messages === null || messages === void 0 ? void 0 : messages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React26.createElement(LodgingEGDSText, {
            overflow: "truncate-2-lines",
            key: "message-".concat(messageIndex),
            spacing: "half",
            size: 300,
            data: message
        });
    })), amenities.length > 0 && /* @__PURE__ */ React26.createElement(UitkSpacing4, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React26.createElement(UitkLayoutFlex3, {
        wrap: "wrap"
    }, amenities.map(function(amenity, i) {
        return /* @__PURE__ */ React26.createElement(UitkLayoutFlexItem3, {
            key: "amenity-".concat(i)
        }, /* @__PURE__ */ React26.createElement(LodgingProductAmenity, {
            data: amenity
        }));
    }))));
};
LodgingCardHeadingSection.fragment = fragment20;
LodgingCardHeadingSection.displayName = "LodgingCardHeadingSection";
// ../internal/src/components/lodging-card/__private/lodging-card-marketing-fee-detail.tsx
import React27 from "react";
import { gql as gql24 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { UitkDialog as UitkDialog2, UitkDialogContent as UitkDialogContent2, UitkDialogFooter as UitkDialogFooter2 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon8, UitkIconSize as UitkIconSize7 } from "uitk-react-icons";
import { UitkMark as UitkMark3, UitkMarkSize as UitkMarkSize3 } from "uitk-react-mark";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText10 } from "uitk-react-text";
var fragment21 = gql24(_templateObject23());
var LodgingCardMarketingFeeDetail = function(param) {
    var id = param.id, data = param.data;
    var tierMessage = data.tierMessage, marketingFeeMessageDialog = data.marketingFeeMessageDialog;
    var marketingFeeDialogId = id ? "priceMarketingFeeDialog-".concat(id) : "priceMarketingFeeDialog";
    var _useDialog2 = _slicedToArray(useDialog2(marketingFeeDialogId, "pwaDialog"), 3), isDialogOpen = _useDialog2[0], dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    var track = useClickTracker5();
    var openDialog = function() {
        track("TAAP.MarketingFee.Details", "Open SRP Commission Information Dialog");
        dialogActions.openDialog();
    };
    if (!marketingFeeMessageDialog || !tierMessage) {
        return null;
    }
    return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(UitkMoreInfoTrigger, {
        onClick: openDialog,
        "data-stid": "marketing-fee-info"
    }, /* @__PURE__ */ React27.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React27.createElement(UitkSpacing5, {
        padding: {
            inlineend: "two"
        }
    }, tierMessage.egdsMark && /* @__PURE__ */ React27.createElement(UitkMark3, {
        name: tierMessage.egdsMark.id,
        size: UitkMarkSize3.SMALL
    })), /* @__PURE__ */ React27.createElement(UitkText10, {
        overflow: "truncate",
        inline: true
    }, tierMessage.value), /* @__PURE__ */ React27.createElement(UitkIcon8, {
        name: "info_outline",
        size: UitkIconSize7.SMALL
    }))), /* @__PURE__ */ React27.createElement(DialogComponent, null, /* @__PURE__ */ React27.createElement(UitkDialog2, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React27.createElement(UitkDialogContent2, null, marketingFeeMessageDialog.content.map(function(content, index) {
        return /* @__PURE__ */ React27.createElement(UitkText10, {
            key: "marketing-fee-message-".concat(index)
        }, content);
    }), /* @__PURE__ */ React27.createElement(UitkDialogFooter2, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: marketingFeeMessageDialog.dialog.footer.buttons[0].primary || "",
            type: "tertiary"
        }
    })))));
};
LodgingCardMarketingFeeDetail.fragment = fragment21;
LodgingCardMarketingFeeDetail.displayName = "LodgingCardMarketingFeeDetail";
// ../internal/src/components/lodging-card/__private/lodging-card-product-summary-section.tsx
import React41 from "react";
import { gql as gql37 } from "@apollo/client";
import { useHeadingLevelContext as useHeadingLevelContext2 } from "@shared-ui/heading-level-context";
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
// ../internal/src/components/lodging-card/__private/lodging-card-change-unit-dialog-action.tsx
import React31 from "react";
import { gql as gql27 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { usePackageOperations } from "@shared-ui/multi-item-operations-providers";
import { UitkDialogContent as UitkDialogContent3 } from "uitk-react-dialog";
import { UitkSheet } from "uitk-react-sheet";
// ../internal/src/components/egds/egds-toolbar/egds-dialog-toolbar.tsx
import React28 from "react";
import { gql as gql25 } from "@apollo/client";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
var fragment22 = gql25(_templateObject24());
var EGDSDialogToolbar = function(param) {
    var data = param.data, toolbarType = param.toolbarType, toolbarAction = param.toolbarAction;
    var _data_closeText;
    return /* @__PURE__ */ React28.createElement(UitkToolbar2, {
        toolbarTitle: data.title,
        navigationContent: {
            onClick: toolbarAction,
            navType: toolbarType,
            navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : void 0
        }
    });
};
EGDSDialogToolbar.fragment = fragment22;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";
// ../internal/src/components/lodging-card/lodging-card-content-provider.tsx
import React29 from "react";
var LodgingCardContentContext = React29.createContext(void 0);
var useLodgingCardContentContext = function() {
    var context = React29.useContext(LodgingCardContentContext);
    if (context === void 0) {
        throw new Error("useLodgingCardContentContext must be used with a ILodgingCardContentContext.Provider");
    }
    return context;
};
// ../internal/src/components/lodging-card/__private/lodging-card-more-details-trigger.tsx
import React30 from "react";
import { gql as gql26 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton } from "uitk-react-button";
var fragment23 = gql26(_templateObject25(), LodgingEGDSIcon.fragment);
var LodgingCardMoreDetailsTrigger = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, accessibilityLabel = _param_data.accessibilityLabel, analytics = _param_data.analytics, icon = _param_data.icon, label = _param_data.label;
    var track = useClickTracker6();
    var onClick = function() {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        track(referrerId, linkName);
        onClickAction();
    };
    return /* @__PURE__ */ React30.createElement(UitkSecondaryButton, {
        onClick: onClick,
        "aria-label": accessibilityLabel,
        domRef: triggerRef
    }, /* @__PURE__ */ React30.createElement(React30.Fragment, null, label, icon && /* @__PURE__ */ React30.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingCardMoreDetailsTrigger.fragment = fragment23;
LodgingCardMoreDetailsTrigger.displayName = "LodgingCardMoreDetailsTrigger";
// ../internal/src/components/lodging-card/__private/lodging-card-change-unit-dialog-action.tsx
var fragment24 = gql27(_templateObject26(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsTrigger.fragment);
var LodgingCardChangeUnitDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var track = useClickTracker7();
    var triggerRef = React31.useRef(null);
    var _useDialog3 = _slicedToArray(useDialog3("LodgingCardChangeUnitDialog"), 3), lodgingCardChangeUnitDialogActions = _useDialog3[1], LodgingCardChangeUnitDialogComponent = _useDialog3[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardChangeUnitDialogActions.closeDialog();
    };
    var openDialogWithButton = function() {
        if (lodgingCardChangeUnitDialogActions) {
            lodgingCardChangeUnitDialogActions.openDialog();
        }
    };
    var state = usePackageOperations().state;
    React31.useEffect(function() {
        if (state.selectPackage.status === "IN_PROGRESS") {
            lodgingCardChangeUnitDialogActions.closeDialog();
        }
    }, [
        state.selectPackage.status
    ]);
    var ChangeUnitContent = useLodgingCardContentContext().ChangeUnitContent;
    return /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(LodgingCardMoreDetailsTrigger, {
        onClickAction: openDialogWithButton,
        data: trigger,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React31.createElement(LodgingCardChangeUnitDialogComponent, null, /* @__PURE__ */ React31.createElement(UitkSheet, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React31.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React31.createElement(UitkDialogContent3, null, /* @__PURE__ */ React31.createElement(ChangeUnitContent, null)))));
};
LodgingCardChangeUnitDialogAction.fragment = fragment24;
LodgingCardChangeUnitDialogAction.displayName = "LodgingCardChangeUnitDialogAction";
// ../internal/src/components/lodging-card/__private/lodging-card-change-unit-sheet-action.tsx
import React32 from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { usePackageOperations as usePackageOperations2 } from "@shared-ui/multi-item-operations-providers";
import { ViewExtraLarge, ViewLarge, ViewMedium, Viewport } from "@shared-ui/viewport-context";
import { UitkSheet as UitkSheet2, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
var fragment25 = gql28(_templateObject27(), LodgingCardMoreDetailsTrigger.fragment);
var SheetContent = function() {
    var ChangeUnitContent = useLodgingCardContentContext().ChangeUnitContent;
    return /* @__PURE__ */ React32.createElement(UitkSheetContent, {
        padded: false
    }, /* @__PURE__ */ React32.createElement(UitkSpacing6, {
        padding: "three"
    }, /* @__PURE__ */ React32.createElement("div", null, /* @__PURE__ */ React32.createElement(ChangeUnitContent, null))));
};
var LodgingCardChangeUnitSheetAction = function(param) {
    var _param_data = param.data, sheet = _param_data.sheet, trigger = _param_data.trigger;
    var track = useClickTracker8();
    var _React32_useState = _slicedToArray(React32.useState(false), 2), visible = _React32_useState[0], setVisible = _React32_useState[1];
    var toggleSideSheet = function() {
        setVisible(function(prevState) {
            return !prevState;
        });
    };
    var closeButtonAction = function() {
        var _sheet_closeAnalytics = sheet.closeAnalytics, referrerId = _sheet_closeAnalytics.referrerId, linkName = _sheet_closeAnalytics.linkName;
        track(referrerId, linkName);
        setVisible(false);
    };
    var state = usePackageOperations2().state;
    React32.useEffect(function() {
        if (state.selectPackage.status === "SUCCESS" || state.selectPackage.status === "FAILURE") {
            setVisible(false);
        }
    }, [
        state.selectPackage.status
    ]);
    var commonUitkSheetProps = {
        isVisible: visible,
        type: "side",
        triggerRef: null
    };
    var renderToolbar = function() {
        var _sheet_closeText;
        return /* @__PURE__ */ React32.createElement(UitkToolbar3, {
            navigationContent: {
                onClick: closeButtonAction,
                navIconLabel: (_sheet_closeText = sheet.closeText) !== null && _sheet_closeText !== void 0 ? _sheet_closeText : ""
            }
        });
    };
    return /* @__PURE__ */ React32.createElement(React32.Fragment, null, /* @__PURE__ */ React32.createElement(LodgingCardMoreDetailsTrigger, {
        onClickAction: toggleSideSheet,
        data: trigger
    }), /* @__PURE__ */ React32.createElement(Viewport, null, /* @__PURE__ */ React32.createElement(ViewMedium, null, /* @__PURE__ */ React32.createElement(UitkSheet2, _objectSpreadProps(_objectSpread({}, commonUitkSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 6
        }
    }), renderToolbar(), /* @__PURE__ */ React32.createElement(SheetContent, null))), /* @__PURE__ */ React32.createElement(ViewLarge, null, /* @__PURE__ */ React32.createElement(UitkSheet2, _objectSpreadProps(_objectSpread({}, commonUitkSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 4
        }
    }), renderToolbar(), /* @__PURE__ */ React32.createElement(SheetContent, null))), /* @__PURE__ */ React32.createElement(ViewExtraLarge, null, /* @__PURE__ */ React32.createElement(UitkSheet2, _objectSpreadProps(_objectSpread({}, commonUitkSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 4
        }
    }), renderToolbar(), /* @__PURE__ */ React32.createElement(SheetContent, null)))));
};
LodgingCardChangeUnitSheetAction.fragment = fragment25;
LodgingCardChangeUnitSheetAction.displayName = "LodgingCardChangeUnitSheetAction";
// ../internal/src/components/lodging-card/__private/lodging-card-guest-rating.tsx
import React33 from "react";
import { gql as gql29 } from "@apollo/client";
import { UitkIcon as UitkIcon9, UitkIconSize as UitkIconSize8 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
var fragment26 = gql29(_templateObject28(), LodgingEGDSText.fragment, EGDSStylizedText.fragment);
var GuestReviewRating = function(param) {
    var part = param.part, index = param.index, isReview = param.isReview, size = param.size;
    return /* @__PURE__ */ React33.createElement(UitkLayoutFlexItem4, null, isReview ? /* @__PURE__ */ React33.createElement(UitkSpacing7, {
        margin: index === 1 ? {
            inlineend: "two"
        } : {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React33.createElement("span", null, /* @__PURE__ */ React33.createElement(LodgingEGDSText, {
        data: part,
        inline: true,
        size: size
    }))) : /* @__PURE__ */ React33.createElement(UitkSpacing7, {
        padding: index === 0 ? {
            inlineend: "half"
        } : {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React33.createElement("span", null, /* @__PURE__ */ React33.createElement(LodgingEGDSText, {
        data: part,
        inline: true,
        size: size
    }))));
};
var LodgingCardGuestRating = function(param) {
    var data = param.data, size = param.size, isReview = param.isReview;
    var parts = data.parts, accessibilityLabel = data.accessibilityLabel, phraseParts = data.phraseParts;
    var ratingPart = phraseParts === null || phraseParts === void 0 ? void 0 : phraseParts.find(function(part) {
        return part.__typename === "EGDSIconRating";
    });
    return /* @__PURE__ */ React33.createElement(UitkLayoutFlex4, {
        alignItems: "start"
    }, ratingPart && /* @__PURE__ */ React33.createElement(UitkLayoutFlexItem4, {
        alignSelf: "center"
    }, /* @__PURE__ */ React33.createElement(UitkIcon9, {
        name: ratingPart.icon.token || "star",
        theme: ratingPart.icon.theme || "default",
        size: ratingPart.icon.size ? UitkIconSize8[ratingPart.icon.size] : UitkIconSize8.EXTRA_SMALL
    })), /* @__PURE__ */ React33.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React33.createElement("div", {
        "aria-hidden": !!accessibilityLabel
    }, /* @__PURE__ */ React33.createElement(UitkLayoutFlex4, {
        wrap: "wrap"
    }, parts.map(function(part, index) {
        return /* @__PURE__ */ React33.createElement(GuestReviewRating, {
            key: "guest-rate-".concat(index),
            part: part,
            index: index,
            isReview: isReview,
            size: size
        });
    })))), accessibilityLabel && /* @__PURE__ */ React33.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel));
};
LodgingCardGuestRating.fragment = fragment26;
LodgingCardGuestRating.displayName = "LodgingCardGuestRating";
// ../internal/src/components/lodging-card/__private/lodging-card-property-dialog-action.tsx
import React37 from "react";
import { gql as gql33 } from "@apollo/client";
// ../internal/src/components/lodging-card/__private/lodging-card-property-details-dialog-action.tsx
import React35 from "react";
import { gql as gql31 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent4 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex5 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet3 } from "uitk-react-sheet";
// ../internal/src/components/lodging-card/__private/lodging-card-more-details-link-trigger.tsx
import React34 from "react";
import { gql as gql30 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
var fragment27 = gql30(_templateObject29(), LodgingEGDSIcon.fragment);
var LodgingCardMoreDetailsLinkTrigger = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, accessibilityLabel = _param_data.accessibilityLabel, analytics = _param_data.analytics, icon = _param_data.icon, label = _param_data.label;
    var track = useClickTracker9();
    var onClick = function() {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        track(referrerId, linkName);
        onClickAction();
    };
    return /* @__PURE__ */ React34.createElement(UitkLink2, {
        onClick: onClick,
        "aria-label": accessibilityLabel
    }, /* @__PURE__ */ React34.createElement("button", {
        type: "button",
        ref: triggerRef
    }, label, icon && /* @__PURE__ */ React34.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingCardMoreDetailsLinkTrigger.fragment = fragment27;
LodgingCardMoreDetailsLinkTrigger.displayName = "LodgingCardMoreDetailsLinkTrigger";
// ../internal/src/components/lodging-card/__private/lodging-card-property-details-dialog-action.tsx
var fragment28 = gql31(_templateObject30(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsLinkTrigger.fragment);
var LodgingCardPropertyDetailsDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var PropertyDetailsContent = useLodgingCardContentContext().PropertyDetailsContent;
    var track = useClickTracker10();
    var triggerRef = React35.useRef(null);
    var _useDialog4 = _slicedToArray(useDialog4("LodgingCardPropertyDetailsDialog"), 3), lodgingCardPropertyDetailsDialogActions = _useDialog4[1], LodgingCardPropertyDetailsDialogComponent = _useDialog4[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardPropertyDetailsDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React35.createElement(React35.Fragment, null, /* @__PURE__ */ React35.createElement(UitkLayoutFlex5, null, /* @__PURE__ */ React35.createElement(LodgingCardMoreDetailsLinkTrigger, {
        onClickAction: lodgingCardPropertyDetailsDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    })), /* @__PURE__ */ React35.createElement(LodgingCardPropertyDetailsDialogComponent, null, /* @__PURE__ */ React35.createElement(UitkSheet3, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React35.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React35.createElement(UitkDialogContent4, null, /* @__PURE__ */ React35.createElement(PropertyDetailsContent, null)))));
};
LodgingCardPropertyDetailsDialogAction.fragment = fragment28;
LodgingCardPropertyDetailsDialogAction.displayName = "LodgingCardPropertyDetailsDialogAction";
// ../internal/src/components/lodging-card/__private/lodging-card-unit-details-dialog-action.tsx
import React36 from "react";
import { gql as gql32 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex6 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet4, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
var fragment29 = gql32(_templateObject31(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsLinkTrigger.fragment);
var LodgingCardUnitDetailsDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var RoomDetailsContent = useLodgingCardContentContext().RoomDetailsContent;
    var track = useClickTracker11();
    var triggerRef = React36.useRef(null);
    var _useDialog5 = _slicedToArray(useDialog5("LodgingCardPropertyRoomDetailsDialog"), 3), isDialogOpen = _useDialog5[0], lodgingCardPropertyRoomDetailsDialogActions = _useDialog5[1], LodgingCardPropertyRoomDetailsDialogComponent = _useDialog5[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardPropertyRoomDetailsDialogActions.closeDialog();
    };
    var dialogContent = /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React36.createElement(UitkSheetContent2, {
        padded: false
    }, /* @__PURE__ */ React36.createElement(dialog_context_default.Provider, {
        value: true
    }, /* @__PURE__ */ React36.createElement(RoomDetailsContent, null))));
    var sheetProps = {
        isVisible: isDialogOpen,
        triggerRef: triggerRef
    };
    return /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(UitkLayoutFlex6, null, /* @__PURE__ */ React36.createElement(LodgingCardMoreDetailsLinkTrigger, {
        onClickAction: lodgingCardPropertyRoomDetailsDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    })), /* @__PURE__ */ React36.createElement(LodgingCardPropertyRoomDetailsDialogComponent, null, /* @__PURE__ */ React36.createElement(Viewport2, null, /* @__PURE__ */ React36.createElement(ViewSmall, null, /* @__PURE__ */ React36.createElement(UitkSheet4, _objectSpreadProps(_objectSpread({}, sheetProps), {
        type: "full"
    }), dialogContent)), /* @__PURE__ */ React36.createElement(ViewMedium2, null, /* @__PURE__ */ React36.createElement(UitkSheet4, _objectSpreadProps(_objectSpread({}, sheetProps), {
        type: "centered"
    }), dialogContent)))));
};
LodgingCardUnitDetailsDialogAction.fragment = fragment29;
LodgingCardUnitDetailsDialogAction.displayName = "LodgingCardUnitDetailsDialogAction";
// ../internal/src/components/lodging-card/__private/lodging-card-property-dialog-action.tsx
var fragment30 = gql33(_templateObject32(), LodgingCardPropertyDetailsDialogAction.fragment, LodgingCardUnitDetailsDialogAction.fragment);
var LodgingCardPropertyDialogAction = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "LodgingCardPropertyDetailsDialog":
            return /* @__PURE__ */ React37.createElement(LodgingCardPropertyDetailsDialogAction, {
                data: data
            });
        case "LodgingCardUnitDetailsDialog":
            return /* @__PURE__ */ React37.createElement(LodgingCardUnitDetailsDialogAction, {
                data: data
            });
        default:
            return null;
    }
};
LodgingCardPropertyDialogAction.fragment = fragment30;
LodgingCardPropertyDialogAction.displayName = "LodgingCardPropertyDialogAction";
// ../internal/src/components/lodging-card/__private/lodging-product-description.tsx
import React38 from "react";
import { gql as gql34 } from "@apollo/client";
import { UitkText as UitkText11 } from "uitk-react-text";
var fragment31 = gql34(_templateObject33());
var LodgingCardPropertyDescriptionSection = function(param) {
    var data = param.data, isReview = param.isReview;
    var heading = data.heading, description = data.description;
    return /* @__PURE__ */ React38.createElement(React38.Fragment, null, heading && /* @__PURE__ */ React38.createElement(UitkText11, {
        size: 200,
        weight: "bold"
    }, heading.text), description && /* @__PURE__ */ React38.createElement(UitkText11, {
        size: 200,
        overflow: isReview ? "truncate-4-lines" : void 0
    }, description.text));
};
LodgingCardPropertyDescriptionSection.fragment = fragment31;
LodgingCardPropertyDescriptionSection.displayName = "LodgingCardPropertyDescriptionSection";
// ../internal/src/components/lodging-card/__private/lodging-product-footer-messages.tsx
import React39 from "react";
import { gql as gql35 } from "@apollo/client";
import { UitkAvatar } from "uitk-react-avatar";
import { UitkLayoutFlex as UitkLayoutFlex7 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark4, UitkMarkSize as UitkMarkSize4 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkText as UitkText12 } from "uitk-react-text";
import { UitkUnformattedHtml } from "uitk-react-unformatted-html";
var _obj7;
// ../internal/src/components/lodging-card/__private/uitk-text-theme-mapper.tsx
var UitkTextThemeMapper = (_obj7 = {}, _defineProperty(_obj7, "NEGATIVE" /* NEGATIVE */ , "negative"), _defineProperty(_obj7, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj7, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _defineProperty(_obj7, "LOYALTY" /* LOYALTY */ , "loyalty"), _defineProperty(_obj7, "DEFAULT" /* DEFAULT */ , "default"), _obj7);
// ../internal/src/components/lodging-card/__private/lodging-product-footer-messages.tsx
var fragment32 = gql35(_templateObject34());
var LodgingProductFooterMessages = function(param) {
    var data = param.data, isReview = param.isReview;
    var _mark_url;
    var style = data.style, text = data.text, mark = data.mark, egdsElementId = data.egdsElementId;
    var hasGraphic = mark && mark.id.length > 0;
    var theme = style ? UitkTextThemeMapper[style] : void 0;
    var plainTextElement = function(props) {
        return /* @__PURE__ */ React39.createElement("span", null, props.children || null);
    };
    var message = /* @__PURE__ */ React39.createElement(UitkText12, {
        inline: !!hasGraphic,
        theme: theme
    }, /* @__PURE__ */ React39.createElement(UitkUnformattedHtml, {
        plainTextElement: plainTextElement,
        htmlToParse: text
    }));
    var stayedDate = "stayed_date";
    var reviewAuthor = "review_author";
    if (isReview) {
        switch(egdsElementId){
            case stayedDate:
                return /* @__PURE__ */ React39.createElement(UitkSpacing8, {
                    padding: {
                        blockstart: "one"
                    }
                }, /* @__PURE__ */ React39.createElement(UitkLayoutFlex7, {
                    wrap: "wrap",
                    direction: "row",
                    alignItems: "center"
                }, /* @__PURE__ */ React39.createElement(UitkText12, {
                    size: 200
                }, text)));
            case reviewAuthor:
                return /* @__PURE__ */ React39.createElement(UitkSpacing8, {
                    padding: {
                        blockstart: "four"
                    }
                }, /* @__PURE__ */ React39.createElement(UitkLayoutFlex7, {
                    wrap: "wrap",
                    direction: "row",
                    alignItems: "center"
                }, /* @__PURE__ */ React39.createElement(UitkAvatar, {
                    size: "small"
                }), /* @__PURE__ */ React39.createElement(UitkSpacing8, {
                    padding: {
                        inlinestart: "one"
                    }
                }, /* @__PURE__ */ React39.createElement(UitkText12, {
                    weight: "bold"
                }, text))));
            default:
                return null;
        }
    }
    return hasGraphic ? /* @__PURE__ */ React39.createElement(UitkSpacing8, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(UitkSpacing8, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React39.createElement(UitkMark4, {
        name: mark === null || mark === void 0 ? void 0 : mark.id,
        url: mark === null || mark === void 0 ? void 0 : (_mark_url = mark.url) === null || _mark_url === void 0 ? void 0 : _mark_url.value,
        description: mark === null || mark === void 0 ? void 0 : mark.description,
        size: UitkMarkSize4.SMALL
    })), message)) : message;
};
LodgingProductFooterMessages.fragment = fragment32;
LodgingProductFooterMessages.displayName = "LodgingProductFooterMessages";
// ../internal/src/components/lodging-card/__private/lodging-product-spannable-footer-messages.tsx
import React40 from "react";
import { gql as gql36 } from "@apollo/client";
import { UitkMark as UitkMark5, UitkMarkSize as UitkMarkSize5 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkText as UitkText13 } from "uitk-react-text";
var fragment33 = gql36(_templateObject35(), EGDSSpannableText.fragment);
var LodgingProductSpannableFooterMessages = function(param) {
    var data = param.data;
    var _graphic_url;
    var style = data.style, text = data.text, graphic = data.graphic, stylizedText = data.stylizedText;
    var hasMark = graphic && graphic.id.length > 0 && graphic.__typename === "Mark";
    var theme = style ? UitkTextThemeMapper[style] : void 0;
    var hasSpannableData = stylizedText && stylizedText.__typename === "EGDSSpannableText";
    return hasMark && hasSpannableData ? /* @__PURE__ */ React40.createElement(UitkSpacing9, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement(UitkSpacing9, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React40.createElement(UitkMark5, {
        name: graphic.id,
        url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
        description: graphic.description,
        size: UitkMarkSize5.SMALL
    })), /* @__PURE__ */ React40.createElement(EGDSSpannableText, {
        data: stylizedText
    }))) : /* @__PURE__ */ React40.createElement(UitkText13, {
        theme: theme
    }, text);
};
LodgingProductSpannableFooterMessages.fragment = fragment33;
LodgingProductSpannableFooterMessages.displayName = "LodgingProductFooterMessages";
// ../internal/src/components/lodging-card/__private/lodging-card-product-summary-section.tsx
var fragment34 = gql37(_templateObject36(), LodgingEGDSHeading.fragment, LodgingProductAmenity.fragment, LodgingEGDSText.fragment, LodgingCardPropertyDescriptionSection.fragment, LodgingCardChangeUnitDialogAction.fragment, LodgingCardChangeUnitSheetAction.fragment, LodgingCardPropertyDialogAction.fragment, LodgingCardGuestRating.fragment, LodgingProductFooterMessages.fragment, LodgingProductSpannableFooterMessages.fragment);
var LodgingCardProductSummarySection = function(param) {
    var data = param.data, view = param.view, isReview = param.isReview;
    var renderFooterMessage = function renderFooterMessage(footerMessage, footerMessageIndex) {
        switch(footerMessage.__typename){
            case "EGDSTextWithMarkListItem":
                return /* @__PURE__ */ React41.createElement(LodgingProductFooterMessages, {
                    data: footerMessage,
                    key: "message-".concat(footerMessageIndex),
                    isReview: isReview
                });
            case "EarnMessageContainerListItem":
                return /* @__PURE__ */ React41.createElement(LodgingProductSpannableFooterMessages, {
                    data: footerMessage,
                    key: "message-".concat(footerMessageIndex)
                });
            default:
                return null;
        }
    };
    var _footerMessages_listItems;
    var heading = data.heading, messages = data.messages, descriptionSection = data.descriptionSection, amenities = data.amenities, changeActionDialog = data.changeActionDialog, changeActionSheet = data.changeActionSheet, detailsAction = data.detailsAction, guestRating = data.guestRating, footerMessages = data.footerMessages;
    var isResponsiveView = !isCompactView(view);
    var headingLevel = useHeadingLevelContext2(2).headingLevel;
    return /* @__PURE__ */ React41.createElement(UitkLayoutFlex8, {
        direction: "column",
        space: "three"
    }, heading && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React41.createElement(LodgingEGDSHeading, {
        size: 7,
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h3",
        data: heading
    })), messages.length > 0 && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React41.createElement("div", null, messages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React41.createElement(LodgingEGDSText, {
            overflow: "truncate-2-lines",
            key: "message-".concat(messageIndex),
            spacing: "half",
            size: 300,
            data: message
        });
    }))), amenities.length > 0 && /* @__PURE__ */ React41.createElement(UitkLayoutFlex8, {
        wrap: "wrap"
    }, amenities.map(function(amenity, i) {
        return /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, {
            key: "amenity-".concat(i)
        }, /* @__PURE__ */ React41.createElement(LodgingProductAmenity, {
            data: amenity
        }));
    })), isReview && guestRating && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React41.createElement(LodgingCardGuestRating, {
        data: guestRating,
        isReview: isReview
    })), isResponsiveView && descriptionSection && /* @__PURE__ */ React41.createElement(Viewport3, null, /* @__PURE__ */ React41.createElement(ViewLarge2, null, /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, {
        minWidth: "16x"
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(LodgingCardPropertyDescriptionSection, {
        data: descriptionSection,
        isReview: isReview
    }))))), isReview && descriptionSection && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, {
        minWidth: "16x"
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(LodgingCardPropertyDescriptionSection, {
        data: descriptionSection,
        isReview: isReview
    }))), footerMessages && ((_footerMessages_listItems = footerMessages.listItems) === null || _footerMessages_listItems === void 0 ? void 0 : _footerMessages_listItems.length) > 0 && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React41.createElement("div", null, footerMessages.listItems.map(function(footerMessage, footerMessageIndex) {
        return /* @__PURE__ */ React41.createElement("div", {
            key: "footer-message-".concat(footerMessageIndex)
        }, renderFooterMessage(footerMessage, footerMessageIndex));
    }))), !isReview && guestRating && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React41.createElement(LodgingCardGuestRating, {
        data: guestRating,
        isReview: isReview
    })), detailsAction && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React41.createElement(LodgingCardPropertyDialogAction, {
        data: detailsAction
    })), changeActionDialog && changeActionSheet && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React41.createElement(UitkSpacing10, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(Viewport3, null, /* @__PURE__ */ React41.createElement(ViewSmall2, null, /* @__PURE__ */ React41.createElement(LodgingCardChangeUnitDialogAction, {
        data: changeActionDialog
    })), /* @__PURE__ */ React41.createElement(ViewMedium3, null, /* @__PURE__ */ React41.createElement(LodgingCardChangeUnitSheetAction, {
        data: changeActionSheet
    })))))));
};
LodgingCardProductSummarySection.fragment = fragment34;
LodgingCardProductSummarySection.displayName = "LodgingCardProductSummarySection";
// ../internal/src/components/lodging-card/__private/lodging-mod-sign-in-button.tsx
import React42, { useEffect } from "react";
import { IntersectionTracker as IntersectionTracker2, ITrackType as ITrackType2, useClickstreamAnalytics, useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { useInView } from "react-intersection-observer";
import { UitkButtonSize as UitkButtonSize2, UitkPrimaryAltButton } from "uitk-react-button";
import { UitkIcon as UitkIcon10 } from "uitk-react-icons";
import { UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
var LodgingMODSignInButton = function(param) {
    var action = param.action, analytics = param.analytics, attemptEvents = param.attemptEvents, icon = param.icon, primary = param.primary, successEvents = param.successEvents, adaptexSuccessActionTracking = param.adaptexSuccessActionTracking;
    var _componentAnalytics_impressed, _componentAnalytics_impressed1;
    var _useAdaptExEvents = useAdaptExEvents(adaptexSuccessActionTracking !== null && adaptexSuccessActionTracking !== void 0 ? adaptexSuccessActionTracking : []), propertyListingAdaptExSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var trackClick = useClickTracker12();
    var _useInView = useInView({
        triggerOnce: true,
        threshold: 0.8
    }), ref = _useInView.ref, inView = _useInView.inView;
    var track = useClickstreamAnalytics().track;
    var componentAnalytics = {
        click: action === null || action === void 0 ? void 0 : action.analytics,
        impressed: analytics
    };
    useEffect(function() {
        if (inView && attemptEvents.length) {
            var attemptEvent = attemptEvents[0];
            track(ITrackType2.EVENT, {
                data: adaptToAdaptExSuccessEventSchema(_objectSpreadProps(_objectSpread({}, attemptEvent), {
                    events: [
                        attemptEvent.events[0]
                    ]
                }))
            });
        }
    }, [
        attemptEvents,
        inView,
        track
    ]);
    var handleOnClick = function() {
        var _componentAnalytics_click, _componentAnalytics_click1;
        if (((_componentAnalytics_click = componentAnalytics.click) === null || _componentAnalytics_click === void 0 ? void 0 : _componentAnalytics_click.referrerId) && ((_componentAnalytics_click1 = componentAnalytics.click) === null || _componentAnalytics_click1 === void 0 ? void 0 : _componentAnalytics_click1.linkName)) {
            trackClick(componentAnalytics.click.referrerId, componentAnalytics.click.linkName);
        }
        if (successEvents.length) {
            var successEvent = successEvents[0];
            track(ITrackType2.EVENT, {
                data: adaptToAdaptExSuccessEventSchema(_objectSpreadProps(_objectSpread({}, successEvent), {
                    events: [
                        successEvent.events[0]
                    ]
                }))
            });
        }
        if (propertyListingAdaptExSuccessEvents.length) {
            propertyListingAdaptExSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType2.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    };
    var content = /* @__PURE__ */ React42.createElement(UitkLayoutFlexItem6, {
        alignSelf: "end"
    }, /* @__PURE__ */ React42.createElement(UitkPrimaryAltButton, {
        domRef: ref,
        onClick: handleOnClick,
        type: "button",
        tag: "a",
        href: action === null || action === void 0 ? void 0 : action.resource.value,
        size: UitkButtonSize2.SMALL
    }, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React42.createElement(UitkIcon10, {
        name: icon.id
    }), primary));
    var MODSignInButtonWithImpressionTracking = ((_componentAnalytics_impressed = componentAnalytics.impressed) === null || _componentAnalytics_impressed === void 0 ? void 0 : _componentAnalytics_impressed.referrerId) && ((_componentAnalytics_impressed1 = componentAnalytics.impressed) === null || _componentAnalytics_impressed1 === void 0 ? void 0 : _componentAnalytics_impressed1.linkName) ? /* @__PURE__ */ React42.createElement(IntersectionTracker2, {
        referrerId: componentAnalytics.impressed.referrerId,
        linkName: componentAnalytics.impressed.linkName,
        trackOnce: true
    }, content) : content;
    return MODSignInButtonWithImpressionTracking;
};
LodgingMODSignInButton.displayName = "LodgingMODSignInButton";
// ../internal/src/components/lodging-card/__private/lodging-card-content-section.tsx
var fragment35 = gql38(_templateObject37(), AdaptExAnalyticsEventFragment, LodgingCardHeadingSection.fragment, LodgingCardProductSummarySection.fragment, PriceSummaryFragment, LodgingCardMarketingFeeDetail.fragment, LodgingCardCompareSection.fragment, LodgingCardDateSection.fragment, LodgingBadge.fragment, LodgingStandardBadge.fragment, LodgingEGDSText.fragment, AdaptexTrackingFragment);
var LodgingCardContentSection = function(param) {
    var data = param.data, isAd2 = param.isAd, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 5 : _param_headingSize, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, wrapHeadingText = param.wrapHeadingText, isReview = param.isReview, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _priceSection_priceSummary;
    var headingSection = data.headingSection, priceSection = data.priceSection, callOut = data.callOut, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection, id = data.id;
    var hasRightColumn = callOut || priceSection || dateSection;
    var isCompact = isCompactView(view);
    var columns;
    if (!isReview) {
        columns = {
            small: [
                "1fr",
                "2fr",
                "2fr"
            ],
            medium: [
                "1fr",
                "2fr",
                "2fr"
            ],
            large: [
                "1fr",
                "max-content",
                "max-content"
            ]
        };
    }
    return /* @__PURE__ */ React43.createElement(React43.Fragment, null, headingSection && /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React43.createElement(UitkSpacing11, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(HeadingLevelProvider, {
        topHeadingLevel: 4
    }, /* @__PURE__ */ React43.createElement(LodgingCardHeadingSection, {
        data: headingSection,
        headingSize: headingSize,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview
    }))))), /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React43.createElement(UitkLayoutGrid2, {
        space: "one",
        columns: columns
    }, /* @__PURE__ */ React43.createElement(UitkLayoutGridItem2, {
        colSpan: hasRightColumn ? 2 : 3,
        alignSelf: "end"
    }, /* @__PURE__ */ React43.createElement("div", null, summarySections.map(function(summarySection, index) {
        return /* @__PURE__ */ React43.createElement(React43.Fragment, {
            key: "summary-section-".concat(index)
        }, index > 0 && /* @__PURE__ */ React43.createElement(UitkSpacingHr, {
            blockMargin: "three"
        }), /* @__PURE__ */ React43.createElement(LodgingCardProductSummarySection, {
            data: summarySection,
            view: view,
            isReview: isReview
        }));
    }))), hasRightColumn && /* @__PURE__ */ React43.createElement(UitkLayoutGridItem2, {
        colSpan: 1,
        justifySelf: "end",
        alignSelf: "end"
    }, callOut && /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(LodgingEGDSText, {
        data: callOut,
        align: "right"
    })), !isReview && priceSection && /* @__PURE__ */ React43.createElement(UitkLayoutFlex9, {
        direction: "column"
    }, !isCompact && /* @__PURE__ */ React43.createElement(Viewport4, null, /* @__PURE__ */ React43.createElement(ViewMedium4, null, /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem7, {
        alignSelf: "end"
    }, /* @__PURE__ */ React43.createElement(LodgingStandardBadge, {
        data: priceSection.standardBadge,
        propertyId: id
    }), " "))), /* @__PURE__ */ React43.createElement(PriceSectionPriceSummary, {
        priceSection: priceSection,
        enableInlineLink: enableInlineLink
    }), ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : _priceSection_priceSummary.marketingFeeDetails) && /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem7, {
        alignSelf: "end"
    }, /* @__PURE__ */ React43.createElement(UitkSpacing11, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(LodgingCardMarketingFeeDetail, {
        data: priceSection.priceSummary.marketingFeeDetails,
        id: id
    })))), (priceSection === null || priceSection === void 0 ? void 0 : priceSection.button) && /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem7, {
        alignSelf: "end"
    }, /* @__PURE__ */ React43.createElement(UitkLayoutPosition3, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React43.createElement(UitkSpacing11, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(LodgingMODSignInButton, _objectSpread({}, priceSection.button)))))), (dateSection === null || dateSection === void 0 ? void 0 : dateSection.date) && /* @__PURE__ */ React43.createElement(UitkLayoutFlexItem7, {
        alignSelf: "end"
    }, /* @__PURE__ */ React43.createElement(UitkSpacing11, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(LodgingCardDateSection, {
        data: dateSection
    })))), compareSection && /* @__PURE__ */ React43.createElement(LodgingCardCompareSection, {
        isAd: isAd2,
        propertyId: id,
        data: compareSection
    }))))));
};
LodgingCardContentSection.fragment = fragment35;
LodgingCardContentSection.displayName = "LodgingCardContentSection";
// ../internal/src/components/lodging-card/__private/lodging-card-link.tsx
import React44, { useContext as useContext2 } from "react";
import { Link } from "react-router-dom";
import { gql as gql39 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";
import { CompareAdaptExContext as CompareAdaptExContext2 } from "@shared-ui/retail-compare-providers";
import { UitkCardLink } from "uitk-react-cards";
var _obj8;
// ../internal/src/components/uitk-link-target-mapper.tsx
var UILinkTargetMap2 = (_obj8 = {}, _defineProperty(_obj8, "EXTERNAL" /* EXTERNAL */ , "_blank"), _defineProperty(_obj8, "INTERNAL" /* INTERNAL */ , "_self"), _obj8);
// ../internal/src/components/lodging-card/__private/lodging-card-link.tsx
var fragment36 = gql39(_templateObject38());
var LINK_REL = "noopener";
var LINK_DATA_STID = "open-hotel-information";
var LodgingCardLink = function(param) {
    var data = param.data, onClickCallback = param.onClickCallback;
    var resource = data.resource, useRelativePath = data.useRelativePath, analytics = data.analytics, target = data.target, accessibility = data.accessibility;
    var track = useClickTracker13();
    var _useProvidedState2 = _slicedToArray(useProvidedState2(), 1), state = _useProvidedState2[0];
    var _state_STATE_FIELD_NAME;
    var comparePropertyIds = ((_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    var _useContext2 = _slicedToArray(useContext2(CompareAdaptExContext2), 1), _useContext2_ = _useContext2[0], campaignId = _useContext2_.campaignId, payloadId = _useContext2_.payloadId;
    var path;
    if (resource.__typename === "HttpURI") {
        path = useRelativePath ? resource.relativePath : resource.value;
        if (comparePropertyIds.length) {
            path = path.concat("&comparePropertyIds=".concat(comparePropertyIds.toString()));
        }
    }
    var onClick = function() {
        if (analytics) {
            var lodgingCompareAdaptExMessage = !(payloadId && campaignId) ? null : lightweightAdaptExMicroMessage({
                campaignId: campaignId,
                payloadId: payloadId,
                eventType: "click",
                eventTarget: "property-card"
            });
            sendProductSchemaTracking(_objectSpreadProps(_objectSpread({}, analytics), {
                uisPrimeMessages: !lodgingCompareAdaptExMessage ? analytics.uisPrimeMessages : _toConsumableArray(analytics.uisPrimeMessages).concat([
                    microMessageToFragment(lodgingCompareAdaptExMessage)
                ])
            }), track);
        }
        if (onClickCallback) {
            onClickCallback();
        }
    };
    var linkProps = {
        rel: LINK_REL,
        "data-stid": LINK_DATA_STID,
        target: target && UILinkTargetMap2[target],
        onClickCapture: onClick
    };
    return /* @__PURE__ */ React44.createElement(UitkCardLink, null, target === "INTERNAL" /* INTERNAL */  && useRelativePath ? /* @__PURE__ */ React44.createElement(Link, _objectSpreadProps(_objectSpread({}, linkProps), {
        to: path || ""
    }), accessibility) : /* @__PURE__ */ React44.createElement("a", _objectSpreadProps(_objectSpread({}, linkProps), {
        href: path
    }), accessibility));
};
LodgingCardLink.fragment = fragment36;
LodgingCardLink.displayName = "LodgingCardLink";
// ../internal/src/components/lodging-card/__private/lodging-card-link-action.tsx
import React45 from "react";
import { gql as gql40 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon11 } from "uitk-react-icons";
import { UitkLink as UitkLink3 } from "uitk-react-link";
var fragment37 = gql40(_templateObject39());
var LodgingCardLinkAction = function(param) {
    var data = param.data;
    var link = data.link;
    var action = link.action, icon = link.icon;
    var analytics = action.analytics, resource = action.resource;
    var track = useClickTracker14();
    if (!link || resource.__typename !== "HttpURI") {
        return null;
    }
    var path = action.useRelativePath ? resource.relativePath : resource.value;
    var analyticsData = analytics ? {
        id: analytics.referrerId,
        description: analytics.linkName,
        callback: function(id, description) {
            return track(id, description, true);
        }
    } : void 0;
    var linkContent = /* @__PURE__ */ React45.createElement(UitkLink3, {
        align: "right",
        analytics: analyticsData
    }, /* @__PURE__ */ React45.createElement("a", {
        href: path,
        target: UILinkTargetMap2[action.target]
    }, link.text, (icon === null || icon === void 0 ? void 0 : icon.id) && /* @__PURE__ */ React45.createElement(UitkIcon11, {
        name: icon === null || icon === void 0 ? void 0 : icon.id
    })));
    var isSignInFooterLink = !!analytics.linkName.match(/sign in/gi);
    return isSignInFooterLink ? /* @__PURE__ */ React45.createElement(IntersectionTracker3, {
        referrerId: "Impression".concat(analytics.referrerId),
        linkName: analytics.linkName,
        trackOnce: true
    }, linkContent) : linkContent;
};
LodgingCardLinkAction.fragment = fragment37;
LodgingCardLinkAction.displayName = "LodgingCardLinkAction";
// ../internal/src/components/lodging-card/__private/lodging-card-media-section.tsx
import React51 from "react";
import { gql as gql46 } from "@apollo/client";
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkFigure as UitkFigure3, UitkImage as UitkImage3 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex10 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition5 } from "uitk-react-layout-position";
// ../internal/src/components/lodging-gallery-carousel/lodging-gallery-carousel.tsx
import React48 from "react";
import { useHistory } from "react-router-dom";
import { gql as gql43 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker4, useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState3 } from "@shared-ui/provided-state-context";
import { UitkButtonTheme } from "uitk-react-button";
import { UitkGalleryCarousel } from "uitk-react-gallery-carousel";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
// ../internal/src/components/lodging-gallery-carousel/lodging-media-item-to-uitk-media-mapper.tsx
var lodgingMediaItemToUitkMediaMapper = function(mediaItem) {
    switch(mediaItem.media.__typename){
        case "Image":
            return {
                src: mediaItem.media.url,
                alt: mediaItem.media.description
            };
        default:
            return {};
    }
};
// ../internal/src/components/lodging-media-item/lodging-media-item.tsx
import React47 from "react";
import { gql as gql42 } from "@apollo/client";
// ../internal/src/components/lodging-egds-image/lodging-egds-image.tsx
import React46 from "react";
import { gql as gql41 } from "@apollo/client";
import { UitkFigure, UitkImage } from "uitk-react-images";
var fragment38 = gql41(_templateObject40());
var LodgingEGDSImage = function(param) {
    var data = param.data, imageFit = param.imageFit, ratio = param.ratio, placeholderImage = param.placeholderImage, lazyLoad = param.lazyLoad;
    var figureProps = {};
    if (ratio) {
        figureProps.ratio = ratio;
    }
    if (imageFit) {
        figureProps.imageFit = imageFit;
    }
    return /* @__PURE__ */ React46.createElement(UitkFigure, _objectSpread({}, figureProps), /* @__PURE__ */ React46.createElement(UitkImage, {
        placeholderImage: placeholderImage,
        src: data.url,
        alt: data.description,
        lazyLoading: lazyLoad
    }));
};
LodgingEGDSImage.fragment = fragment38;
LodgingEGDSImage.displayName = "LodgingEGDSImage";
// ../internal/src/components/lodging-media-item/lodging-media-item.tsx
var fragment39 = gql42(_templateObject41(), LodgingEGDSImage.fragment);
var LodgingMediaItem = function(param) {
    var imageFit = param.imageFit, ratio = param.ratio, data = param.data, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg;
    switch(data.media.__typename){
        case "Image":
            return /* @__PURE__ */ React47.createElement(LodgingEGDSImage, {
                imageFit: imageFit,
                ratio: ratio,
                placeholderImage: true,
                data: data.media,
                lazyLoad: lazyLoadImg ? "lazy" : "off"
            });
        default:
            return null;
    }
};
LodgingMediaItem.fragment = fragment39;
LodgingMediaItem.displayName = "LodgingProductMediaItem";
// ../internal/src/components/lodging-gallery-carousel/lodging-gallery-carousel.tsx
var fragment40 = gql43(_templateObject42(), LodgingMediaItem.fragment);
var LodgingGalleryCarousel = function(param) {
    var data = param.data, carouselId = param.carouselId, allyHeadingLevel = param.allyHeadingLevel, cardLink = param.cardLink, propertyId = param.propertyId, _param_imageRatio = param.imageRatio, imageRatio = _param_imageRatio === void 0 ? UitkFigureAspectRatioType2.R21_9 : _param_imageRatio, onClickCallback = param.onClickCallback, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg, propertySortIndex = param.propertySortIndex;
    var media = data.media, accessibilityHeadingText = data.accessibilityHeadingText, navClickAnalytics = data.navClickAnalytics, intersectionAnalytics = data.intersectionAnalytics;
    var track = useClickTracker15();
    var _React48_useState = _slicedToArray(React48.useState(0), 2), currentMediaIndex = _React48_useState[0], setCurrentMediaIndex = _React48_useState[1];
    var _useProvidedState3 = _slicedToArray(useProvidedState3(), 1), lodgingCompareState = _useProvidedState3[0];
    var _lodgingCompareState_STATE_FIELD_NAME;
    var comparePropertyIds = ((_lodgingCompareState_STATE_FIELD_NAME = lodgingCompareState[STATE_FIELD_NAME]) !== null && _lodgingCompareState_STATE_FIELD_NAME !== void 0 ? _lodgingCompareState_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    React48.useEffect(function() {
        setCurrentMediaIndex(0);
    }, [
        carouselId
    ]);
    var additionalUisPrimeMicroMessages = function(mdiaIndex) {
        var _media_mdiaIndex, _intersectionAnalytics_uisPrimeMessages, _media_mdiaIndex1;
        var iId = (_media_mdiaIndex = media[mdiaIndex]) === null || _media_mdiaIndex === void 0 ? void 0 : _media_mdiaIndex.id;
        var imageId = iId && parseInt(iId, 10);
        var productId = propertyId && parseInt(propertyId, 10);
        var messageContent = (intersectionAnalytics === null || intersectionAnalytics === void 0 ? void 0 : (_intersectionAnalytics_uisPrimeMessages = intersectionAnalytics.uisPrimeMessages) === null || _intersectionAnalytics_uisPrimeMessages === void 0 ? void 0 : _intersectionAnalytics_uisPrimeMessages.length) ? JSON.parse(intersectionAnalytics === null || intersectionAnalytics === void 0 ? void 0 : intersectionAnalytics.uisPrimeMessages[0].messageContent) : void 0;
        var badges = messageContent === null || messageContent === void 0 ? void 0 : messageContent.badges;
        var sponsored = !!(messageContent === null || messageContent === void 0 ? void 0 : messageContent.sponsored);
        var algoMediaGuid = (_media_mdiaIndex1 = media[mdiaIndex]) === null || _media_mdiaIndex1 === void 0 ? void 0 : _media_mdiaIndex1.trackingId;
        var galleryMaxPosition = media === null || media === void 0 ? void 0 : media.length;
        var galleryPosition = mdiaIndex;
        return [
            {
                schemaName: "allHotelProducts",
                messageContent: {
                    numOfProducts: 1,
                    hotelProducts: [
                        {
                            productId: productId,
                            imageId: imageId,
                            imageGalleryAlgorithm: {
                                name: "heroaesthetics.v20190411-hsc.v20190223"
                            },
                            badges: badges,
                            algoMediaGuid: algoMediaGuid,
                            sortPosition: propertySortIndex,
                            sponsored: sponsored
                        }
                    ]
                }
            },
            {
                schemaName: "imageTracking",
                messageContent: {
                    galleryName: "SRP_PROPERTY_CARD_CAROUSEL",
                    galleryType: "GALLERY_TYPE_SINGLE",
                    galleryMaxPosition: galleryMaxPosition,
                    galleryPosition: galleryPosition,
                    repeatedGalleryIndex: null
                }
            }
        ];
    };
    var history = useHistory();
    var onImageClick = function() {
        var comparePropertyIdsStringToAppend = comparePropertyIds.length ? "&comparePropertyIds=".concat(comparePropertyIds.toString()) : "";
        if ((cardLink === null || cardLink === void 0 ? void 0 : cardLink.resource.__typename) === "HttpURI") {
            if (cardLink.target === "INTERNAL" /* INTERNAL */  && (cardLink === null || cardLink === void 0 ? void 0 : cardLink.useRelativePath)) {
                history.push(cardLink.resource.relativePath.concat(comparePropertyIdsStringToAppend));
            } else {
                var path = cardLink.useRelativePath ? cardLink.resource.relativePath.concat(comparePropertyIdsStringToAppend) : cardLink.resource.value.concat(comparePropertyIdsStringToAppend);
                window.open(path, UILinkTargetMap2[cardLink.target]);
            }
            if (cardLink.analytics) {
                sendProductSchemaTracking(cardLink.analytics, track);
            }
        }
        var currentMedia = media[currentMediaIndex].media;
        if (currentMedia.__typename === "Image" && currentMedia.thumbnailClickAnalytics) {
            track(currentMedia.thumbnailClickAnalytics.referrerId, currentMedia.thumbnailClickAnalytics.linkName, true, additionalUisPrimeMicroMessages(currentMediaIndex));
        }
        if (onClickCallback) {
            onClickCallback();
        }
    };
    var navButtonAnalytics = navClickAnalytics ? {
        id: navClickAnalytics.referrerId,
        description: navClickAnalytics.linkName,
        callback: function(id, description) {
            return track(id, description, true, additionalUisPrimeMicroMessages(currentMediaIndex));
        }
    } : void 0;
    var galleryCarouselButtonText = data.nextButtonText && data.previousButtonText ? {
        nextButton: data.nextButtonText,
        prevButton: data.previousButtonText
    } : void 0;
    var galleryCarousel = media.length > 1 && /* @__PURE__ */ React48.createElement(UitkGalleryCarousel, {
        allyHeadingText: accessibilityHeadingText,
        allyHeadingLevel: allyHeadingLevel !== null && allyHeadingLevel !== void 0 ? allyHeadingLevel : void 0,
        carouselId: carouselId,
        carouselName: carouselId,
        currentIndex: currentMediaIndex,
        buttonText: galleryCarouselButtonText,
        images: media.map(function(mediaItem) {
            return lodgingMediaItemToUitkMediaMapper(mediaItem);
        }),
        onImageClick: cardLink ? onImageClick : void 0,
        onIndexChange: setCurrentMediaIndex,
        ratio: imageRatio,
        navTheme: UitkButtonTheme.TRANSPARENT,
        showGalleryButton: false,
        analytics: navButtonAnalytics,
        enablePreload: true,
        placeholderImage: true
    });
    switch(media.length){
        case 0:
            return /* @__PURE__ */ React48.createElement(UitkLayoutPosition4, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React48.createElement(UitkFigure2, {
                imageFit: "cover",
                ratio: imageRatio
            }, /* @__PURE__ */ React48.createElement(UitkImage2, {
                placeholderImage: true,
                alt: ""
            })));
        case 1:
            return /* @__PURE__ */ React48.createElement(UitkLayoutPosition4, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React48.createElement(LodgingMediaItem, {
                imageFit: "cover",
                ratio: imageRatio,
                data: media[0],
                lazyLoadImg: lazyLoadImg
            }));
        default:
            return /* @__PURE__ */ React48.createElement(UitkLayoutPosition4, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React48.createElement(UitkFigure2, {
                imageFit: "cover",
                ratio: imageRatio
            }, intersectionAnalytics ? /* @__PURE__ */ React48.createElement(IntersectionTracker4, {
                tag: "span",
                referrerId: intersectionAnalytics.referrerId,
                linkName: intersectionAnalytics.linkName,
                additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(currentMediaIndex)
            }, galleryCarousel) : galleryCarousel));
    }
};
LodgingGalleryCarousel.fragment = fragment40;
LodgingGalleryCarousel.displayName = "LodgingGalleryCarousel";
// ../internal/src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
import React49 from "react";
import { gql as gql44 } from "@apollo/client";
import { ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics2 } from "@shared-ui/clickstream-analytics-context";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
var fragment41 = gql44(_templateObject43(), AdaptexTrackingFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var LodgingTripsSaveItemAdapter = function(param) {
    var data = param.data;
    var save = data.save, remove = data.remove;
    var track = useClickstreamAnalytics2().track;
    var _save_adaptexSuccessCampaignIds;
    var _useAdaptExEvents = useAdaptExEvents((_save_adaptexSuccessCampaignIds = save.adaptexSuccessCampaignIds) !== null && _save_adaptexSuccessCampaignIds !== void 0 ? _save_adaptexSuccessCampaignIds : []), saveAdaptexSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var _remove_adaptexSuccessCampaignIds;
    var _useAdaptExEvents1 = useAdaptExEvents((_remove_adaptexSuccessCampaignIds = remove.adaptexSuccessCampaignIds) !== null && _remove_adaptexSuccessCampaignIds !== void 0 ? _remove_adaptexSuccessCampaignIds : []), removeAdaptexSuccessEvents = _useAdaptExEvents1.adaptExSuccessEvents;
    var saveItemAdaptexTracking = React49.useCallback(function() {
        if (saveAdaptexSuccessEvents.length) {
            saveAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType3.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        saveAdaptexSuccessEvents,
        track
    ]);
    var removeItemAdaptexTracking = React49.useCallback(function() {
        if (removeAdaptexSuccessEvents.length) {
            removeAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType3.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        removeAdaptexSuccessEvents,
        track
    ]);
    return data && /* @__PURE__ */ React49.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React49.createElement(TripSaveItem, {
        data: data,
        source: Source.LODGING_SEARCH,
        heartLayoutPosition: {
            type: "absolute",
            position: {
                top: "zero",
                right: "zero",
                zindex: "layer2"
            }
        },
        saveItemCallback: saveItemAdaptexTracking,
        removeItemCallback: removeItemAdaptexTracking
    }));
};
LodgingTripsSaveItemAdapter.fragment = fragment41;
LodgingTripsSaveItemAdapter.displayName = "LodgingTripsSaveItemAdapter";
// ../internal/src/components/lodging-card/__private/lodging-card-save-item.tsx
import React50 from "react";
import { gql as gql45 } from "@apollo/client";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { ProductType, ShortlistToggle } from "@shared-ui/trip-planning-travelpulse";
var fragment42 = gql45(_templateObject44());
var LodgingCardSaveItem = function(param) {
    var data = param.data;
    var trackClick = useClickTracker16();
    var _React50_useState = _slicedToArray(React50.useState(data.initialChecked), 2), isChecked = _React50_useState[0], setIsChecked = _React50_useState[1];
    var items = data.items, labels = data.labels, messages = data.messages, initialChecked = data.initialChecked, analytics = data.analytics;
    var label = isChecked ? labels === null || labels === void 0 ? void 0 : labels.removeLabel : labels === null || labels === void 0 ? void 0 : labels.saveLabel;
    var inputs = {
        productId: items[0].itemId,
        productType: ProductType.PROPERTY_DETAILS
    };
    var handleChange = function(_previousChecked, currentChecked, dispatch) {
        setIsChecked(currentChecked);
        var referrerId = currentChecked ? "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.linkName, ".Add to favorite lists") : "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.linkName, ".Remove from favorite lists");
        var linkName = currentChecked ? "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, ".SaveFavorite") : "".concat(analytics === null || analytics === void 0 ? void 0 : analytics.referrerId, ".RemoveFavorite");
        trackClick(linkName, referrerId);
        var message = currentChecked ? messages === null || messages === void 0 ? void 0 : messages.saveMessage : messages === null || messages === void 0 ? void 0 : messages.removeMessage;
        if (message) {
            dispatch({
                message: message
            });
        }
    };
    return /* @__PURE__ */ React50.createElement(ShortlistToggle, {
        inputs: inputs,
        initialChecked: initialChecked,
        label: label || void 0,
        onChange: handleChange
    });
};
LodgingCardSaveItem.fragment = fragment42;
LodgingCardSaveItem.displayName = "LodgingCardSaveItem";
// ../internal/src/components/lodging-card/__private/lodging-card-media-section.tsx
var fragment43 = gql46(_templateObject45(), LodgingBadge.fragment, LodgingGalleryCarousel.fragment, LodgingCardSaveItem.fragment, LodgingTripsSaveItemAdapter.fragment);
var LodgingCardMediaSection = function(param) {
    var cardLink = param.cardLink, propertyId = param.propertyId, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, data = param.data, imageRatio = param.imageRatio, onClickCallback = param.onClickCallback, index = param.index, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg, isSRPListingCard = param.isSRPListingCard;
    var badges = data.badges, gallery = data.gallery, saveItem = data.saveItem, saveTripItem = data.saveTripItem;
    var carouselFigure = gallery ? /* @__PURE__ */ React51.createElement(LodgingGalleryCarousel, {
        data: gallery,
        carouselId: "lodging-card-gallery-carousel-".concat(propertyId, "-").concat(index),
        allyHeadingLevel: "h3",
        cardLink: cardLink,
        propertyId: propertyId,
        imageRatio: imageRatio,
        onClickCallback: onClickCallback,
        lazyLoadImg: lazyLoadImg,
        propertySortIndex: index
    }) : /* @__PURE__ */ React51.createElement(UitkFigure3, {
        additionalProps: {
            "data-stid": "lodging-card-media-section-placeholder-image"
        }
    }, /* @__PURE__ */ React51.createElement(UitkImage3, {
        placeholderImage: true,
        alt: ""
    }));
    var tertiaryLodgingBadge;
    if (badges === null || badges === void 0 ? void 0 : badges.tertiaryBadge) {
        var tertiaryBadgeContent = /* @__PURE__ */ React51.createElement(UitkLayoutPosition5, {
            type: "absolute",
            position: {
                right: "three",
                bottom: "minus-three",
                zindex: "layer2"
            },
            cloneElement: true
        }, /* @__PURE__ */ React51.createElement(LodgingBadge, {
            data: badges.tertiaryBadge,
            propertyId: propertyId
        }));
        if (!isCompactHorizontalView(view)) {
            tertiaryLodgingBadge = isCompactView(view) ? tertiaryBadgeContent : /* @__PURE__ */ React51.createElement(Viewport5, null, /* @__PURE__ */ React51.createElement(ViewSmall3, null, tertiaryBadgeContent), /* @__PURE__ */ React51.createElement(ViewMedium5, null));
        }
    }
    var shortlistToggle = saveItem && !isCompactHorizontalView(view) && /* @__PURE__ */ React51.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            top: "zero",
            right: "zero",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React51.createElement(LodgingCardSaveItem, {
        data: saveItem
    }));
    var compactViewShortlistToggle = saveItem && isCompactHorizontalView(view) && /* @__PURE__ */ React51.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            top: "zero",
            left: "zero",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React51.createElement(LodgingCardSaveItem, {
        data: saveItem
    }));
    var saveTripItemHeart = saveTripItem && /* @__PURE__ */ React51.createElement(LodgingTripsSaveItemAdapter, {
        data: saveTripItem
    });
    var primaryLodgingBadge = (badges === null || badges === void 0 ? void 0 : badges.primaryBadge) && /* @__PURE__ */ React51.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            left: "three",
            top: "three",
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React51.createElement(LodgingBadge, {
        data: badges.primaryBadge
    }));
    var secondaryLodgingBadge = (badges === null || badges === void 0 ? void 0 : badges.secondaryBadge) && /* @__PURE__ */ React51.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            bottom: "three",
            left: "three",
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React51.createElement(LodgingBadge, {
        isSRPListingCard: isSRPListingCard,
        data: badges.secondaryBadge
    }));
    return /* @__PURE__ */ React51.createElement(UitkLayoutPosition5, {
        type: "relative",
        position: {
            top: "zero",
            left: "zero"
        },
        cloneElement: true
    }, /* @__PURE__ */ React51.createElement(UitkLayoutFlex10, {
        blockSize: "full_size"
    }, carouselFigure, shortlistToggle, compactViewShortlistToggle, saveTripItemHeart, primaryLodgingBadge, secondaryLodgingBadge, tertiaryLodgingBadge));
};
LodgingCardMediaSection.fragment = fragment43;
LodgingCardMediaSection.displayName = "LodgingCardMediaSection";
// ../internal/src/components/lodging-card/lodging-card-compact.tsx
import React52 from "react";
import { UitkCard, UitkCardContentSection, UitkCardFeaturedHeader } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex11 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
var LodgingCardCompact = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "COMPACT" /* COMPACT */  : _param_view, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? true : _param_lazyLoadImg, imageRatio = param.imageRatio, onClick = param.onClick, onHoverChanged = param.onHoverChanged, wrapHeadingText = param.wrapHeadingText, index = param.index, isReview = param.isReview, border = param.border, headingSize = param.headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var __typename = data.__typename, callOut = data.callOut, cardLink = data.cardLink, headingSection = data.headingSection, featuredHeader = data.featuredHeader, footerActions = data.footerActions, id = data.id, mediaSection = data.mediaSection, priceSection = data.priceSection, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection;
    var lodgingCardContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var lodgingCardMediaSection = /* @__PURE__ */ React52.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        onClickCallback: onClick,
        index: index,
        lazyLoadImg: lazyLoadImg
    });
    return /* @__PURE__ */ React52.createElement(UitkCard, {
        border: border,
        className: className,
        "data-stid": "lodging-card-compact",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        }
    }, featuredHeader && /* @__PURE__ */ React52.createElement(UitkCardFeaturedHeader, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    }), /* @__PURE__ */ React52.createElement(UitkLayoutGrid3, {
        columns: 1
    }, /* @__PURE__ */ React52.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React52.createElement("div", null, lodgingCardMediaSection)), /* @__PURE__ */ React52.createElement(UitkLayoutGridItem3, null, /* @__PURE__ */ React52.createElement(UitkCardContentSection, null, /* @__PURE__ */ React52.createElement(UitkLayoutFlex11, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React52.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: isAd(mediaSection),
        view: view,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink
    }))))), footerActions.length > 0 && /* @__PURE__ */ React52.createElement(UitkCardContentSection, {
        tag: "footer",
        border: "top"
    }, /* @__PURE__ */ React52.createElement(UitkLayoutFlex11, {
        space: "two",
        direction: "column"
    }, footerActions.map(function(footerAction, i) {
        return /* @__PURE__ */ React52.createElement(LodgingCardLinkAction, {
            data: footerAction,
            key: "footerAction-".concat(i)
        });
    }))), cardLink && /* @__PURE__ */ React52.createElement(LodgingCardLink, {
        data: cardLink,
        onClickCallback: onClick
    }));
};
LodgingCardCompact.displayName = "LodgingCardCompact";
// ../internal/src/components/lodging-card/lodging-card-compact-horizontal.tsx
import React54 from "react";
import Lazyload from "react-lazy-load";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection2, UitkCardFeaturedHeader as UitkCardFeaturedHeader2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex13 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid5, UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
// ../internal/src/components/lodging-card/__private/lodging-card-compact-horizontal-content-section.tsx
import React53 from "react";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid4, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition6 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing12, UitkSpacingHr as UitkSpacingHr2 } from "uitk-react-spacing";
var LodgingCardCompactHorizontalContentSection = function(param) {
    var data = param.data, isAd2 = param.isAd, _param_view = param.view, view = _param_view === void 0 ? "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */  : _param_view, wrapHeadingText = param.wrapHeadingText, isReview = param.isReview, showDismissButton = param.showDismissButton, onCardDismiss = param.onCardDismiss, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 6 : _param_headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _priceSection_priceSummary;
    var headingSection = data.headingSection, priceSection = data.priceSection, callOut = data.callOut, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection, id = data.id;
    var hasRightColumn = callOut || priceSection;
    return /* @__PURE__ */ React53.createElement(React53.Fragment, null, headingSection && /* @__PURE__ */ React53.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React53.createElement(UitkSpacing12, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React53.createElement(LodgingCardHeadingSection, {
        data: headingSection,
        headingSize: headingSize,
        wrapHeadingText: wrapHeadingText,
        onCardDismiss: onCardDismiss,
        showDismissButton: showDismissButton
    }))), /* @__PURE__ */ React53.createElement(UitkLayoutFlexItem8, {
        grow: 1
    }, /* @__PURE__ */ React53.createElement(UitkLayoutGrid4, {
        columns: 1,
        space: "two"
    }, /* @__PURE__ */ React53.createElement(UitkLayoutGridItem4, {
        colSpan: hasRightColumn ? 2 : 3,
        alignSelf: "end"
    }, /* @__PURE__ */ React53.createElement("div", null, summarySections.map(function(summarySection, index) {
        return /* @__PURE__ */ React53.createElement(React53.Fragment, {
            key: "summary-section-".concat(index)
        }, index > 0 && /* @__PURE__ */ React53.createElement(UitkSpacingHr2, {
            blockMargin: "three"
        }), /* @__PURE__ */ React53.createElement(LodgingCardProductSummarySection, {
            data: summarySection,
            view: view,
            isReview: isReview
        }));
    }))), hasRightColumn && /* @__PURE__ */ React53.createElement(UitkLayoutGridItem4, {
        colSpan: 2,
        justifySelf: "end",
        alignSelf: "end"
    }, callOut && /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(LodgingEGDSText, {
        data: callOut,
        align: "right"
    })), priceSection && /* @__PURE__ */ React53.createElement(UitkLayoutFlex12, {
        direction: "column"
    }, /* @__PURE__ */ React53.createElement(UitkLayoutFlexItem8, {
        alignSelf: "end"
    }, /* @__PURE__ */ React53.createElement(UitkLayoutPosition6, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React53.createElement(LodgingStandardBadge, {
        data: priceSection.standardBadge,
        propertyId: id
    }), " ")), /* @__PURE__ */ React53.createElement(PriceSectionPriceSummary, {
        priceSection: priceSection,
        enableInlineLink: enableInlineLink
    }), ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : _priceSection_priceSummary.marketingFeeDetails) && /* @__PURE__ */ React53.createElement(UitkLayoutFlexItem8, {
        alignSelf: "end"
    }, /* @__PURE__ */ React53.createElement(UitkSpacing12, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(LodgingCardMarketingFeeDetail, {
        data: priceSection.priceSummary.marketingFeeDetails,
        id: id
    })))), (priceSection === null || priceSection === void 0 ? void 0 : priceSection.button) && /* @__PURE__ */ React53.createElement(UitkLayoutPosition6, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React53.createElement(UitkSpacing12, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(LodgingMODSignInButton, _objectSpread({}, priceSection.button))))), dateSection && /* @__PURE__ */ React53.createElement(UitkLayoutFlexItem8, {
        alignSelf: "end"
    }, /* @__PURE__ */ React53.createElement(UitkSpacing12, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(LodgingCardDateSection, {
        data: dateSection
    })))), compareSection && /* @__PURE__ */ React53.createElement(LodgingCardCompareSection, {
        propertyId: id,
        data: compareSection,
        isAd: isAd2
    }))))));
};
LodgingCardCompactHorizontalContentSection.displayName = "LodgingCardCompactHorizontalContentSection";
// ../internal/src/components/lodging-card/lodging-card-compact-horizontal.tsx
var LodgingCardCompactHorizontal = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */  : _param_view, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? true : _param_lazyLoadImg, imageRatio = param.imageRatio, onClick = param.onClick, onHoverChanged = param.onHoverChanged, onCardDismiss = param.onCardDismiss, showDismissButton = param.showDismissButton, wrapHeadingText = param.wrapHeadingText, index = param.index, isReview = param.isReview, border = param.border, headingSize = param.headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var featuredHeader = data.featuredHeader, summarySections = data.summarySections, compareSection = data.compareSection, footerActions = data.footerActions, mediaSection = data.mediaSection, cardLink = data.cardLink, callOut = data.callOut, priceSection = data.priceSection, headingSection = data.headingSection, dateSection = data.dateSection, id = data.id, __typename = data.__typename;
    var lodgingCardCompactHorizontalContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var lodgingCardMediaSection = /* @__PURE__ */ React54.createElement(UitkLayoutGridItem5, null, /* @__PURE__ */ React54.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        onClickCallback: onClick,
        index: index
    }));
    return /* @__PURE__ */ React54.createElement(UitkCard2, {
        border: border,
        className: className,
        "data-stid": "lodging-card-compact-horizontal",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        }
    }, featuredHeader && /* @__PURE__ */ React54.createElement(UitkCardFeaturedHeader2, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    }), /* @__PURE__ */ React54.createElement(UitkLayoutGrid5, {
        columns: 3
    }, !lazyLoadImg && lodgingCardMediaSection, lazyLoadImg && /* @__PURE__ */ React54.createElement(Lazyload, {
        offset: 100
    }, lodgingCardMediaSection), /* @__PURE__ */ React54.createElement(UitkLayoutGridItem5, {
        colSpan: 2
    }, /* @__PURE__ */ React54.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React54.createElement(UitkLayoutFlex13, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React54.createElement(LodgingCardCompactHorizontalContentSection, {
        data: lodgingCardCompactHorizontalContentSectionData,
        isAd: isAd(mediaSection),
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        onCardDismiss: onCardDismiss,
        showDismissButton: showDismissButton,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink
    }))))), footerActions.length > 0 && /* @__PURE__ */ React54.createElement(UitkCardContentSection2, {
        tag: "footer",
        border: "top"
    }, /* @__PURE__ */ React54.createElement(UitkLayoutFlex13, {
        space: "two",
        direction: "column"
    }, footerActions.map(function(footerAction, i) {
        return /* @__PURE__ */ React54.createElement(LodgingCardLinkAction, {
            data: footerAction,
            key: "footerAction-".concat(i)
        });
    }))), cardLink && /* @__PURE__ */ React54.createElement(LodgingCardLink, {
        data: cardLink,
        onClickCallback: onClick
    }));
};
LodgingCardCompactHorizontal.displayName = "LodgingCardCompactHorizontal";
// ../internal/src/components/lodging-card/lodging-card-responsive.tsx
import React55 from "react";
import Lazyload2 from "react-lazy-load";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard3, UitkCardContentSection as UitkCardContentSection3, UitkCardFeaturedHeader as UitkCardFeaturedHeader3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex14 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid6, UitkLayoutGridItem as UitkLayoutGridItem6 } from "uitk-react-layout-grid";
var LodgingCardResponsive = function(props) {
    var className = props.className, data = props.data, imageRatio = props.imageRatio, lazyLoadImg = props.lazyLoadImg, onClick = props.onClick, onHoverChanged = props.onHoverChanged, view = props.view, wrapHeadingText = props.wrapHeadingText, index = props.index, isReview = props.isReview, border = props.border, headingSize = props.headingSize, isSRPListingCard = props.isSRPListingCard, _props_enableInlineLink = props.enableInlineLink, enableInlineLink = _props_enableInlineLink === void 0 ? false : _props_enableInlineLink;
    var __typename = data.__typename, callOut = data.callOut, cardLink = data.cardLink, headingSection = data.headingSection, featuredHeader = data.featuredHeader, footerActions = data.footerActions, id = data.id, mediaSection = data.mediaSection, priceSection = data.priceSection, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection;
    var lodgingCardContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var lodgingCardMediaSection = /* @__PURE__ */ React55.createElement(UitkLayoutGridItem6, null, /* @__PURE__ */ React55.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        onClickCallback: onClick,
        index: index,
        isSRPListingCard: isSRPListingCard
    }));
    var _isAd = isAd(mediaSection);
    return /* @__PURE__ */ React55.createElement(Viewport6, null, /* @__PURE__ */ React55.createElement(ViewSmall4, null, /* @__PURE__ */ React55.createElement(LodgingCardCompact, _objectSpread({}, props))), /* @__PURE__ */ React55.createElement(ViewMedium6, null, /* @__PURE__ */ React55.createElement(UitkCard3, {
        border: border,
        className: className,
        "data-stid": "lodging-card-responsive",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        }
    }, featuredHeader && /* @__PURE__ */ React55.createElement(UitkCardFeaturedHeader3, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    }), /* @__PURE__ */ React55.createElement(UitkLayoutGrid6, {
        columns: {
            medium: 3
        }
    }, lazyLoadImg ? /* @__PURE__ */ React55.createElement(Lazyload2, {
        offset: 100
    }, lodgingCardMediaSection) : lodgingCardMediaSection, /* @__PURE__ */ React55.createElement(UitkLayoutGridItem6, {
        colSpan: {
            medium: 2
        }
    }, /* @__PURE__ */ React55.createElement(UitkCardContentSection3, null, /* @__PURE__ */ React55.createElement(Viewport6, null, /* @__PURE__ */ React55.createElement(ViewMedium6, null, /* @__PURE__ */ React55.createElement(UitkLayoutFlex14, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between",
        style: {
            minHeight: 111
        }
    }, /* @__PURE__ */ React55.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: _isAd,
        view: view,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink
    }))), /* @__PURE__ */ React55.createElement(ViewLarge3, null, /* @__PURE__ */ React55.createElement(UitkLayoutFlex14, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between",
        style: {
            minHeight: 143
        }
    }, /* @__PURE__ */ React55.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: _isAd,
        view: view,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink
    }))))))), footerActions.length > 0 && /* @__PURE__ */ React55.createElement(UitkCardContentSection3, {
        tag: "footer",
        border: "top"
    }, /* @__PURE__ */ React55.createElement(UitkLayoutFlex14, {
        space: "two",
        direction: "column"
    }, footerActions.map(function(footerAction, i) {
        return /* @__PURE__ */ React55.createElement(LodgingCardLinkAction, {
            data: footerAction,
            key: "footerAction-".concat(i)
        });
    }))), cardLink && /* @__PURE__ */ React55.createElement(LodgingCardLink, {
        data: cardLink,
        onClickCallback: onClick
    }))));
};
LodgingCardResponsive.displayName = "LodgingCardResponsive";
// ../internal/src/components/lodging-card/lodging-card.tsx
var fragment44 = gql47(_templateObject46(), AdaptExAnalyticsEventFragment, LodgingCardLinkAction.fragment, LodgingCardMediaSection.fragment, LodgingCardHeadingSection.fragment, LodgingCardContentSection.fragment, LodgingCardLink.fragment);
var lodgingCardBy = function(view, props, index) {
    switch(view){
        case "COMPACT" /* COMPACT */ :
            return {
                lodgingCard: /* @__PURE__ */ React56.createElement(LodgingCardCompact, _objectSpreadProps(_objectSpread({}, props), {
                    index: index
                })),
                trackerClassName: "uitk-card-roundcorner-all uitk-card-has-primary-theme"
            };
        case "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ :
            return {
                lodgingCard: /* @__PURE__ */ React56.createElement(LodgingCardCompactHorizontal, _objectSpreadProps(_objectSpread({}, props), {
                    index: index
                }))
            };
        default:
            return {
                lodgingCard: /* @__PURE__ */ React56.createElement(LodgingCardResponsive, _objectSpreadProps(_objectSpread({}, props), {
                    index: index
                }))
            };
    }
};
var LodgingCard = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? true : _param_lazyLoadImg, imageRatio = param.imageRatio, onClickCallback = param.onClickCallback, onHoverChanged = param.onHoverChanged, onCardDismiss = param.onCardDismiss, showDismissButton = param.showDismissButton, _param_wrapHeadingText = param.wrapHeadingText, wrapHeadingText = _param_wrapHeadingText === void 0 ? true : _param_wrapHeadingText, index = param.index, _param_fireCardImpression = param.fireCardImpression, fireCardImpression = _param_fireCardImpression === void 0 ? true : _param_fireCardImpression, isReview = param.isReview, _param_border = param.border, border = _param_border === void 0 ? false : _param_border, headingSize = param.headingSize, _param_isSRPListingCard = param.isSRPListingCard, isSRPListingCard = _param_isSRPListingCard === void 0 ? false : _param_isSRPListingCard, _param_fireImpressionByViewability = param.fireImpressionByViewability, fireImpressionByViewability = _param_fireImpressionByViewability === void 0 ? false : _param_fireImpressionByViewability, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var track = useEgClickstream();
    var _useClickstreamAnalytics3 = useClickstreamAnalytics3(), adaptexTrack = _useClickstreamAnalytics3.track;
    var clickstreamEvents = data.clickstreamEvents, id = data.id, impressionAnalytics = data.impressionAnalytics, adaptexSuccessActionTracking = data.adaptexSuccessActionTracking;
    var adaptExSuccessEvents = useAdaptExEvents(adaptexSuccessActionTracking !== null && adaptexSuccessActionTracking !== void 0 ? adaptexSuccessActionTracking : []).adaptExSuccessEvents;
    var onClick = consolidateOnclick(track, clickstreamEvents.productSelected, adaptexTrack, adaptExSuccessEvents, onClickCallback);
    var _ref = impressionAnalytics !== null && impressionAnalytics !== void 0 ? impressionAnalytics : {}, url = _ref.url, referrerId = _ref.referrerId, linkName = _ref.linkName, uisPrimeMessages = _ref.uisPrimeMessages;
    var additionalUisPrimeMicroMessages = parseLodgingCardImpressionSchema(uisPrimeMessages);
    var shouldUseViewability = url && fireImpressionByViewability;
    var componentRef = useMesoViewabilityWrapper({
        viewabilityBeacon: url
    }).componentRef;
    var onHoverChangedWithId = React56.useCallback(function(hovered) {
        onHoverChanged === null || onHoverChanged === void 0 ? void 0 : onHoverChanged(id, hovered);
    }, [
        onHoverChanged
    ]);
    useEffect2(function() {
        if (url && fireCardImpression && !fireImpressionByViewability) {
            fetch(url).then(function(response) {
                return response;
            });
        }
    }, [
        impressionAnalytics
    ]);
    var props = {
        className: className,
        data: data,
        lazyLoadImg: lazyLoadImg,
        imageRatio: imageRatio,
        onClick: onClick,
        onCardDismiss: onCardDismiss,
        onHoverChanged: onHoverChangedWithId,
        showDismissButton: showDismissButton,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        border: border,
        headingSize: headingSize,
        isSRPListingCard: isSRPListingCard,
        enableInlineLink: enableInlineLink
    };
    var lodgingCardWrapper = lodgingCardBy(view, props, index);
    var lodgingCardComponent = function() {
        if (referrerId && linkName) {
            return /* @__PURE__ */ React56.createElement(IntersectionTracker5, {
                className: lodgingCardWrapper.trackerClassName,
                referrerId: referrerId,
                linkName: linkName,
                additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages
            }, lodgingCardWrapper.lodgingCard);
        }
        return lodgingCardWrapper.lodgingCard;
    };
    return shouldUseViewability ? /* @__PURE__ */ React56.createElement("div", {
        ref: componentRef
    }, lodgingCardComponent()) : lodgingCardComponent();
};
LodgingCard.fragment = fragment44;
LodgingCard.displayName = "LodgingCard";
// ../internal/src/components/lodging-heading/lodging-heading.tsx
import React57 from "react";
import { gql as gql48 } from "@apollo/client";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
var fragment45 = gql48(_templateObject47());
var LodgingHeading = function(param) {
    var tag = param.tag, size = param.size, className = param.className, data = param.data;
    var value = data.value;
    return /* @__PURE__ */ React57.createElement(UitkHeading3, {
        tag: tag,
        size: size,
        className: className
    }, value);
};
LodgingHeading.fragment = fragment45;
LodgingHeading.displayName = "LodgingHeading";
// ../internal/src/components/lodging-intent-card/lodging-intent-card.tsx
import React59 from "react";
import { gql as gql50 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard4, UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType4 } from "uitk-react-images";
import { UitkLayoutGrid as UitkLayoutGrid7, UitkLayoutGridItem as UitkLayoutGridItem7 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkText as UitkText14 } from "uitk-react-text";
// ../internal/src/components/lodging-intent-card/__private/lodging-intent-button.tsx
import React58 from "react";
import { gql as gql49 } from "@apollo/client";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
var fragment46 = gql49(_templateObject48());
var LodgingIntentButton = function(param) {
    var data = param.data, onClickButton = param.onClickButton;
    var track = useClickTracker17();
    var onClickCapture = function() {
        var _data_action;
        if ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.analytics) {
            track(data.action.analytics.referrerId, data.action.analytics.linkName);
        }
    };
    return /* @__PURE__ */ React58.createElement(UitkSpacing13, {
        margin: {
            small: {
                blockstart: "three",
                blockend: "four"
            },
            medium: {
                blockstart: "three"
            }
        }
    }, /* @__PURE__ */ React58.createElement(UitkPrimaryButton2, {
        type: "button",
        onClickCapture: onClickCapture,
        onClick: onClickButton
    }, data.primary));
};
LodgingIntentButton.fragment = fragment46;
LodgingIntentButton.displayName = "LodgingIntentButton";
// ../internal/src/components/lodging-intent-card/lodging-intent-card.tsx
var fragment47 = gql50(_templateObject49(), LodgingMediaItem.fragment, LodgingIntentButton.fragment);
var LodgingIntentCard = function(param) {
    var data = param.data, onClickButton = param.onClickButton;
    var headingTitle = data.headingTitle, message = data.message, gallery = data.gallery, primaryButton = data.primaryButton, impressionTracking = data.impressionTracking;
    return /* @__PURE__ */ React59.createElement(IntersectionTracker6, {
        referrerId: impressionTracking.referrerId,
        linkName: impressionTracking.event
    }, /* @__PURE__ */ React59.createElement(UitkCard4, null, /* @__PURE__ */ React59.createElement(UitkLayoutGrid7, {
        columns: {
            medium: 2,
            large: 12
        }
    }, /* @__PURE__ */ React59.createElement(UitkLayoutGridItem7, {
        colSpan: {
            medium: 1,
            large: 7
        },
        rowStart: {
            small: 2,
            medium: 1
        }
    }, /* @__PURE__ */ React59.createElement(UitkSpacing14, {
        padding: {
            medium: {
                block: "two",
                inline: "four"
            }
        },
        margin: {
            medium: "three"
        }
    }, /* @__PURE__ */ React59.createElement(UitkCardContentSection4, null, headingTitle && /* @__PURE__ */ React59.createElement(UitkHeading4, {
        size: 5
    }, headingTitle), message && /* @__PURE__ */ React59.createElement(UitkSpacing14, {
        margin: {
            large: {
                inlineend: "six"
            }
        }
    }, /* @__PURE__ */ React59.createElement(UitkText14, {
        size: 300,
        spacing: "two"
    }, message)), primaryButton && /* @__PURE__ */ React59.createElement(LodgingIntentButton, {
        onClickButton: onClickButton,
        data: primaryButton
    })))), /* @__PURE__ */ React59.createElement(UitkLayoutGridItem7, {
        colSpan: {
            medium: 1,
            large: 5
        }
    }, gallery.media.length && /* @__PURE__ */ React59.createElement(LodgingMediaItem, {
        ratio: UitkFigureAspectRatioType4.R21_9,
        data: gallery.media[0]
    })))));
};
LodgingIntentCard.displayName = "LodgingIntentCard";
LodgingIntentCard.fragment = fragment47;
// ../internal/src/components/lodging-message-card/message-result.tsx
import React61 from "react";
import { gql as gql52 } from "@apollo/client";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard5 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex15, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkText as UitkText15 } from "uitk-react-text";
// ../internal/src/components/lodging-message-card/messaging-result-title-media.tsx
import React60 from "react";
import { gql as gql51 } from "@apollo/client";
import { UitkIcon as UitkIcon12, UitkIconSize as UitkIconSize9 } from "uitk-react-icons";
import { UitkIllustrations } from "uitk-react-illustrations";
import { UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark6, UitkMarkSize as UitkMarkSize6 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
var fragment48 = gql51(_templateObject50());
var MessagingResultTitleMedia = function(param) {
    var data = param.data;
    var _egdsMark_url, _illustration_assetUri;
    var egdsMark = data.egdsMark, icon = data.icon, illustration = data.illustration;
    if (!egdsMark && !icon && !illustration) {
        return null;
    }
    var graphic = egdsMark;
    var spotLight = (icon === null || icon === void 0 ? void 0 : icon.spotLight) ? icon.spotLight.toLowerCase() : void 0;
    var _egdsMark_url_value, _illustration_description, _illustration_assetUri_value;
    return /* @__PURE__ */ React60.createElement(React60.Fragment, null, graphic && /* @__PURE__ */ React60.createElement(UitkMark6, {
        id: graphic.id,
        name: graphic.id,
        size: UitkMarkSize6.MEDIUM_LARGE,
        description: graphic.description,
        url: (_egdsMark_url_value = egdsMark === null || egdsMark === void 0 ? void 0 : (_egdsMark_url = egdsMark.url) === null || _egdsMark_url === void 0 ? void 0 : _egdsMark_url.value) !== null && _egdsMark_url_value !== void 0 ? _egdsMark_url_value : ""
    }), icon && /* @__PURE__ */ React60.createElement(UitkIcon12, {
        id: icon.id,
        title: icon.id,
        name: icon.id,
        size: UitkIconSize9.MEDIUM,
        description: icon.description,
        spotlight: spotLight
    }), illustration && /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem9, {
        maxWidth: "18x"
    }, /* @__PURE__ */ React60.createElement(UitkSpacing15, {
        padding: {
            block: "half"
        }
    }, /* @__PURE__ */ React60.createElement(UitkIllustrations, {
        alt: (_illustration_description = illustration.description) !== null && _illustration_description !== void 0 ? _illustration_description : "",
        url: (_illustration_assetUri_value = (_illustration_assetUri = illustration.assetUri) === null || _illustration_assetUri === void 0 ? void 0 : _illustration_assetUri.value) !== null && _illustration_assetUri_value !== void 0 ? _illustration_assetUri_value : ""
    }))));
};
MessagingResultTitleMedia.fragment = fragment48;
MessagingResultTitleMedia.displayName = "MessagingResultTitleMedia";
// ../internal/src/components/lodging-message-card/message-result.tsx
var fragment49 = gql52(_templateObject51(), MessagingResultTitleMedia.fragment);
var getAnalytics = function(linkName, referrerId, trackClick) {
    if (linkName && referrerId) {
        return {
            id: referrerId,
            callback: function() {
                return trackClick(referrerId, linkName);
            }
        };
    }
    return void 0;
};
var getMessageGraphic = function(title, subtitle) {
    if (title && (title.icon || title.egdsMark || title.illustration)) {
        return title;
    }
    if (subtitle && (subtitle.icon || subtitle.egdsMark)) {
        return subtitle;
    }
    return void 0;
};
var getLinkTarget = function(action) {
    switch(action){
        case "EXTERNAL_LINK":
            return {
                target: "_blank"
            };
        default:
            return {};
    }
};
var MessageResult = function(param) {
    var className = param.className, data = param.data, primaryActionClickHandler = param.primaryActionClickHandler, secondaryActionClickHandler = param.secondaryActionClickHandler, liveAnnounceLevel = param.liveAnnounceLevel;
    var _primary_analytics, _secondary_analytics, _primary_analytics1, _secondary_analytics1, _primary_actionDetails;
    var title = data.title, subtitle = data.subtitle, action = data.action, footerText = data.footerText;
    var _ref = action || {}, primary = _ref.primary, secondary = _ref.secondary;
    var _primary_analytics_referrerId;
    var primaryReferrerId = (_primary_analytics_referrerId = primary === null || primary === void 0 ? void 0 : (_primary_analytics = primary.analytics) === null || _primary_analytics === void 0 ? void 0 : _primary_analytics.referrerId) !== null && _primary_analytics_referrerId !== void 0 ? _primary_analytics_referrerId : primary === null || primary === void 0 ? void 0 : primary.referrerId;
    var _secondary_analytics_referrerId;
    var secondaryReferrerId = (_secondary_analytics_referrerId = secondary === null || secondary === void 0 ? void 0 : (_secondary_analytics = secondary.analytics) === null || _secondary_analytics === void 0 ? void 0 : _secondary_analytics.referrerId) !== null && _secondary_analytics_referrerId !== void 0 ? _secondary_analytics_referrerId : secondary === null || secondary === void 0 ? void 0 : secondary.referrerId;
    var _primary_analytics_linkName;
    var primaryLinkName = (_primary_analytics_linkName = primary === null || primary === void 0 ? void 0 : (_primary_analytics1 = primary.analytics) === null || _primary_analytics1 === void 0 ? void 0 : _primary_analytics1.linkName) !== null && _primary_analytics_linkName !== void 0 ? _primary_analytics_linkName : primary === null || primary === void 0 ? void 0 : primary.text;
    var _secondary_analytics_linkName;
    var secondaryLinkName = (_secondary_analytics_linkName = secondary === null || secondary === void 0 ? void 0 : (_secondary_analytics1 = secondary.analytics) === null || _secondary_analytics1 === void 0 ? void 0 : _secondary_analytics1.linkName) !== null && _secondary_analytics_linkName !== void 0 ? _secondary_analytics_linkName : secondary === null || secondary === void 0 ? void 0 : secondary.text;
    var trackClick = useClickTracker18();
    if (!title && !subtitle) {
        return null;
    }
    var messageGraphic = getMessageGraphic(title, subtitle);
    var primaryLinkTargetAttributes = getLinkTarget(primary === null || primary === void 0 ? void 0 : (_primary_actionDetails = primary.actionDetails) === null || _primary_actionDetails === void 0 ? void 0 : _primary_actionDetails.action);
    return /* @__PURE__ */ React61.createElement(UitkCard5, {
        padded: true,
        className: className
    }, /* @__PURE__ */ React61.createElement(UitkLayoutFlex15, {
        alignItems: "center",
        "aria-live": liveAnnounceLevel,
        "data-stid": "lodging-message-card-message-result"
    }, messageGraphic && /* @__PURE__ */ React61.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React61.createElement(UitkSpacing16, {
        margin: {
            inlinestart: "half"
        }
    }, /* @__PURE__ */ React61.createElement("div", null, /* @__PURE__ */ React61.createElement(MessagingResultTitleMedia, {
        data: messageGraphic
    })))), /* @__PURE__ */ React61.createElement(UitkSpacing16, {
        margin: {
            inlinestart: "three"
        }
    }, /* @__PURE__ */ React61.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React61.createElement("div", null, /* @__PURE__ */ React61.createElement(React61.Fragment, null, /* @__PURE__ */ React61.createElement(UitkHeading5, {
        tag: "h3",
        size: 7
    }, title === null || title === void 0 ? void 0 : title.text), /* @__PURE__ */ React61.createElement(UitkText15, {
        size: 300
    }, subtitle === null || subtitle === void 0 ? void 0 : subtitle.text)), (primary || secondary) && /* @__PURE__ */ React61.createElement(UitkList, {
        bullet: "no-bullet",
        orientation: "inline",
        size: 2,
        spacing: true,
        type: "unordered"
    }, (primary === null || primary === void 0 ? void 0 : primary.linkUrl) && /* @__PURE__ */ React61.createElement(UitkListItem, null, /* @__PURE__ */ React61.createElement(UitkLink4, {
        analytics: getAnalytics(primaryLinkName, primaryReferrerId, trackClick)
    }, /* @__PURE__ */ React61.createElement("a", _objectSpread({
        href: primary.linkUrl
    }, primaryLinkTargetAttributes), primary.text))), (primary === null || primary === void 0 ? void 0 : primary.actionDetails) && (primary === null || primary === void 0 ? void 0 : primary.text) && primaryActionClickHandler && /* @__PURE__ */ React61.createElement(UitkListItem, null, /* @__PURE__ */ React61.createElement(UitkText15, {
        align: "left"
    }, /* @__PURE__ */ React61.createElement(UitkLink4, {
        onClick: primaryActionClickHandler,
        analytics: getAnalytics(primaryLinkName, primaryReferrerId, trackClick),
        inline: true
    }, /* @__PURE__ */ React61.createElement("button", {
        type: "button"
    }, primary.text)))), (secondary === null || secondary === void 0 ? void 0 : secondary.linkUrl) && /* @__PURE__ */ React61.createElement(UitkListItem, null, /* @__PURE__ */ React61.createElement(UitkLink4, {
        analytics: getAnalytics(secondaryLinkName, secondaryReferrerId, trackClick)
    }, /* @__PURE__ */ React61.createElement("a", {
        href: secondary.linkUrl
    }, secondary.text))), (secondary === null || secondary === void 0 ? void 0 : secondary.actionDetails) && (secondary === null || secondary === void 0 ? void 0 : secondary.text) && /* @__PURE__ */ React61.createElement(UitkListItem, null, /* @__PURE__ */ React61.createElement(UitkText15, {
        align: "left"
    }, /* @__PURE__ */ React61.createElement(UitkLink4, {
        onClick: secondaryActionClickHandler,
        analytics: getAnalytics(secondaryLinkName, secondaryReferrerId, trackClick),
        inline: true
    }, /* @__PURE__ */ React61.createElement("button", {
        type: "button"
    }, secondary.text))))), footerText && /* @__PURE__ */ React61.createElement(UitkText15, {
        align: "left",
        size: 100,
        spacing: "two"
    }, footerText))))));
};
MessageResult.fragment = fragment49;
MessageResult.displayName = "MessageResult";
// ../internal/src/components/lodging-sparkle-banner/lodging-sparkle-banner.tsx
import React62 from "react";
import { gql as gql53 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker7, useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium7, Viewport as Viewport7, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize3, UitkPrimaryButton as UitkPrimaryButton3 } from "uitk-react-button";
import { UitkCardBrandTheme, UitkCardContentSection as UitkCardContentSection5 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex16, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid8, UitkLayoutGridItem as UitkLayoutGridItem8 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6, UitkText as UitkText16 } from "uitk-react-text";
var fragment50 = gql53(_templateObject52(), MessagingResultTitleMedia.fragment);
var getMessageGraphic2 = function(title) {
    return (title === null || title === void 0 ? void 0 : title.egdsMark) || (title === null || title === void 0 ? void 0 : title.illustration) ? title : void 0;
};
var SparkleBanner = function(param) {
    var className = param.className, data = param.data, liveAnnounceLevel = param.liveAnnounceLevel, bannerToAddMargin = param.bannerToAddMargin;
    var trackClick = useClickTracker19();
    var action = data.action, title = data.title, type = data.type;
    var primary = (action || {}).primary;
    var bannerTheme;
    var buttonTheme;
    var buttonTextColor = type === "BRANDED_THEME_ACCENT" ? "loyalty" : "inverse";
    if (type === "BRANDED_THEME_ACCENT") {
        bannerTheme = "accent";
        buttonTheme = true;
    } else {
        bannerTheme = "dark";
        buttonTheme = false;
    }
    var componentAnalytics = primary === null || primary === void 0 ? void 0 : primary.analytics;
    var shouldTrackAnalyticsForAuthenticatedUsers = (primary === null || primary === void 0 ? void 0 : primary.linkUrl) === "";
    var handleClick = function() {
        if (componentAnalytics) {
            trackClick(componentAnalytics === null || componentAnalytics === void 0 ? void 0 : componentAnalytics.referrerId.replace(".Impression", ".Click"), "".concat(componentAnalytics === null || componentAnalytics === void 0 ? void 0 : componentAnalytics.linkName, " Click"));
        }
    };
    var messageGraphic = getMessageGraphic2(title);
    var shouldAddMargin = bannerToAddMargin === "sparklePDP";
    var _componentAnalytics_referrerId, _componentAnalytics_linkName, _componentAnalytics_referrerId1, _componentAnalytics_linkName1;
    return /* @__PURE__ */ React62.createElement("div", {
        "data-stid": "lodging-sparkle-banner-message-result-".concat(bannerTheme),
        role: "presentation",
        onClick: shouldTrackAnalyticsForAuthenticatedUsers ? handleClick : void 0
    }, /* @__PURE__ */ React62.createElement(Experiment2, {
        name: "Reduce_sparkle_banner_height"
    }, /* @__PURE__ */ React62.createElement(ExperimentControl2, null, /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        margin: shouldAddMargin ? {
            small: "three",
            medium: "unset",
            large: "unset"
        } : "unset"
    }, /* @__PURE__ */ React62.createElement(IntersectionTracker7, {
        referrerId: (_componentAnalytics_referrerId = componentAnalytics === null || componentAnalytics === void 0 ? void 0 : componentAnalytics.referrerId) !== null && _componentAnalytics_referrerId !== void 0 ? _componentAnalytics_referrerId : "",
        linkName: (_componentAnalytics_linkName = componentAnalytics === null || componentAnalytics === void 0 ? void 0 : componentAnalytics.linkName) !== null && _componentAnalytics_linkName !== void 0 ? _componentAnalytics_linkName : ""
    }, /* @__PURE__ */ React62.createElement(UitkCardBrandTheme, {
        brandTheme: bannerTheme,
        padded: true,
        className: className,
        "aria-live": liveAnnounceLevel
    }, /* @__PURE__ */ React62.createElement(UitkLayoutGrid8, {
        alignItems: "center",
        autoColumns: [
            "minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"
        ],
        columns: [
            "0fr",
            "1fr",
            "max-content"
        ],
        display: "grid"
    }, /* @__PURE__ */ React62.createElement(UitkLayoutGridItem8, {
        alignSelf: "start"
    }, /* @__PURE__ */ React62.createElement(UitkCardContentSection5, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, messageGraphic && /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        margin: shouldAddMargin ? {
            inlinestart: "half"
        } : "unset"
    }, /* @__PURE__ */ React62.createElement("div", null, /* @__PURE__ */ React62.createElement(MessagingResultTitleMedia, {
        data: messageGraphic
    }))))), /* @__PURE__ */ React62.createElement(UitkLayoutFlex16, {
        wrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React62.createElement(UitkLayoutFlexItem11, {
        grow: 1,
        maxWidth: "180x",
        alignSelf: "center"
    }, /* @__PURE__ */ React62.createElement(UitkCardContentSection5, {
        padded: true
    }, /* @__PURE__ */ React62.createElement(Viewport7, null, /* @__PURE__ */ React62.createElement(ViewSmall5, null, /* @__PURE__ */ React62.createElement(UitkHeading6, {
        size: 7
    }, title === null || title === void 0 ? void 0 : title.text)), /* @__PURE__ */ React62.createElement(ViewMedium7, null, /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React62.createElement(UitkHeading6, {
        size: 6
    }, title === null || title === void 0 ? void 0 : title.text)))))), /* @__PURE__ */ React62.createElement(UitkLayoutGrid8, null, (primary === null || primary === void 0 ? void 0 : primary.linkUrl) && /* @__PURE__ */ React62.createElement(UitkLayoutFlexItem11, {
        alignSelf: "center"
    }, /* @__PURE__ */ React62.createElement(UitkCardContentSection5, null, /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React62.createElement(UitkPrimaryButton3, {
        href: primary === null || primary === void 0 ? void 0 : primary.linkUrl,
        inverse: buttonTheme,
        onClick: handleClick,
        size: UitkButtonSize3.SMALL
    }, /* @__PURE__ */ React62.createElement(UitkText16, {
        theme: buttonTextColor
    }, primary.text)))))))))))), /* @__PURE__ */ React62.createElement(ExperimentVariant2, {
        bucket: 1
    }, /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        margin: shouldAddMargin ? {
            small: "three",
            medium: "unset",
            large: "unset"
        } : "unset"
    }, /* @__PURE__ */ React62.createElement(IntersectionTracker7, {
        referrerId: (_componentAnalytics_referrerId1 = componentAnalytics === null || componentAnalytics === void 0 ? void 0 : componentAnalytics.referrerId) !== null && _componentAnalytics_referrerId1 !== void 0 ? _componentAnalytics_referrerId1 : "",
        linkName: (_componentAnalytics_linkName1 = componentAnalytics === null || componentAnalytics === void 0 ? void 0 : componentAnalytics.linkName) !== null && _componentAnalytics_linkName1 !== void 0 ? _componentAnalytics_linkName1 : ""
    }, /* @__PURE__ */ React62.createElement(UitkCardBrandTheme, {
        brandTheme: bannerTheme,
        className: className,
        "aria-live": liveAnnounceLevel
    }, /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        padding: {
            inlinestart: "three",
            inlineend: "three",
            blockstart: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React62.createElement(UitkLayoutGrid8, {
        alignItems: "center",
        autoColumns: [
            "minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"
        ],
        columns: [
            "0fr",
            "1fr",
            "max-content"
        ],
        display: "grid"
    }, /* @__PURE__ */ React62.createElement(UitkLayoutGridItem8, {
        alignSelf: "start"
    }, /* @__PURE__ */ React62.createElement(UitkCardContentSection5, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, messageGraphic && /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        margin: shouldAddMargin ? {
            inlinestart: "half"
        } : "unset"
    }, /* @__PURE__ */ React62.createElement("div", null, /* @__PURE__ */ React62.createElement(MessagingResultTitleMedia, {
        data: messageGraphic
    }))))), /* @__PURE__ */ React62.createElement(UitkLayoutFlex16, {
        wrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React62.createElement(UitkLayoutFlexItem11, {
        grow: 1,
        maxWidth: "180x",
        alignSelf: "center"
    }, /* @__PURE__ */ React62.createElement(UitkCardContentSection5, {
        padded: true
    }, /* @__PURE__ */ React62.createElement(Viewport7, null, /* @__PURE__ */ React62.createElement(ViewSmall5, null, /* @__PURE__ */ React62.createElement(UitkHeading6, {
        size: 7
    }, title === null || title === void 0 ? void 0 : title.text)), /* @__PURE__ */ React62.createElement(ViewMedium7, null, /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React62.createElement(UitkHeading6, {
        size: 6
    }, title === null || title === void 0 ? void 0 : title.text)))))), /* @__PURE__ */ React62.createElement(UitkLayoutGrid8, null, (primary === null || primary === void 0 ? void 0 : primary.linkUrl) && /* @__PURE__ */ React62.createElement(UitkLayoutFlexItem11, {
        alignSelf: "center"
    }, /* @__PURE__ */ React62.createElement(UitkCardContentSection5, null, /* @__PURE__ */ React62.createElement(UitkSpacing17, {
        margin: {
            medium: {
                inlinestart: "one"
            },
            large: {
                inlinestart: "two"
            },
            extra_large: {
                inlinestart: "one"
            }
        }
    }, /* @__PURE__ */ React62.createElement(UitkPrimaryButton3, {
        href: primary === null || primary === void 0 ? void 0 : primary.linkUrl,
        inverse: buttonTheme,
        onClick: handleClick,
        size: UitkButtonSize3.SMALL
    }, /* @__PURE__ */ React62.createElement(UitkText16, {
        theme: buttonTextColor
    }, primary.text)))))))))))))));
};
SparkleBanner.fragment = fragment50;
SparkleBanner.displayName = "SparkleBanner";
// src/components/property-listing/__private/listing.tsx
import { ViewMedium as ViewMedium8, Viewport as Viewport9, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
// src/components/property-listing-expando-card/property-listing-expando-card.tsx
import React63 from "react";
import { gql as gql54 } from "@apollo/client";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard6, UitkCardContentSection as UitkCardContentSection6 } from "uitk-react-cards";
import { UitkExpandoList, UitkExpandoListItem } from "uitk-react-expando";
import { UitkIcon as UitkIcon13, UitkIconSize as UitkIconSize10 } from "uitk-react-icons";
import { UitkFigure as UitkFigure4, UitkFigureAspectRatioType as UitkFigureAspectRatioType5, UitkImage as UitkImage4 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex17, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkList as UitkList2 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7, UitkSubheading, UitkText as UitkText17 } from "uitk-react-text";
var fragment51 = gql54(_templateObject53());
var PropertyListingExpandoCard = function(param) {
    var data = param.data;
    var graphic = data.graphic, expandoCard = data.expandoCard, expandedContent = data.expandedContent;
    var track = useClickTracker20();
    var _React63_useState = _slicedToArray(React63.useState(expandoCard ? expandoCard.expanded : false), 2), isVisible = _React63_useState[0], setIsVisible = _React63_useState[1];
    var _React63_useState1 = _slicedToArray(React63.useState((expandoCard === null || expandoCard === void 0 ? void 0 : expandoCard.collapsedLabel) || ""), 2), expandoTitle = _React63_useState1[0], setExpandoTittle = _React63_useState1[1];
    var callback = React63.useCallback(function(id, description) {
        track(id, description);
    }, [
        track
    ]);
    if (!expandoCard || !expandedContent) return null;
    var getTitle = function(title) {
        return /* @__PURE__ */ React63.createElement(UitkLayoutFlex17, {
            space: "three",
            alignItems: "center"
        }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Illustration" && /* @__PURE__ */ React63.createElement(UitkLayoutFlexItem12, {
            maxWidth: "12x",
            alignSelf: "center"
        }, /* @__PURE__ */ React63.createElement(UitkFigure4, {
            ratio: UitkFigureAspectRatioType5.R1_1,
            imageFit: "contain"
        }, /* @__PURE__ */ React63.createElement(UitkImage4, {
            src: graphic.url,
            alt: graphic.description
        }))), /* @__PURE__ */ React63.createElement(UitkLayoutFlex17, {
            direction: "column"
        }, /* @__PURE__ */ React63.createElement(UitkText17, null, /* @__PURE__ */ React63.createElement(UitkHeading7, {
            size: 7
        }, title)), expandoCard.subtitle && /* @__PURE__ */ React63.createElement(UitkSubheading, null, expandoCard.subtitle)));
    };
    var expandoDescription = /* @__PURE__ */ React63.createElement(UitkSpacing18, {
        padding: "three",
        margin: {
            inlinestart: "three",
            blockstart: "three"
        }
    }, /* @__PURE__ */ React63.createElement("div", null, /* @__PURE__ */ React63.createElement(UitkList2, {
        bullet: "icon-alternate",
        data: expandedContent.map(function(listItem) {
            return {
                content: listItem.text,
                icon: listItem.graphic.__typename === "Icon" && /* @__PURE__ */ React63.createElement(UitkText17, null, /* @__PURE__ */ React63.createElement(UitkIcon13, {
                    theme: listItem.graphic.theme || void 0,
                    size: UitkIconSize10[listItem.graphic.size || "SMALL"],
                    name: listItem.graphic.id
                })) || void 0
            };
        })
    })));
    var handleToggle = function() {
        setIsVisible(!isVisible);
        setExpandoTittle(isVisible ? expandoCard.collapsedLabel : expandoCard.expandedLabel);
    };
    return /* @__PURE__ */ React63.createElement(UitkCard6, null, /* @__PURE__ */ React63.createElement(UitkCardContentSection6, null, /* @__PURE__ */ React63.createElement(UitkExpandoList, null, /* @__PURE__ */ React63.createElement(UitkExpandoListItem, {
        isVisible: isVisible,
        isIndented: false,
        expandoTitle: getTitle(expandoTitle),
        expandoDescription: expandoDescription,
        onToggle: handleToggle,
        triggerPosition: "trailing",
        analytics: expandoCard.collapseAnalytics && expandoCard.expandAnalytics && {
            id: isVisible ? expandoCard.expandAnalytics.referrerId : expandoCard.collapseAnalytics.referrerId,
            description: isVisible ? expandoCard.expandAnalytics.linkName : expandoCard.collapseAnalytics.linkName,
            callback: callback
        } || void 0
    }))));
};
PropertyListingExpandoCard.displayName = "PropertyListingExpandoCard";
PropertyListingExpandoCard.fragment = fragment51;
// src/components/property-listing-overfiltered/property-listing-overfiltered.tsx
import React66 from "react";
import { Link as Link2 } from "react-router-dom";
import { gql as gql57 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker8, useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/lodging-search-filter-pills/lodging-search-filter-pills.tsx
import React65 from "react";
import { useHistory as useHistory2 } from "react-router-dom";
import { gql as gql56 } from "@apollo/client";
import { ViewLarge as ViewLarge4, Viewport as Viewport8, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkPillContainer } from "uitk-react-pill";
// ../internal/src/components/lodging-egds-removable-pill/lodging-egds-removable-pill.tsx
import React64 from "react";
import { gql as gql55 } from "@apollo/client";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill } from "uitk-react-pill";
var fragment52 = gql55(_templateObject54());
var LodgingEGDSRemovablePill = function(param) {
    var data = param.data, onClick = param.onClick, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var name = data.name, value = data.value, primary = data.primary, accessibility = data.accessibility, remove = data.remove, removeAnalytics = data.removeAnalytics;
    var clickTracker = useClickTracker21();
    var handleChange = function() {
        if (removeAnalytics) {
            var linkName = removeAnalytics.linkName, referrerId = removeAnalytics.referrerId;
            clickTracker(referrerId, linkName);
        }
        if (name && value) {
            var removablePill = {
                name: name,
                value: value
            };
            onClick === null || onClick === void 0 ? void 0 : onClick(removablePill);
        }
    };
    return /* @__PURE__ */ React64.createElement(UitkRemovablePill, {
        id: "".concat(name, "-").concat(value),
        onClick: handleChange,
        value: value !== null && value !== void 0 ? value : "",
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        disabled: disabled,
        icon: (remove === null || remove === void 0 ? void 0 : remove.__typename) === "Icon" && remove.id ? remove.id : ""
    }, primary);
};
LodgingEGDSRemovablePill.fragment = fragment52;
LodgingEGDSRemovablePill.displayName = "LodgingEGDSRemovablePill";
// ../internal/src/components/lodging-search-filter-pills/lodging-search-filter-pills.tsx
var __SearchFilterPillsFragment = gql56(_templateObject55(), LodgingEGDSRemovablePill.fragment);
var SearchFilterPills = function(param) {
    var data = param.data, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_scrollTopOnRemoval = param.scrollTopOnRemoval, scrollTopOnRemoval = _param_scrollTopOnRemoval === void 0 ? false : _param_scrollTopOnRemoval;
    var updateSearchAndFilters = function updateSearchAndFilters(relativePath) {
        history.push(relativePath);
    };
    var history = useHistory2();
    if (!data || !data.filterPills) {
        return null;
    }
    var filterPills = data.filterPills;
    var pills = filterPills.map(function(pill, index) {
        var _pill_filter;
        if (pill.__typename !== "BasicShoppingAppliedFilter" || ((_pill_filter = pill.filter) === null || _pill_filter === void 0 ? void 0 : _pill_filter.__typename) !== "EGDSBasicRemovablePill") {
            return null;
        }
        return /* @__PURE__ */ React65.createElement(LodgingEGDSRemovablePill, {
            key: "filterPill".concat(index),
            data: pill.filter,
            onClick: function() {
                var _pill_linkUrl;
                if (((_pill_linkUrl = pill.linkUrl) === null || _pill_linkUrl === void 0 ? void 0 : _pill_linkUrl.resource.__typename) === "HttpURI") {
                    updateSearchAndFilters(pill.linkUrl.resource.relativePath);
                }
                if (scrollTopOnRemoval) {
                    window.scrollTo(0, 0);
                }
            },
            disabled: disabled
        });
    });
    return /* @__PURE__ */ React65.createElement(Viewport8, null, /* @__PURE__ */ React65.createElement(ViewSmall6, null, /* @__PURE__ */ React65.createElement(UitkPillContainer, {
        wrap: true,
        align: "center"
    }, pills)), /* @__PURE__ */ React65.createElement(ViewLarge4, null, /* @__PURE__ */ React65.createElement(UitkPillContainer, {
        wrap: true,
        align: "center"
    }, pills)));
};
SearchFilterPills.displayName = "SearchFilterPills";
SearchFilterPills.fragment = __SearchFilterPillsFragment;
// src/components/property-listing-overfiltered/property-listing-overfiltered.tsx
import { UitkSecondaryButton as UitkSecondaryButton2 } from "uitk-react-button";
import { UitkCard as UitkCard7 } from "uitk-react-cards";
import { UitkIcon as UitkIcon14 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex18 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8, UitkText as UitkText18 } from "uitk-react-text";
var fragment53 = gql57(_templateObject56(), SearchFilterPills.fragment);
var Graphic = function(data) {
    switch(data === null || data === void 0 ? void 0 : data.__typename){
        case "Icon":
            {
                var spotlight = data.withBackground ? "info" : void 0;
                return /* @__PURE__ */ React66.createElement(UitkIcon14, {
                    spotlight: spotlight,
                    id: data.id,
                    name: data.id,
                    title: data === null || data === void 0 ? void 0 : data.description,
                    size: (data === null || data === void 0 ? void 0 : data.iconSize) ? UitkBadgeSizeMapper[data.iconSize] : void 0
                });
            }
        default:
            return /* @__PURE__ */ React66.createElement(React66.Fragment, null);
    }
};
var PropertyListingOverfiltered = function(param) {
    var data = param.data;
    var _action_action;
    var cardContent = data.cardContent, impressionAnalytics = data.impressionAnalytics, action = data.action;
    var clickTracker = useClickTracker22();
    var clickChange = function() {
        if ((action === null || action === void 0 ? void 0 : action.button.__typename) !== "UISecondaryButton") {
            return;
        }
        if (action === null || action === void 0 ? void 0 : action.button.analytics) {
            var _action_button_analytics = action.button.analytics, linkName = _action_button_analytics.linkName, referrerId = _action_button_analytics.referrerId;
            clickTracker(referrerId, linkName);
        }
        window.scrollTo(0, 0);
    };
    var propertyListingOverfiltered = /* @__PURE__ */ React66.createElement(UitkCard7, null, /* @__PURE__ */ React66.createElement(UitkSpacing19, {
        padding: {
            block: "twelve"
        }
    }, /* @__PURE__ */ React66.createElement(UitkLayoutFlex18, {
        direction: "column",
        alignItems: "center"
    }, (cardContent === null || cardContent === void 0 ? void 0 : cardContent.graphic) && Graphic(cardContent.graphic), (cardContent === null || cardContent === void 0 ? void 0 : cardContent.heading) && /* @__PURE__ */ React66.createElement(UitkSpacing19, {
        margin: {
            blockstart: "six",
            blockend: "two"
        },
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React66.createElement(UitkHeading8, {
        size: 4,
        align: "center"
    }, cardContent.heading)), (cardContent === null || cardContent === void 0 ? void 0 : cardContent.message) && /* @__PURE__ */ React66.createElement(UitkText18, {
        size: 400
    }, cardContent.message), /* @__PURE__ */ React66.createElement(UitkSpacing19, {
        margin: {
            blockstart: "six",
            blockend: "two"
        }
    }, /* @__PURE__ */ React66.createElement(UitkLayoutFlex18, null, /* @__PURE__ */ React66.createElement(SearchFilterPills, {
        data: data,
        disabled: false,
        scrollTopOnRemoval: true
    }))), (action === null || action === void 0 ? void 0 : action.button.__typename) === "UISecondaryButton" && /* @__PURE__ */ React66.createElement(UitkSpacing19, {
        margin: {
            blockstart: "six",
            blockend: "two"
        }
    }, /* @__PURE__ */ React66.createElement(UitkSecondaryButton2, {
        onClick: clickChange
    }, /* @__PURE__ */ React66.createElement(Link2, {
        style: {
            textDecoration: "none"
        },
        to: ((_action_action = action.action) === null || _action_action === void 0 ? void 0 : _action_action.resource.__typename) === "HttpURI" && action.action.resource.relativePath
    }, action === null || action === void 0 ? void 0 : action.button.primary))))));
    var component = impressionAnalytics ? /* @__PURE__ */ React66.createElement(IntersectionTracker8, {
        referrerId: impressionAnalytics.referrerId,
        linkName: impressionAnalytics.event
    }, propertyListingOverfiltered) : propertyListingOverfiltered;
    return component;
};
PropertyListingOverfiltered.fragment = fragment53;
PropertyListingOverfiltered.displayName = "PropertyListingOverfiltered";
// src/components/property-listing-sold-out/property-listing-sold-out.tsx
import React67 from "react";
import { gql as gql58 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker9, useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton as UitkSecondaryButton3 } from "uitk-react-button";
import { UitkCard as UitkCard8 } from "uitk-react-cards";
import { UitkIcon as UitkIcon15 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex19 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9 } from "uitk-react-text";
var fragment54 = gql58(_templateObject57());
var Graphic2 = function(data) {
    switch(data === null || data === void 0 ? void 0 : data.__typename){
        case "Icon":
            {
                var spotlight = data.withBackground ? "info" : void 0;
                var _data_title, _data_theme;
                return /* @__PURE__ */ React67.createElement(UitkIcon15, {
                    spotlight: spotlight,
                    name: data.id,
                    id: data.id,
                    title: (_data_title = data === null || data === void 0 ? void 0 : data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
                    theme: (_data_theme = data === null || data === void 0 ? void 0 : data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
                    description: data === null || data === void 0 ? void 0 : data.description,
                    size: (data === null || data === void 0 ? void 0 : data.iconSize) ? UitkBadgeSizeMapper[data.iconSize] : void 0
                });
            }
        default:
            return /* @__PURE__ */ React67.createElement(React67.Fragment, null);
    }
};
var PropertyListingSoldOut = function(param) {
    var _param_data = param.data, cardContent = _param_data.cardContent, analytics = _param_data.analytics, actionButton = _param_data.actionButton, onClick = param.onClick;
    var clickTracker = useClickTracker23();
    var clickChange = function() {
        if (actionButton === null || actionButton === void 0 ? void 0 : actionButton.analytics) {
            var _actionButton_analytics = actionButton.analytics, referrerId = _actionButton_analytics.referrerId, linkName = _actionButton_analytics.linkName;
            clickTracker(referrerId, linkName);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    var propertyListingSoldOut = /* @__PURE__ */ React67.createElement(UitkSpacing20, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React67.createElement(UitkCard8, null, /* @__PURE__ */ React67.createElement(UitkSpacing20, {
        padding: {
            block: "twelve"
        }
    }, /* @__PURE__ */ React67.createElement(UitkLayoutFlex19, {
        direction: "column",
        justifyContent: "center",
        alignItems: "center"
    }, (cardContent === null || cardContent === void 0 ? void 0 : cardContent.graphic) && Graphic2(cardContent.graphic), (cardContent === null || cardContent === void 0 ? void 0 : cardContent.heading) && /* @__PURE__ */ React67.createElement(UitkSpacing20, {
        margin: {
            blockstart: "six",
            blockend: "two"
        },
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React67.createElement(UitkHeading9, {
        tag: "h3",
        size: 4,
        align: "center"
    }, cardContent.heading)), actionButton && /* @__PURE__ */ React67.createElement(UitkSecondaryButton3, {
        onClick: clickChange
    }, actionButton.primary)))));
    var component = analytics ? /* @__PURE__ */ React67.createElement(IntersectionTracker9, {
        referrerId: analytics.referrerId,
        linkName: analytics.linkName || ""
    }, propertyListingSoldOut) : propertyListingSoldOut;
    return component;
};
PropertyListingSoldOut.fragment = fragment54;
PropertyListingSoldOut.displayName = "PropertyListingSoldOut";
// src/components/property-listing-standard-messaging-card/property-listing-standard-messaging-card.tsx
import React68 from "react";
import { useHistory as useHistory3 } from "react-router-dom";
import { gql as gql59 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker10, useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard9 } from "uitk-react-cards";
import { UitkFigure as UitkFigure5, UitkFigureAspectRatioType as UitkFigureAspectRatioType6, UitkImage as UitkImage5 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex20, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink5 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10, UitkText as UitkText19 } from "uitk-react-text";
var fragment55 = gql59(_templateObject58());
var PropertyListingStandardMessagingCard = function(param) {
    var data = param.data, onClick = param.onClick;
    var history = useHistory3();
    var graphic = data.graphic, heading = data.heading, cardMessage = data.cardMessage, links = data.links, impressionAnalyticsTracking = data.impressionAnalyticsTracking;
    var relativePath = (links === null || links === void 0 ? void 0 : links[0].action.resource.__typename) === "HttpURI" && links[0].action.resource.relativePath;
    var trackClick = useClickTracker24();
    var handleClick = function(clientSideAnalytics, path) {
        if (onClick) {
            onClick(data === null || data === void 0 ? void 0 : data.egdsElementId);
        } else {
            history.push(path);
        }
        trackClick(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
    };
    var propertyListingMessagingCard = /* @__PURE__ */ React68.createElement(UitkCard9, {
        padded: true
    }, /* @__PURE__ */ React68.createElement(UitkLayoutFlex20, {
        space: "three"
    }, graphic && graphic.__typename === "Illustration" && /* @__PURE__ */ React68.createElement(UitkLayoutFlexItem13, {
        maxWidth: "12x",
        alignSelf: "center"
    }, /* @__PURE__ */ React68.createElement(UitkFigure5, {
        ratio: UitkFigureAspectRatioType6.R1_1,
        imageFit: "contain"
    }, /* @__PURE__ */ React68.createElement(UitkImage5, {
        src: graphic.url,
        alt: graphic.description
    }))), /* @__PURE__ */ React68.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React68.createElement(UitkLayoutFlex20, {
        direction: "column"
    }, heading && /* @__PURE__ */ React68.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React68.createElement(UitkHeading10, {
        tag: "h3",
        size: 7
    }, heading)), /* @__PURE__ */ React68.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React68.createElement(UitkText19, null, cardMessage)), relativePath && /* @__PURE__ */ React68.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React68.createElement(UitkSpacing21, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React68.createElement(UitkLink5, {
        onClick: function() {
            handleClick(links[0].action.analytics, relativePath);
        }
    }, /* @__PURE__ */ React68.createElement("button", {
        type: "button"
    }, links[0].text))))))));
    var _impressionAnalyticsTracking_referrerId, _impressionAnalyticsTracking_linkName;
    return /* @__PURE__ */ React68.createElement(IntersectionTracker10, {
        referrerId: (_impressionAnalyticsTracking_referrerId = impressionAnalyticsTracking === null || impressionAnalyticsTracking === void 0 ? void 0 : impressionAnalyticsTracking.referrerId) !== null && _impressionAnalyticsTracking_referrerId !== void 0 ? _impressionAnalyticsTracking_referrerId : "",
        linkName: (_impressionAnalyticsTracking_linkName = impressionAnalyticsTracking === null || impressionAnalyticsTracking === void 0 ? void 0 : impressionAnalyticsTracking.linkName) !== null && _impressionAnalyticsTracking_linkName !== void 0 ? _impressionAnalyticsTracking_linkName : ""
    }, propertyListingMessagingCard);
};
PropertyListingStandardMessagingCard.fragment = fragment55;
PropertyListingStandardMessagingCard.displayName = "PropertyListingStandardMessagingCard";
// src/components/sponsored-content-placement/sponsored-content-placement.tsx
import React69 from "react";
import { gql as gql60 } from "@apollo/client";
import { MultiListingAd } from "@shared-ui/retail-lodging-multi-listing-ad";
import { BrandResultListing } from "@shared-ui/sponsored-content-brand-result-listing";
import { DestinationExperience } from "@shared-ui/sponsored-content-destination-experience";
var fragment56 = gql60(_templateObject59());
function stripGraphQlMetadata(obj) {
    return JSON.parse(JSON.stringify(obj, function(k, v) {
        return k.startsWith("__") ? void 0 : v;
    }));
}
var SponsoredContentPlacement = function(param) {
    var criteria = param.criteria, data = param.data;
    var productType = data.productType, sponsoredContentContext = data.sponsoredContentContext;
    var sponsoredContentContextInput = stripGraphQlMetadata(sponsoredContentContext);
    var searchCriteriaInput = criteria ? {
        properties: [
            criteria
        ]
    } : {
        properties: null
    };
    if (sponsoredContentContextInput.targeting !== void 0) {
        switch(productType){
            case "BRAND_RESULT_LISTING_LODGING" /* BRAND_RESULT_LISTING_LODGING */ :
                return /* @__PURE__ */ React69.createElement(BrandResultListing, {
                    inputs: {
                        sponsoredContentContext: sponsoredContentContextInput
                    },
                    skipSsr: true,
                    impressionOnly: false,
                    rooms: criteria === null || criteria === void 0 ? void 0 : criteria.primary.rooms
                });
            case "MULTI_LISTING_AD" /* MULTI_LISTING_AD */ :
                return /* @__PURE__ */ React69.createElement(MultiListingAd, {
                    inputs: {
                        sponsoredContentContextInput: sponsoredContentContextInput,
                        searchCriteriaInput: searchCriteriaInput
                    },
                    skipSsr: true,
                    name: "multi-listing-ad"
                });
            case "DESTINATION_EXPERIENCE" /* DESTINATION_EXPERIENCE */ :
                return /* @__PURE__ */ React69.createElement(DestinationExperience, {
                    inputs: {
                        sponsoredContentContext: sponsoredContentContextInput
                    },
                    skipSsr: true
                });
            default:
                return null;
        }
    }
    return null;
};
SponsoredContentPlacement.fragment = fragment56;
SponsoredContentPlacement.displayName = "SponsoredContentPlacement";
// src/components/property-listing/__private/__fragments/lodging-static-multi-item-cross-sell.tsx
import React70 from "react";
import { gql as gql61 } from "@apollo/client";
import { StaticMultiItemCrossSell } from "@shared-ui/multi-item-static-cross-sell";
var fragment57 = gql61(_templateObject60(), MessageResult.fragment);
function stripGraphQlMetadata2(obj) {
    return JSON.parse(JSON.stringify(obj, function(k, v) {
        return k.startsWith("__") || k.endsWith("__") ? void 0 : v;
    }));
}
var LodgingStaticMultiItemCrossSell = function(param) {
    var data = param.data, className = param.className;
    var fallbackListing = data.fallbackListing, crossSellProductType = data.crossSellProductType, multiItemSearchContext = data.multiItemSearchContext;
    if (!crossSellProductType) {
        return null;
    }
    var sanitizedSearchContext = stripGraphQlMetadata2(multiItemSearchContext);
    var NoResultFallback = (fallbackListing === null || fallbackListing === void 0 ? void 0 : fallbackListing.__typename) === "MessageResult" ? function() {
        return /* @__PURE__ */ React70.createElement(MessageResult, {
            data: fallbackListing
        });
    } : void 0;
    return /* @__PURE__ */ React70.createElement("div", {
        "data-stid": "lodging-static-multi-item-cross-sell",
        className: className
    }, /* @__PURE__ */ React70.createElement(StaticMultiItemCrossSell, {
        inputs: {
            searchContext: sanitizedSearchContext,
            crossSellProductType: crossSellProductType
        },
        noResultsFallback: NoResultFallback
    }));
};
LodgingStaticMultiItemCrossSell.fragment = fragment57;
LodgingStaticMultiItemCrossSell.displayName = "LodgingStaticMultiItemCrossSell";
// src/components/property-listing/__private/__fragments/property-search-listing-placeholder.tsx
import React71 from "react";
import { gql as gql62 } from "@apollo/client";
import { InstallmentPlan } from "@shared-ui/retail-multi-item-installment-plan";
import { UitkLayoutFlex as UitkLayoutFlex21 } from "uitk-react-layout-flex";
var fragment58 = gql62(_templateObject61());
var PropertySearchListingPlaceholder = function(param) {
    var data = param.data;
    var loadingComponent = data.loadingComponent;
    switch(loadingComponent){
        case "InstallmentPlan":
        case "InstallmentPlanAffirm":
            return /* @__PURE__ */ React71.createElement(UitkLayoutFlex21, {
                justifyContent: "center",
                "data-stid": "lodging-installment-plan"
            }, /* @__PURE__ */ React71.createElement(InstallmentPlan, {
                inputs: {
                    multiItemSessionId: null,
                    amount: null
                },
                margin: {
                    blockstart: "two"
                },
                placeholderMargin: {
                    blockstart: "three"
                },
                minWidth: "4x"
            }));
        case "InstallmentPlanKlarna":
            return /* @__PURE__ */ React71.createElement(UitkLayoutFlex21, {
                justifyContent: "center",
                "data-stid": "lodging-installment-plan"
            }, /* @__PURE__ */ React71.createElement(InstallmentPlan, {
                inputs: {
                    multiItemSessionId: null,
                    amount: null
                },
                margin: {
                    blockstart: "two"
                },
                placeholderMargin: {
                    blockstart: "three",
                    blockend: "half"
                },
                minWidth: "4x__half"
            }));
        default:
            return null;
    }
};
PropertySearchListingPlaceholder.fragment = fragment58;
PropertySearchListingPlaceholder.displayName = "PropertySearchListingPlaceholder";
// src/components/property-listing/__private/listing.tsx
var fragment59 = gql63(_templateObject62(), LodgingCard.fragment, LodgingHeading.fragment, LodgingIntentCard.fragment, LodgingStaticMultiItemCrossSell.fragment, MessageResult.fragment, SponsoredContentPlacement.fragment, PropertyListingSoldOut.fragment, PropertyListingOverfiltered.fragment, PropertyListingStandardMessagingCard.fragment, PropertyListingExpandoCard.fragment, SparkleBanner.fragment, PropertySearchListingPlaceholder.fragment);
var Listing = function(param) {
    var data = param.data, index = param.index, _param_isMultiItem = param.isMultiItem, isMultiItem = _param_isMultiItem === void 0 ? false : _param_isMultiItem, criteria = param.criteria, isSRPListing = param.isSRPListing, openDatePicker = param.openDatePicker, onClickCallback = param.onClickCallback, onHoverChanged = param.onHoverChanged;
    var __typename = data.__typename;
    var shouldLazyLoadImg = index >= 3;
    var handleClickCallBack = function() {
        onClickCallback === null || onClickCallback === void 0 ? void 0 : onClickCallback(data);
    };
    var addCallBack = function(messageCardData) {
        return (messageCardData === null || messageCardData === void 0 ? void 0 : messageCardData.egdsElementId) === "propertySelectDateCard" && {
            onClick: openDatePicker
        };
    };
    var lodgingCard = function(lodgingCardData, view) {
        return /* @__PURE__ */ React72.createElement(Experiment3, {
            name: "TravelAds_Viewability_Impression_Tracking"
        }, /* @__PURE__ */ React72.createElement(ExperimentControl3, null, /* @__PURE__ */ React72.createElement(LodgingCard, {
            data: lodgingCardData,
            view: view,
            lazyLoadImg: shouldLazyLoadImg,
            onClickCallback: handleClickCallBack,
            onHoverChanged: onHoverChanged,
            index: index,
            isSRPListingCard: isSRPListing,
            enableInlineLink: true
        })), /* @__PURE__ */ React72.createElement(ExperimentVariant3, {
            bucket: 1
        }, /* @__PURE__ */ React72.createElement(LodgingCard, {
            data: lodgingCardData,
            view: view,
            lazyLoadImg: shouldLazyLoadImg,
            onClickCallback: handleClickCallBack,
            onHoverChanged: onHoverChanged,
            index: index,
            fireCardImpression: false,
            isSRPListingCard: isSRPListing,
            fireImpressionByViewability: true,
            enableInlineLink: true
        })));
    };
    var compactCardWrapper = function(lodgingCardFragmentData) {
        return /* @__PURE__ */ React72.createElement(Experiment3, {
            name: "Compact_SRP_Property_Card_mWeb"
        }, /* @__PURE__ */ React72.createElement(ExperimentControl3, null, lodgingCard(lodgingCardFragmentData)), /* @__PURE__ */ React72.createElement(ExperimentVariant3, {
            bucket: 1
        }, lodgingCard(lodgingCardFragmentData, "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ )), /* @__PURE__ */ React72.createElement(ExperimentVariant3, {
            bucket: 2
        }, lodgingCard(lodgingCardFragmentData, "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ )));
    };
    var listingSpacing = {
        blockstart: "three"
    };
    switch(__typename){
        case "LodgingCard":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: listingSpacing
            }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(Viewport9, null, /* @__PURE__ */ React72.createElement(ViewSmall7, null, isMultiItem ? lodgingCard(data) : compactCardWrapper(data)), /* @__PURE__ */ React72.createElement(ViewMedium8, null, lodgingCard(data)))));
        case "LodgingIntentCard":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: {
                    blockstart: "four"
                }
            }, /* @__PURE__ */ React72.createElement(LodgingIntentCard, {
                data: data
            }));
        case "LodgingHeading":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                padding: {
                    blockstart: "three"
                },
                margin: listingSpacing
            }, /* @__PURE__ */ React72.createElement(LodgingHeading, {
                tag: "h2",
                size: 5,
                data: data
            }));
        case "MessageResult":
            return /* @__PURE__ */ React72.createElement(Experiment3, {
                name: "EDR_Lodging_SRP"
            }, /* @__PURE__ */ React72.createElement(ExperimentControl3, null, /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: listingSpacing
            }, data.type === "BRANDED_THEME_ACCENT" /* BRANDED_THEME_ACCENT */  || data.type === "BRANDED_THEME_DARK" /* BRANDED_THEME_DARK */  ? /* @__PURE__ */ React72.createElement(SparkleBanner, {
                data: data
            }) : /* @__PURE__ */ React72.createElement(MessageResult, {
                data: data
            }))), /* @__PURE__ */ React72.createElement(ExperimentVariant3, {
                bucket: 1
            }));
        case "SponsoredContentPlacement":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: listingSpacing
            }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(SponsoredContentPlacement, {
                data: data,
                criteria: criteria
            })));
        case "StaticLodgingMultiItemCrossSell":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: listingSpacing
            }, /* @__PURE__ */ React72.createElement(LodgingStaticMultiItemCrossSell, {
                data: data
            }));
        case "PropertySearchListingsSoldOutCard":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: listingSpacing
            }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(PropertyListingSoldOut, {
                data: data,
                onClick: openDatePicker
            })));
        case "PropertySearchListingsOverfilteredCard":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: listingSpacing
            }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(PropertyListingOverfiltered, {
                data: data
            })));
        case "EGDSStandardMessagingCard":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: listingSpacing
            }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(PropertyListingStandardMessagingCard, _objectSpread({
                data: data
            }, addCallBack(data)))));
        case "PropertyListingsIconTextExpando":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index,
                margin: listingSpacing
            }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(PropertyListingExpandoCard, {
                data: data
            })));
        case "PropertySearchListingPlaceholder":
            return /* @__PURE__ */ React72.createElement(UitkSpacing22, {
                key: index
            }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(PropertySearchListingPlaceholder, {
                data: data
            })));
        default:
            return null;
    }
};
Listing.fragment = fragment59;
Listing.displayName = "Listing";
// src/components/property-listing/placeholders.tsx
import React73 from "react";
import { UitkCard as UitkCard10, UitkCardContentSection as UitkCardContentSection7 } from "uitk-react-cards";
import { UitkFigure as UitkFigure6, UitkFigureAspectRatioType as UitkFigureAspectRatioType7 } from "uitk-react-images";
import { UitkLayoutGrid as UitkLayoutGrid9, UitkLayoutGridItem as UitkLayoutGridItem9 } from "uitk-react-layout-grid";
import { UitkBlockSkeleton, UitkLineSkeleton as UitkLineSkeleton2 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
var SearchListingPlaceholder = function() {
    return /* @__PURE__ */ React73.createElement(UitkSpacing23, {
        margin: {
            block: "four"
        }
    }, /* @__PURE__ */ React73.createElement(UitkCard10, null, /* @__PURE__ */ React73.createElement(UitkLayoutGrid9, {
        columns: 3
    }, /* @__PURE__ */ React73.createElement(UitkLayoutGridItem9, {
        colSpan: 1
    }, /* @__PURE__ */ React73.createElement(CardGalleryPlaceholder, {
        aspectRatio: UitkFigureAspectRatioType7.R21_9
    })), /* @__PURE__ */ React73.createElement(UitkLayoutGridItem9, {
        colSpan: 2
    }, /* @__PURE__ */ React73.createElement(UitkSpacing23, {
        padding: {
            blockend: "twelve"
        }
    }, /* @__PURE__ */ React73.createElement("div", null, /* @__PURE__ */ React73.createElement(CardContentPlaceholder, null)))))));
};
SearchListingPlaceholder.displayName = "SearchListingPlaceholder";
var CardGalleryPlaceholder = function(param) {
    var aspectRatio = param.aspectRatio;
    return /* @__PURE__ */ React73.createElement(UitkFigure6, {
        ratio: aspectRatio
    }, /* @__PURE__ */ React73.createElement(UitkBlockSkeleton, null));
};
CardGalleryPlaceholder.displayName = "CardGalleryPlaceholder";
var CardContentPlaceholder = function(param) {
    var border = param.border;
    return /* @__PURE__ */ React73.createElement(UitkCardContentSection7, {
        border: border
    }, /* @__PURE__ */ React73.createElement(PaddedSkeletonText, null), /* @__PURE__ */ React73.createElement(PaddedSkeletonText, {
        margin: {
            blockend: "twelve"
        },
        type: "secondary"
    }));
};
CardContentPlaceholder.displayName = "CardContentPlaceholder";
var PaddedSkeletonText = function(param) {
    var _param_margin = param.margin, margin = _param_margin === void 0 ? {
        blockend: "two"
    } : _param_margin, type = param.type;
    return /* @__PURE__ */ React73.createElement(UitkSpacing23, {
        margin: margin
    }, /* @__PURE__ */ React73.createElement(UitkLineSkeleton2, {
        animation: true,
        type: type
    }));
};
PaddedSkeletonText.displayName = "PaddedSkeletonText";
// src/components/property-listing/use-secondary-property-listing-fetch.tsx
import { useEffect as useEffect3 } from "react";
var SECONDARY_FETCH_CRITERIA_ID = "shouldFetchSecondaryBatch";
function useSecondaryPropertyListingFetch(shouldMakeSecondaryFetch, nextSubSet, handlePagination) {
    useEffect3(function() {
        if (!shouldMakeSecondaryFetch || !nextSubSet) {
            return;
        }
        var size = nextSubSet.size, startingIndex = nextSubSet.startingIndex;
        handlePagination(startingIndex, size);
    }, [
        nextSubSet,
        shouldMakeSecondaryFetch,
        handlePagination
    ]);
}
// src/components/property-listing/property-listing.tsx
var INITIAL_LOAD_THRESHOLD = 20;
var LAZY_LOAD_OFFSET = 2e3;
var StateProvider = buildStateProvider2(new ValidatedInputsState2(), TripsToastStateChunk, LodgingCompareStateChunk);
var __PropertyListingQuery = gql64(_templateObject63(), AdaptExAnalyticsEventFragment, Listing.fragment);
var PropertyListing = function(props) {
    var handlePaginationWithTracking = function handlePaginationWithTracking() {
        var nextPaginationStartingIndex = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var _data_propertySearch_pagination;
        handlePagination(nextPaginationStartingIndex);
        var trigger = (_data_propertySearch_pagination = data === null || data === void 0 ? void 0 : data.propertySearch.pagination) === null || _data_propertySearch_pagination === void 0 ? void 0 : _data_propertySearch_pagination.trigger;
        if ((trigger === null || trigger === void 0 ? void 0 : trigger.__typename) === "UIPrimaryButton") {
            var _trigger_analytics, _trigger_analytics1;
            var _trigger_analytics_referrerId, _trigger_analytics_linkName;
            clickTracker((_trigger_analytics_referrerId = (_trigger_analytics = trigger.analytics) === null || _trigger_analytics === void 0 ? void 0 : _trigger_analytics.referrerId) !== null && _trigger_analytics_referrerId !== void 0 ? _trigger_analytics_referrerId : "", (_trigger_analytics_linkName = (_trigger_analytics1 = trigger.analytics) === null || _trigger_analytics1 === void 0 ? void 0 : _trigger_analytics1.linkName) !== null && _trigger_analytics_linkName !== void 0 ? _trigger_analytics_linkName : "");
        }
    };
    var _pagination_subSets, _pagination_trigger, _pagination_subSets1;
    var batchKey = props.batchKey, inputs = props.inputs, skipSsr = props.skipSsr, propertySearchListingsPwa = props.propertySearchListingsPwa, propertySearchListingAdaptexAnalyticsEvents = props.propertySearchListingAdaptexAnalyticsEvents, isLoadingPwa = props.isLoadingPwa, openDatePicker = props.openDatePicker, onClickCallback = props.onClickCallback, onHoverChanged = props.onHoverChanged, onPaginationCallback = props.onPaginationCallback;
    var context = useBexApi().context;
    var exposure = useExperiment("SRP_Sticky_Search_Form").exposure;
    var showLoadingList = isLoadingPwa && (!propertySearchListingsPwa || propertySearchListingsPwa.length === 0);
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var shouldSkipQuery = Boolean(propertySearchListingsPwa);
    var _useState = _slicedToArray(useState(false), 2), paginationLoading = _useState[0], setPaginationLoading = _useState[1];
    var _useState1 = _slicedToArray(useState(), 2), paginationData = _useState1[0], setPaginationData = _useState1[1];
    var _useState2 = _slicedToArray(useState(), 2), secondaryCriteriaBooleans = _useState2[0], setSecondaryCriteriaBooleans = _useState2[1];
    var _useState3 = _slicedToArray(useState(), 2), propertySearchListings = _useState3[0], setPropertySearchListings = _useState3[1];
    var queryOptions = {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipQuery
    };
    var clickTracker = useClickTracker25();
    var _useQuery = useQuery(__PropertyListingQuery, queryOptions), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, fetchMore = _useQuery.fetchMore;
    var isInitialLoad = !data && loading;
    var criteriaString = JSON.stringify(inputs.criteria);
    React74.useEffect(function() {
        var _data_propertySearch_pagination, _data_propertySearch_criteria_secondary;
        setPropertySearchListings(data === null || data === void 0 ? void 0 : data.propertySearch.propertySearchListings);
        setPaginationData(data === null || data === void 0 ? void 0 : data.propertySearch.pagination);
        if ((_data_propertySearch_pagination = data === null || data === void 0 ? void 0 : data.propertySearch.pagination) === null || _data_propertySearch_pagination === void 0 ? void 0 : _data_propertySearch_pagination.subSets) {
            onPaginationCallback === null || onPaginationCallback === void 0 ? void 0 : onPaginationCallback(data.propertySearch.pagination.subSets);
        }
        setSecondaryCriteriaBooleans((_data_propertySearch_criteria_secondary = data === null || data === void 0 ? void 0 : data.propertySearch.criteria.secondary) === null || _data_propertySearch_criteria_secondary === void 0 ? void 0 : _data_propertySearch_criteria_secondary.booleans);
    }, [
        criteriaString,
        isInitialLoad
    ]);
    var _ref, _ref1;
    var listings = (_ref1 = (_ref = propertySearchListingsPwa !== null && propertySearchListingsPwa !== void 0 ? propertySearchListingsPwa : propertySearchListings) !== null && _ref !== void 0 ? _ref : data === null || data === void 0 ? void 0 : data.propertySearch.propertySearchListings) !== null && _ref1 !== void 0 ? _ref1 : [];
    var pagination = paginationData !== null && paginationData !== void 0 ? paginationData : data === null || data === void 0 ? void 0 : data.propertySearch.pagination;
    var _listings_filter;
    var searchResultsProperties = React74.useMemo(function() {
        return (_listings_filter = listings === null || listings === void 0 ? void 0 : listings.filter(function(listing) {
            return listing.__typename === "LodgingCard";
        })) !== null && _listings_filter !== void 0 ? _listings_filter : [];
    }, [
        listings
    ]);
    var hasNextSubset = !!(pagination === null || pagination === void 0 ? void 0 : (_pagination_subSets = pagination.subSets) === null || _pagination_subSets === void 0 ? void 0 : _pagination_subSets.nextSubSet);
    var paginationTriggerType = pagination === null || pagination === void 0 ? void 0 : (_pagination_trigger = pagination.trigger) === null || _pagination_trigger === void 0 ? void 0 : _pagination_trigger.__typename;
    var isShowMorePagination = paginationTriggerType === "UIPrimaryButton";
    var onHoverCallback = isShowMorePagination ? void 0 : onHoverChanged;
    var shouldDisplayShowMoreButton = !shouldSkipQuery && isShowMorePagination;
    var showMoreTriggerData = paginationTriggerType === "UIPrimaryButton" ? pagination === null || pagination === void 0 ? void 0 : pagination.trigger : void 0;
    var shouldDisplayPaginationArrows = !shouldSkipQuery && !isShowMorePagination;
    function handlePagination() {
        return _handlePagination.apply(this, arguments);
    }
    function _handlePagination() {
        _handlePagination = _asyncToGenerator(function() {
            var nextPaginationStartingIndex, nextPaginationSize, _inputs_criteria, _newPaginationData_propertySearch_pagination, _newPaginationData_propertySearch_criteria, _newPaginationData_propertySearch_criteria_secondary, _ref, newPaginationData, nextPropertySearchListings;
            var _arguments = arguments;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        nextPaginationStartingIndex = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0, nextPaginationSize = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 50;
                        setPaginationLoading(true);
                        return [
                            4,
                            fetchMore({
                                variables: {
                                    criteria: _objectSpreadProps(_objectSpread({}, inputs.criteria), {
                                        secondary: _objectSpreadProps(_objectSpread({}, (_inputs_criteria = inputs.criteria) === null || _inputs_criteria === void 0 ? void 0 : _inputs_criteria.secondary), {
                                            counts: [
                                                {
                                                    id: "resultsSize",
                                                    value: nextPaginationSize
                                                },
                                                {
                                                    id: "resultsStartingIndex",
                                                    value: nextPaginationStartingIndex
                                                }
                                            ]
                                        })
                                    })
                                }
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), newPaginationData = _ref.data;
                        nextPropertySearchListings = isShowMorePagination ? listings.concat(newPaginationData.propertySearch.propertySearchListings) : newPaginationData.propertySearch.propertySearchListings;
                        setPropertySearchListings(nextPropertySearchListings);
                        if ((_newPaginationData_propertySearch_pagination = newPaginationData.propertySearch.pagination) === null || _newPaginationData_propertySearch_pagination === void 0 ? void 0 : _newPaginationData_propertySearch_pagination.subSets) {
                            setPaginationData(newPaginationData.propertySearch.pagination);
                            onPaginationCallback === null || onPaginationCallback === void 0 ? void 0 : onPaginationCallback(newPaginationData.propertySearch.pagination.subSets);
                        }
                        setSecondaryCriteriaBooleans((_newPaginationData_propertySearch_criteria = newPaginationData.propertySearch.criteria) === null || _newPaginationData_propertySearch_criteria === void 0 ? void 0 : (_newPaginationData_propertySearch_criteria_secondary = _newPaginationData_propertySearch_criteria.secondary) === null || _newPaginationData_propertySearch_criteria_secondary === void 0 ? void 0 : _newPaginationData_propertySearch_criteria_secondary.booleans);
                        setPaginationLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handlePagination.apply(this, arguments);
    }
    var shouldMakeSecondaryFetch = !paginationLoading && hasNextSubset && !!paginationTriggerType && !!(secondaryCriteriaBooleans === null || secondaryCriteriaBooleans === void 0 ? void 0 : secondaryCriteriaBooleans.find(function(param) {
        var id = param.id, value = param.value;
        return id === SECONDARY_FETCH_CRITERIA_ID && value;
    }));
    useSecondaryPropertyListingFetch(shouldMakeSecondaryFetch, pagination === null || pagination === void 0 ? void 0 : (_pagination_subSets1 = pagination.subSets) === null || _pagination_subSets1 === void 0 ? void 0 : _pagination_subSets1.nextSubSet, handlePagination);
    var _ref2;
    var propertyListingAdaptexAnalyticsSuccessEvents = (_ref2 = (data === null || data === void 0 ? void 0 : data.propertySearch.propertyListingAdaptexAnalyticsSuccessEvents) || propertySearchListingAdaptexAnalyticsEvents) !== null && _ref2 !== void 0 ? _ref2 : [];
    var scrollToTop = React74.useRef(null);
    React74.useEffect(function() {
        if (exposure.bucket === 0 && (scrollToTop === null || scrollToTop === void 0 ? void 0 : scrollToTop.current) && (loading || paginationLoading || shouldSkipQuery)) {
            scrollToTop.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        }
    }, [
        loading,
        paginationLoading,
        searchResultsProperties,
        shouldSkipQuery
    ]);
    if (!isShowMorePagination && paginationLoading || isInitialLoad || showLoadingList) {
        var loadingList = _toConsumableArray(Array(6));
        return /* @__PURE__ */ React74.createElement(React74.Fragment, null, /* @__PURE__ */ React74.createElement("div", {
            ref: isShowMorePagination ? void 0 : scrollToTop
        }, loadingList.map(function(_, index) {
            return /* @__PURE__ */ React74.createElement(SearchListingPlaceholder, {
                key: "placeholder-".concat(index)
            });
        })), shouldDisplayPaginationArrows && /* @__PURE__ */ React74.createElement(PropertyListingPagination, {
            handlePagination: handlePagination,
            isLoading: true,
            pagination: pagination
        }));
    }
    if (error) {
        return null;
    }
    var _showMoreTriggerData_accessibility;
    return /* @__PURE__ */ React74.createElement(StateProvider, null, /* @__PURE__ */ React74.createElement(LodgingCompareStateManager, {
        searchResultsProperties: searchResultsProperties
    }, /* @__PURE__ */ React74.createElement(AdaptExEventsProvider, {
        value: {
            adaptExSuccessEvents: propertyListingAdaptexAnalyticsSuccessEvents
        }
    }, /* @__PURE__ */ React74.createElement("div", {
        "data-stid": "property-listing-results"
    }, listings.slice(0, INITIAL_LOAD_THRESHOLD).map(function(listing, index) {
        var _inputs_shoppingContext;
        return /* @__PURE__ */ React74.createElement(Listing, {
            data: listing,
            index: index,
            isMultiItem: Boolean(inputs === null || inputs === void 0 ? void 0 : (_inputs_shoppingContext = inputs.shoppingContext) === null || _inputs_shoppingContext === void 0 ? void 0 : _inputs_shoppingContext.multiItem),
            criteria: variables.criteria,
            key: "property-listing-".concat(index),
            isSRPListing: true,
            openDatePicker: openDatePicker,
            onClickCallback: onClickCallback,
            onHoverChanged: onHoverCallback
        });
    }), /* @__PURE__ */ React74.createElement(LazyLoad, {
        offset: LAZY_LOAD_OFFSET
    }, /* @__PURE__ */ React74.createElement(React74.Fragment, null, listings.slice(INITIAL_LOAD_THRESHOLD, listings.length).map(function(listing, index) {
        var _inputs_shoppingContext;
        return /* @__PURE__ */ React74.createElement(Listing, {
            data: listing,
            index: index,
            isMultiItem: Boolean(inputs === null || inputs === void 0 ? void 0 : (_inputs_shoppingContext = inputs.shoppingContext) === null || _inputs_shoppingContext === void 0 ? void 0 : _inputs_shoppingContext.multiItem),
            criteria: variables.criteria,
            key: "property-listing-".concat(index),
            isSRPListing: true,
            openDatePicker: openDatePicker,
            onClickCallback: onClickCallback,
            onHoverChanged: onHoverCallback
        });
    })))), /* @__PURE__ */ React74.createElement(UitkSpacing24, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React74.createElement("div", null, shouldDisplayShowMoreButton && hasNextSubset && /* @__PURE__ */ React74.createElement(React74.Fragment, null, /* @__PURE__ */ React74.createElement(UitkLayoutFlex22, {
        justifyContent: "center",
        tag: "section"
    }, /* @__PURE__ */ React74.createElement(UitkSecondaryButton4, {
        "aria-label": (_showMoreTriggerData_accessibility = showMoreTriggerData === null || showMoreTriggerData === void 0 ? void 0 : showMoreTriggerData.accessibility) !== null && _showMoreTriggerData_accessibility !== void 0 ? _showMoreTriggerData_accessibility : "",
        disabled: paginationLoading,
        onClick: function() {
            var _pagination_subSets, _pagination_subSets_nextSubSet;
            return handlePaginationWithTracking(pagination === null || pagination === void 0 ? void 0 : (_pagination_subSets = pagination.subSets) === null || _pagination_subSets === void 0 ? void 0 : (_pagination_subSets_nextSubSet = _pagination_subSets.nextSubSet) === null || _pagination_subSets_nextSubSet === void 0 ? void 0 : _pagination_subSets_nextSubSet.startingIndex);
        }
    }, showMoreTriggerData === null || showMoreTriggerData === void 0 ? void 0 : showMoreTriggerData.primary)), !propertySearchListingsPwa && /* @__PURE__ */ React74.createElement(UitkPageLoader, {
        visible: paginationLoading
    })), shouldDisplayPaginationArrows && /* @__PURE__ */ React74.createElement(PropertyListingPagination, {
        handlePagination: handlePagination,
        isLoading: paginationLoading || isInitialLoad,
        pagination: pagination
    }))))), /* @__PURE__ */ React74.createElement(LodgingCompareSheet, null));
};
PropertyListing.displayName = "PropertyListing";
// src/components/property-listing-header-messages/property-listing-header-messages.tsx
import React77 from "react";
import { gql as gql67, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// ../internal/src/components/lodging-more-info-trigger/lodging-more-info-trigger.tsx
import React75 from "react";
import { gql as gql65 } from "@apollo/client";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge as ViewLarge5, Viewport as Viewport10, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";
import { UitkIcon as UitkIcon16, UitkIconSize as UitkIconSize11 } from "uitk-react-icons";
import { UitkLayoutPosition as UitkLayoutPosition7 } from "uitk-react-layout-position";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger2 } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing25 } from "uitk-react-spacing";
import { UitkText as UitkText20 } from "uitk-react-text";
var fragment60 = gql65(_templateObject64());
var LodgingMoreInfoTrigger = function(param) {
    var data = param.data, _param_fontWeight = param.fontWeight, fontWeight = _param_fontWeight === void 0 ? "bold" : _param_fontWeight, fontSize = param.fontSize;
    var _data_action, _data_action1, _data_action2, _data_action3;
    var clickTracker = useClickTracker26();
    if (!data.action || ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.resource.__typename) !== "HttpURI") {
        return null;
    }
    var path = data.action.useRelativePath ? (_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : _data_action1.resource.relativePath : data.action.resource.value;
    var triggerAnalytics = {
        id: ((_data_action2 = data.action) === null || _data_action2 === void 0 ? void 0 : _data_action2.analytics.referrerId) || "",
        description: ((_data_action3 = data.action) === null || _data_action3 === void 0 ? void 0 : _data_action3.analytics.linkName) || "",
        callback: function(id, desc) {
            return clickTracker(id, desc);
        }
    };
    return /* @__PURE__ */ React75.createElement(Viewport10, null, /* @__PURE__ */ React75.createElement(ViewSmall8, null, /* @__PURE__ */ React75.createElement(UitkLayoutPosition7, {
        type: "relative",
        position: {
            bottom: "one",
            left: "center"
        },
        cloneElement: true
    }, /* @__PURE__ */ React75.createElement(UitkMoreInfoTrigger2, {
        size: "small",
        analytics: triggerAnalytics
    }, /* @__PURE__ */ React75.createElement("a", {
        href: path,
        target: "_blank",
        rel: "noopener"
    }, /* @__PURE__ */ React75.createElement(UitkText20, {
        size: fontSize,
        weight: fontWeight
    }, data.text, data.action.accessibility && /* @__PURE__ */ React75.createElement("span", {
        className: "is-visually-hidden"
    }, data.action.accessibility), data.icon && /* @__PURE__ */ React75.createElement(UitkSpacing25, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React75.createElement(UitkIcon16, {
        id: data.icon.id || "info_outline",
        name: data.icon.id || "info_outline",
        description: data.icon.description || "",
        title: data.icon.title || "",
        "data-stid": "uitk-icon",
        size: UitkIconSize11.SMALL
    }))))))), /* @__PURE__ */ React75.createElement(ViewLarge5, null, /* @__PURE__ */ React75.createElement(UitkMoreInfoTrigger2, {
        size: "small",
        analytics: triggerAnalytics
    }, /* @__PURE__ */ React75.createElement("a", {
        href: path,
        target: "_blank",
        rel: "noopener"
    }, /* @__PURE__ */ React75.createElement(UitkText20, {
        size: fontSize,
        weight: fontWeight
    }, data.text, data.action.accessibility && /* @__PURE__ */ React75.createElement("span", {
        className: "is-visually-hidden"
    }, data.action.accessibility), data.icon && /* @__PURE__ */ React75.createElement(UitkSpacing25, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React75.createElement(UitkIcon16, {
        id: data.icon.id || "info_outline",
        name: data.icon.id || "info_outline",
        description: data.icon.description || "",
        title: data.icon.title || "",
        "data-stid": "uitk-icon",
        size: UitkIconSize11.SMALL
    })))))));
};
LodgingMoreInfoTrigger.fragment = fragment60;
LodgingMoreInfoTrigger.displayName = "LodgingMoreInfoTrigger";
// src/components/property-listing-header-messages/__private/__fragments/plain-header-message.tsx
import React76 from "react";
import { gql as gql66 } from "@apollo/client";
import { ViewLarge as ViewLarge6, Viewport as Viewport11, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing26 } from "uitk-react-spacing";
import { UitkText as UitkText21 } from "uitk-react-text";
var fragment61 = gql66(_templateObject65());
var PlainHeaderMessage = function(param) {
    var data = param.data, _param_fontWeight = param.fontWeight, fontWeight = _param_fontWeight === void 0 ? "medium" : _param_fontWeight, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? 200 : _param_fontSize;
    return /* @__PURE__ */ React76.createElement(Viewport11, null, /* @__PURE__ */ React76.createElement(ViewSmall9, null, /* @__PURE__ */ React76.createElement(UitkSpacing26, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React76.createElement(UitkText21, {
        align: "center",
        size: fontSize,
        weight: fontWeight,
        "data-stid": "results-header-message"
    }, data.text))), /* @__PURE__ */ React76.createElement(ViewLarge6, null, /* @__PURE__ */ React76.createElement(UitkSpacing26, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React76.createElement(UitkText21, {
        align: "left",
        size: fontSize,
        weight: fontWeight,
        "data-stid": "results-header-message"
    }, data.text))));
};
PlainHeaderMessage.fragment = fragment61;
PlainHeaderMessage.displayName = "EGDSPlainText";
// src/components/property-listing-header-messages/property-listing-header-messages.tsx
var __PropertyListingHeaderMessagesQuery = gql67(_templateObject66(), PlainHeaderMessage.fragment, LodgingMoreInfoTrigger.fragment);
var HeaderMessages = function(param) {
    var messages = param.messages, fontWeight = param.fontWeight, fontSize = param.fontSize;
    return /* @__PURE__ */ React77.createElement(React77.Fragment, null, messages.map(function(message, index) {
        switch(message.__typename){
            case "EGDSPlainText":
                return /* @__PURE__ */ React77.createElement(PlainHeaderMessage, {
                    data: message,
                    key: "header-message-".concat(index),
                    fontWeight: fontWeight,
                    fontSize: fontSize
                });
            case "EGDSStandardLink":
                return /* @__PURE__ */ React77.createElement(LodgingMoreInfoTrigger, {
                    data: message,
                    key: "header-message-".concat(index),
                    fontWeight: fontWeight,
                    fontSize: fontSize
                });
            default:
                return null;
        }
    }));
};
var PropertyListingHeaderMessages = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, messages = props.messages, fontWeight = props.fontWeight, fontSize = props.fontSize;
    var context = useBexApi2().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs || {}), {
        context: context
    });
    var _useQuery2 = useQuery2(__PropertyListingHeaderMessagesQuery, {
        variables: variables,
        ssr: !skipSsr,
        skip: Boolean(messages)
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (messages) {
        return /* @__PURE__ */ React77.createElement(HeaderMessages, {
            messages: messages,
            fontWeight: fontWeight,
            fontSize: fontSize
        });
    }
    if (loading || error || !data) {
        return null;
    }
    var propertySearch = data.propertySearch;
    var summary = propertySearch.summary;
    return /* @__PURE__ */ React77.createElement(HeaderMessages, {
        messages: summary.resultMessages,
        fontWeight: fontWeight,
        fontSize: fontSize
    });
};
PropertyListingHeaderMessages.displayName = "PropertyListingHeaderMessages";
export { PropertyListing, PropertyListingExpandoCard, PropertyListingHeaderMessages, PropertyListingOverfiltered, PropertyListingSoldOut, PropertyListingStandardMessagingCard }; // istanbul ignore next -- @preserve
//# sourceMappingURL=index.js.map